export default {
    "en": {
        "about": {
            "weStriveToRevolutionize": "We strive to revolutionize the way you compete in combat sports",
            "smoothcompIsATournamentSoftware": "Smoothcomp is a tournament software hosted in the cloud that helps you to organize registrations, brackets, clubs, matches, coaches and athletes. The whole event.",
            "ourTeamHasOver": "Our team have experience in arranging big tournaments since the year 2000 and we have been competing ourselves on a high international level, so you could say we've seen it all. We know how much work is involved in organizing a great tournament. After looking for a good solution but never finding one ourselfs, we decided to build our own platform. <strong>Smoothcomp was born.</strong> We are now on a fantastic journey to help other organizers, athletes and coaches all over the world to a better tournament experience.",
            "planningToStartUsing": "Planning to start using Smoothcomp for your tournament? Great! We'd be happy to help you out.",
            "businessInquiries": "Business inquiries",
            "seeOurFeatures": "See our features.",
            "salesAndSupport": "Sales and support",
            "carnebornBelts": "Black Belt in BJJ<br /> Black Belt in Sport Ju-Jutsu",
            "martinBelts": "Black Belt in BJJ",
            "martinVarghult": "Martin has been working with web design since the late 90's and founded the web agency Pixelstore in 2005. He trains BJJ in Stenungsunds Kampsportsakademi under fellow Smoothcomp sensei Martin Janson. Together they developed the embryo for Smoothcomp while hosting the tournament Swedish Open BJJ. Martin loves design and graphical user interfaces. He follows Dieter Ram's ten principles for good design and the motto \"good design is as little design as possible\".",
            "ricardCarneborn": "Ricard has trained martial arts since 1986 and competed for 10 years on elite level. He is head instructor for his academy Nacka Dojo, CEO of Ctrl Sports and co-founder of Smoothcomp. He is the organizer of some of the biggest tournaments in Scandinavia called Nordic Open - tournaments for both BJJ and JJIF Fighting established in 2000. He loves his work and the motto: \"Working hard for something we do not care about is called stress - working hard for something we love is called passion\".",
            "martinJanson": "Martin has been involved in martial arts since 1996, fighting ”light MMA” or ”Shootfighting” in the early -00´s. Since 2005 he has dedicated himself to grappling and BJJ. He runs a BJJ academy in his hometown Stenungsund. The academy started up organizing a small tournament back in 2005 that over time became Swedish Open BJJ - one of Northern Europe's largest BJJ tournaments. Martin loves great organization as much as he dislikes unnecessary work; ”everything should run smooth”.",
            "developmentAndDesign": "Development and design",
            "company": "Company",
            "address": "Address",
            "tradeRegister": "Trade register",
            "supportInformation": "Support information",
            "instantUpdates": "Instant Updates.",
            "instantUpdatesSubtitle": "Get notified on matches, events, and the athletes you follow.",
            "freeToDownload": "Free to Download.",
            "freeToDownloadSubtitle": "Optional one-time fee for Pro Features.",
            "lockScreenCountdown": "Lock Screen Countdown.",
            "lockScreenCountdownSubtitle": "Glance at your screen to see your next matches.",
            "builtForAction": "Built for Action.",
            "builtForActionSubtitle": "Get the full experience by using the app.",
            "liveCountdown": "Live Countdown",
            "liveCountdownSubtitle": "Peace of mind in the palm of your hand.",
            "registerInSeconds": "Register in Seconds",
            "registerInSecondsSubtitle": "Join Millions of Athletes in the World’s Greatest Events.",
            "stayInTheLoop": "Stay in the Loop",
            "stayInTheLoopSubtitle": "Get Instant Updates on Matches, Events, and the Athletes You Follow.",
            "identifyYourself": "Identify Yourself",
            "identifyYourselfSubtitle": "Tickets, Memberships and Smoothcomp ID.",
            "knowYourCompetition": "Know your Competition",
            "knowYourCompetitionSubtitle": "Stay on Top of Brackets and Schedules for Every Event.",
            "followFriendsAndFamily": "Follow Friends & Family",
            "followFriendsAndFamilySubtitle": "Join the Community and Stay Connected with the People You Like.",
            "empoweringTheWorld": "Empowering the world's greatest tournaments and athletes",
            "smoothcompFoundedIn2015": "Smoothcomp was founded in 2015 with the goal to revolutionize the way events was organized and to help all participants to a better tournament experience with innovative tech.",
            "largestOnlinePlatform": "Today we are the largest online platform in the world. We have organizers all around the world using our software to run combat sports events and a community of millions of athletes and fans using our services on a daily basis.",
            "joinMillionsOfAthletes": "Join millions of athletes around the world with Smoothcomp.",
            "faqTitle": "Questions & Answers",
            "faqIsItFreeTitle": "Is it free?",
            "faqIsItFreeAnswer": "Yes, the app is free to download and use on both Android and iPhone. It provides access to your events, updates on athletes, clubs, and events you follow. For advanced features, you can currently upgrade to the Pro version with a one-time fee.",
            "faqProFeaturesTitle": "What additional features do Pro users get?",
            "faqProFeaturesAnswer": "Pro users gain access to more premium features like<ul><li>Notifications for important updates on events, athletes and more.</li><li>Live Countdown of your upcoming matches on your lock screen.</li><li>Activity Feed with athletes you follow.</li></ul>",
            "faqHowToUpgradeTitle": "How do I upgrade to the Pro?",
            "faqHowToUpgradeAnswer": "You can upgrade to the Pro version directly in the app. Navigate to your profile and then click \"Upgrade to Pro\" and follow the steps to make a one-time payment.",
            "faqAndroidIphoneTitle": "Is the app available for both Android and iPhone?",
            "faqAndroidIphoneAnswer": "Yes! The Smoothcomp app is available for download on both the Google Play Store for Android device and the App Store for iPhone users.",
            "faqNotificationsUpcomingTitle": "Will I get notifications about my upcoming events?",
            "faqNotificationsUpcomingAnswer": "Yes! The app ensures you stay informed about the events you're registered for and any updates from clubs, events, or people you follow. Pro users can also customize notifications for real-time updates like schedule changes, results, or weigh-in status.",
            "faqAccountRequiredTitle": "Do I need a Smoothcomp account to use the app?",
            "faqAccountRequiredAnswer": "Yes, you need a Smoothcomp account to log in and access your personalized event details, updates, and news from the community. If you don't have an account, you can easily create one via the app.",
            "faqRegisterInAppTitle": "Can I register for events directly in the app?",
            "faqRegisterInAppAnswer": "Absolutely! The Smoothcomp app makes it easy to register for events. Browse events in your area, sign up directly in the app, and manage your registrations all in one place.",
            "faqViewBracketsTitle": "Can I view brackets and schedules in the app?",
            "faqViewBracketsAnswer": "Yes, you can browse brackets and schedules for any event. Stay up to date with match times, updates in the schedule, everything in real time.",
            "faqCustomizableNotificationsTitle": "How customisable are the Pro user notifications?",
            "faqCustomizableNotificationsAnswer": "Pro users have extensive control over their notifications. You can for example choose to receive updates on schedule changes, match results, new events published in your area, or when someone you follow wins a match or passes their weigh-in.",
            "faqFindEventsTitle": "How do I find events in my area?",
            "faqFindEventsAnswer": "The app makes it easy to discover events near you. Use the search feature to filter events by location or browse upcoming competitions to find events you're interested in.",
            "faqWhyAppTitle": "Why should I use the app instead of the browser?",
            "faqWhyAppAnswer": "The app provides a more streamlined and optimized experience compared to the browser. It's faster, easier to navigate, and designed specifically for mobile users, ensuring you get the best performance and user experience.",
            "faqBrowserNotificationsTitle": "Can I get notifications if I only use the browser?",
            "faqBrowserNotificationsAnswer": "No, browser users don't receive notifications. With the app, you'll stay informed in real-time with updates sent straight to your phone, including match changes, event announcements, and more.",
            "faqBetterAccessTitle": "Is the app better for accessing events and schedules?",
            "faqBetterAccessAnswer": "Yes! The app gives you instant access to your events, brackets, and schedules in an easy-to-read format. Plus, you can receive live updates and changes directly on your lock screen if you're a Pro user."
        },
        "payment": {
            "method": {
                "stripe": "Stripe",
                "stripe_ideal": "Stripe - iDEAL",
                "stripe_bancontact": "Stripe - Bancontact",
                "paypal_express": "PayPal Express",
                "migs": "MiGS",
                "custom_payment": "Custom payment",
                "adminpaid": "Payment status changed",
                "systempaid": "System paid",
                "smoothcomp": "Smoothcomp",
                "ngenius": "N-Genius Online",
                "no_payout": "No payout",
                "academy_wallet": "Prepaid academy funds",
                "adcb": "ADCB",
                "paypal_rest": "PayPal",
                "mercadopago": "Mercado Pago",
                "safe2pay": "Safe2Pay"
            },
            "payWithCreditCard": "Pay with credit card",
            "needToChoosePaymentMethod": "You need to choose a payment method",
            "contactOrganizerForPaymentMethod": "Please contact the tournament organizer to use this payment method",
            "paypalCreditCard": "PayPal / Credit Card",
            "errorLoadingStripe": "Error loading Stripe",
            "errorGettingIntent": "Error getting payment intent",
            "errorGettingToken": "Error getting token",
            "errorUpdatingCard": "Error updating card",
            "ppvPurchase": "PPV purchase",
            "ppvRefund": "PPV refund",
            "refill": "Refill",
            "autoRefill": "Auto refill",
            "adjustment": "Adjustment",
            "paymentMethodPlaceholder": "- Payment method -",
            "orderStatusPlaceholder": "- Order status -",
            "enterYourCard": "Enter your credit or debit card",
            "thisCardWillBeAutoCharged": "This card will be automatically charged each month",
            "currentCardEndsWith": "Current card {card} ends with {last}"
        },
        "pricing": {
            "saveWithYearly": "Save up to 30%\\nwith yearly",
            "goBigOrGoLocal": "Go big or go local –– join the world’s\\ngreatest organizers on Smoothcomp.",
            "organizeEvents": "Organize Events with the\\nPower of Smoothcomp",
            "pricing": "Pricing",
            "plans": "Plans",
            "starter": "Starter",
            "basic": "Basic",
            "premium": "Premium",
            "brandedPlatform": "Federation Platform",
            "startRunningYourOwn": "Start running your own events",
            "brandedPlatformWithSub": "Federation platform with Subdomain",
            "membershipsAndRankings": "Memberships & Rankings",
            "perMonth": "/mo",
            "perYear": "/yr",
            "startingFee": "12.5 starting fee",
            "eventPricing": "Event Pricing",
            "oneCreditOneAthlete": "1 Credit = 1 Athlete",
            "payAsYouGo": "Pay as you go",
            "perCredit": "/credit",
            "buyOneThousandCredits": "Buy 1 000 credits",
            "buyFiveThousandCredits": "Buy 5 000 credits",
            "beforeTheEvent": "Before the event",
            "publishEvents": "Publish Events",
            "manageEntries": "Manage Entries",
            "handleRegAndReq": "Handle registrations and requirements for participation.",
            "scheduling": "Scheduling",
            "dragAndDropScheduling": "Drag and drop scheduling with real time estimations.",
            "bracketSystem": "Bracket System",
            "includesSingleElimination": "Includes Single- and Double Eliminations, Round Robin, 3 players with comeback, Multistage, Voting with judges score and much more.",
            "payments": "Payments",
            "paymentsThrough": "Payments through Stripe, Paypal, Authorize.net, Safe 2 Pay, Paystack and more.",
            "discountsAndCoupons": "Discounts & Coupons",
            "refunds": "Refunds",
            "lateAndEarlyFees": "Late & Early Fees",
            "smsAndEmailCommunication": "SMS & Email Communication",
            "exportOfRegistrationsTo": "Export of registrations to Mailchimp and similar",
            "appForAthletes": "App for Athletes",
            "theSmoothcompAppProvides": "The Smoothcomp App provides instant updates on upcoming matches, schedule changes, event recommendations and more for millions of athletes.",
            "scorekeeping": "Scorekeeping",
            "liveScorekeepingUsing": "Live digital scorekeeping using tablets or laptops. Seamlessly connected to the bracket system. Optionally connect to a TV for large display.",
            "realTimeBracketsAnd": "Real-time Brackets & Schedules",
            "athletesGetsLiveUpdates": "Athletes gets live updates about their next matches in the app and on your on-site displays.",
            "livestreamWithScoreboardOverlays": "Livestream with Scoreboard Overlays",
            "streamYourEventsWith": "Stream your events with built-in graphical overlays, connected automatically to the digital scoreboard.",
            "sellYourStreamingAs": "Sell your streaming as PPV",
            "getYourOwnStreamingPlatform": "Get your own streaming platform on Smoothcomp and sell streaming packages as pay-per-view.",
            "results": "Results",
            "publicResultsPage": "Public results page after the event.",
            "duringTheEvent": "During the event",
            "afterTheEvent": "After the event",
            "management": "Management",
            "nameSmoothcompCom": "Get name.smoothcomp.com as your landing page.",
            "exclusiveEventListing": "Exclusive Event Listing on Subdomain",
            "makeYourEventsExclusive": "Make your events exclusive on your subdomain, and require active memberships for registration.",
            "affiliateOrganizers": "Affiliate Organizers",
            "growYourBusiness": "Grow your business by letting affiliate organizers run events under your umbrella.",
            "academyMemberships": "Academy Memberships",
            "chargeAcademiesAYearly": "Charge academies a yearly fee for being a part of your organization. Control who gets to participate at your events.",
            "eventTemplates": "Event Templates",
            "makeACompetitionTemplate": "Make a competition template for your federation to make creating events simple also for affiliate organizers.",
            "contentManagementSystem": "Content Management System (CMS)",
            "buildYourFederationPage": "Build your federation page as you want with multiple pages/menus or add a news page.",
            "athleteMemberships": "Athlete Memberships",
            "addAnotherLayerOfMembership": "Add another layer of membership for individual users, you can have one fee for the academy and one for the individual.",
            "customMembershipPlans": "Custom Membership Plans",
            "createDifferentLevelsOf": "Create different levels of memberships, for example Supporter and Premium membership.",
            "askForAdditionalInfo": "Ask for additional information about previous merits, belts or other achievements. Have your members upload documents for you to check before approving their membership.",
            "monthly": "Monthly",
            "yearly": "Yearly",
            "billedMonthly": "Billed monthly",
            "billedYearly": "Billed yearly",
            "revshareWithNoUpfront": "Revshare with\\nno upfront fees",
            "customMetaDataForMembers": "Custom Meta Data for Member’s Database",
            "goBigOrGoLocalReach": "Go big or go local – Reach Smoothcomp’s community with millions of athletes.",
            "onlinePayments": "Online Payments",
            "worksWithAnyQrAnd": "Works with any QR and barcode reader. Instant weigh-ins with our supported smart-scales.",
            "checkInAndWeighin": "Check-in and Weigh-in",
            "resultsAndPodium": "Results and Podium",
            "statisticsAndData": "Statistics and Data Export",
            "eventTopList": "Event Top List",
            "createTopListsForBest": "Create top lists for best academies, nations and fastest submissions etc.",
            "rankingLists": "Ranking Lists",
            "scaleYourOrganizationWith": "Scale your organization with automated ranking lists. Aggregate data from multiple events to track the best athletes, academies, and nations in real-time.",
            "oneTimeFee": "One time fee",
            "custom": "Custom",
            "priceInCurrency": "Price in {currency}",
            "unableToGetPlans": "Unable to get federation plans. Please try again.",
            "sixMonths": "6 months"
        },
        "messages": {
            "daysLeft": "{count} days left",
            "entryContainsRestrictionsOn": "This entry contains restrictions on {restrictions} <br>Make sure your profile is set up correctly to gain access to your desired division.",
            "eventRegistrationsTermsOfService": "By registering to {event} you agree to their <a href=\"#!\">Terms of Service</a>.",
            "organizersCanRunTheirEventsUsingSmoothcomp": "Organizers can run their events using Smoothcomp. <a href=\"{route}\">Learn more &amp; get started</a>",
            "registerInOneOfEntries": "Register in one of these entries first:<br> {entries}",
            "registrationClosed": "Registration period is not open at this time",
            "theseRegistrationsAreCurrently": "These registrations are currently set as \"unknown\" do you want to set them as \"no-show\"? If they are already seeded in a bracket they will be marked as WO (Walk Over) and automatically lose all their matches.",
            "validBetween": "Valid between {start} and {end}",
            "willingToChangeDivisions": "Willing to change divisions?",
            "youAreAlreadyRegisteredToGroup": "You are already registered to this group.",
            "youAreAlreadyRegisteredToEntry": "You have reached the maximum number of registrations for this entry.",
            "youAreNotAffiliationManager": "You are not affiliation manager for any club on {name}",
            "youAreNotCoachManager": "You are not coach manager for any club on {name}",
            "youAreNotCoachManagerFederation": "You are not coach manager for any Federation on {name}",
            "youDoNotMeetCriteriaForEntry": "You do not meet the criteria for this entry",
            "youNeedToSelectClub": "You need to select a club",
            "capacityReached": "The event has reached full capacity",
            "notRegisterInOneOfEntries": "You are not able to register in this entry since you already registered for:<br> {entries}",
            "academyReachedMaxRegistrations": "This event allows maximum {num} players per division from the same academy and you can not enter any more registrations for \"{club}\"",
            "youNeedToSelectCompetitionTeam": "You need to select a competition team",
            "isNotAValidValue": "is not a valid value",
            "yourValues": "Your values"
        },
        "skill-label": {
            "belt": "Belt"
        },
        "streaming": {
            "faqTitle": "Questions & Answers",
            "faqSetupStreamQuestion": "How do I set up a stream for my event?",
            "faqSetupStreamIntro": "Setting up is quick and simple:",
            "faqSetupStreamStep1": "<strong>Create your event</strong> on Smoothcomp",
            "faqSetupStreamStep2": "Create the streams to your desired destination from the livestreaming tab",
            "faqSetupStreamStep3": "Create your pricing structure (if you use Smoothcomp TV)",
            "faqSetupStreamStep4": "Scan the QR code from each stream or add the RTMP keys manually to connect",
            "faqSetupStreamStep5": "<strong>Go live</strong> using our smartphone app or use a computer and third party software",
            "faqSetupStreamStep6": "<strong>Get paid with our PPV option</strong> - revenue is automatically processed to your account",
            "faqInternetConnectionQuestion": "What kind of internet connection do I need to livestream my event?",
            "faqInternetConnectionIntro": "For a <strong>stable livestream</strong>, you need a <strong>strong and reliable internet connection</strong>.",
            "faqWeRecommend": "We recommend:",
            "faqInternetConnectionTip1": "✅&nbsp;<strong>Upload speed of at least 10 Mbps</strong> for each mat of HD streaming (higher is better)",
            "faqInternetConnectionTip2": "✅&nbsp;A <strong>wired (Ethernet) connection</strong> instead of WiFi for more stability",
            "faqInternetConnectionTip3": "✅&nbsp;<strong>Testing your connection</strong> before the event to avoid interruptions",
            "faqInternetConnectionOutro": "If your internet is unstable, you may experience <strong>lag or buffering</strong>, so always check your network before going live!",
            "faqWhatIsSmoothcompTvQuestion": "What is Smoothcomp TV, and how does it work?",
            "faqWhatIsSmoothcompTvAnswer": "Smoothcomp TV is our pay-per-view (PPV) streaming platform designed for sports events. It allows event organizers to easily stream and sell access to viewers worldwide. You set the price, and we handle the background tech - making it simple to broadcast your event professionally.",
            "faqWhySmoothcompTvQuestion": "Why should I use Smoothcomp TV and PPV for my event?",
            "faqWhySmoothcompTvAnswer": "Smoothcomp TV has a unique cut & connect technology that automatically cuts each match and connects it to the brackets and the user profiles. The watchpage has advanced search and filtering tools making it super smooth to watch the things you are looking for.",
            "faqWhySmoothcompTvBenefit1": "✅&nbsp;<strong>Built-in payments</strong> - Easily monetize your streams",
            "faqWhySmoothcompTvBenefit2": "✅&nbsp;<strong>Global reach</strong> - Sell access worldwide to our global community",
            "faqWhySmoothcompTvBenefit3": "✅&nbsp;<strong>Easy setup</strong> - No extra software or technical knowledge required",
            "faqWhySmoothcompTvBenefit4": "✅&nbsp;<strong>New revenue stream</strong> - Get a new revenue stream and grow your events with us",
            "faqBetterThanOthersQuestion": "What makes Smoothcomp TV better than other streaming services/platforms?",
            "faqBetterThanOthersAnswer": "Unlike generic streaming platforms, Smoothcomp TV is designed for sports and is tightly integrated in the platform making it the easiest and most profitable way to stream your event. With the unique cut & connect technology and the beautiful watchpage you will never want to offer something else to your customers after using it.",
            "faqBetterThanOthersFeature1": "✂️&nbsp;<strong>Cut & connect technology</strong> - Like magic all matches are available in the search",
            "faqBetterThanOthersFeature2": "👀&nbsp;<strong>Watchpage</strong> - Watch up to 4 streams at the same time",
            "faqBetterThanOthersFeature3": "🎯&nbsp;<strong>Automatic scoreboard</strong> - Displays live match results from Smoothcomp",
            "faqBetterThanOthersFeature4": "💪&nbsp;<strong>Tale of the Tape</strong> - Athlete and matchup details appear <strong>automatically</strong> on screen",
            "faqBetterThanOthersFeature5": "⚡&nbsp;<strong>Integrated event data</strong> - No need for manual overlays, everything updates in real-time",
            "faqBetterThanOthersFeature6": "💰&nbsp;<strong>Automatic payments</strong> - The payments are automatically split at the transaction",
            "faqBetterThanOthersOutro": "These features <strong>enhance the viewer experience</strong> while reducing production workload, making your event look more professional with minimal effort.",
            "faqHowMuchDoesItCostQuestion": "How much does it cost to use Smoothcomp TV?",
            "faqHowMuchDoesItCostAnswer": "Smoothcomp TV operates on a revenue-sharing model. You set the <strong>PPV price</strong> for your event, and a percentage goes to Smoothcomp to cover streaming and payment processing. There are <strong>no upfront fees</strong> - you only pay when you make sales!",
            "faqRevenueShareQuestion": "How does revenue share work?",
            "faqRevenueShareAnswer1": "Revenue share means we split the revenue from sold PPV tickets. You never pay anything upfront. If you sell, you earn. If you don't sell, you owe nothing.",
            "faqRevenueShareAnswer2": "You start by creating a PayPal account (if you don't already have one). When a viewer purchases a PPV ticket, your share of the sale will be deposited directly into your PayPal account.",
            "faqRevenueShareAnswer3": "<strong>Can't use PayPal?</strong> If PayPal isn't available in your country (or you're unable to use it), other payment gateways may be possible. Contact us for assistance.",
            "faqMultipleDevicesQuestion": "Can I stream to multiple devices and locations?",
            "faqMultipleDevicesAnswer": "Yes! Your audience can watch on <strong> mobile, tablet, or desktop</strong> with a stable internet connection. They can access the stream from anywhere in the world, ensuring maximum reach for your event.",
            "faqEquipmentNeededQuestion": "What equipment do I need for a professional livestream?",
            "faqEquipmentNeededIntro": "To produce a <strong>high-quality broadcast</strong>, you'll need:",
            "faqEquipmentNeededItem1": "🎥&nbsp;<strong>Camera(s)</strong> - A basic setup can start with a single HD camera, but multiple angles enhance the experience",
            "faqEquipmentNeededItem2": "🎤&nbsp;<strong>Microphone</strong> - Good audio is crucial! Use an external mic for clear commentary and crowd noise",
            "faqEquipmentNeededItem3": "💻&nbsp;<strong>Streaming software or encoder</strong> - Smoothcomp TV supports RTMP(S) and SRT streams from <strong>OBS, vMix, Ecamm, and more</strong>",
            "faqEquipmentNeededItem4": "🔌&nbsp;<strong>Stable power & internet</strong> - Backup power and a wired internet connection ensure uninterrupted streaming",
            "faqEquipmentNeededOutro": "Smoothcomp TV works with both <strong>basic and professional setups</strong>, so you can scale your production to match your needs.",
            "faqMultipleCamerasQuestion": "Can I stream my event with multiple cameras and professional production?",
            "faqMultipleCamerasIntro": "Absolutely! Smoothcomp TV supports <strong>multi-camera productions</strong>, allowing you to switch between different angles for a more dynamic broadcast. You can use:",
            "faqMultipleCamerasOption1": "🎥&nbsp;<strong>Hardware switchers</strong> (like ATEM Mini) for seamless transitions",
            "faqMultipleCamerasOption2": "🎥&nbsp;<strong>Software solutions</strong> (like OBS or vMix) to manage multiple inputs",
            "faqMultipleCamerasOption3": "🎥&nbsp;<strong>Wireless camera feeds</strong> for flexibility in coverage",
            "faqMultipleCamerasOutro": "Whether you're running a <strong>simple setup or a full-scale production</strong>, Smoothcomp TV can handle it.",
            "faqHowToGetStartedQuestion": "How can I get started?",
            "faqHowToGetStartedAnswer": "Please contact us on <a href=\"mailto:support@smoothcomp.com\">support@smoothcomp.com</a> in order to get started!"
        },
        "support": {
            "pleaseContactYourEventOrganizer": "Please contact your event organizer regarding questions about the event.",
            "knowledgeBase": "Knowledge base",
            "contactYourOrganizer": "Contact your organizer",
            "planningToStartUsingSmoothcomp": "Planning to start using Smoothcomp for your tournament? Great! We'd be happy to help you out. Please <a href=\"javascript{void}(0)\" onclick=\"openChat()\">chat with support</a> and we'll gladly help you out.",
            "createOrganizerAccount": "Create organizer account",
            "viewAgreements": "View agreements",
            "submitTicket": "Submit ticket",
            "technicalSupport": "Technical support",
            "ifYouHaveQuestionsAboutTheSmoothcompSystem": "If you have questions about the Smoothcomp system, please <a href=\"javascript{void}(0)\" onclick=\"openChat()\" >chat with support</a> and let us help you out.",
            "press": "Press and media",
            "download": "High resolution downloads",
            "downloadlogo": "Download Smoothcomp logo",
            "downloadpress": "Download press images",
            "downloadsmoothstreamer": "Download Smoothstreamer logo",
            "agreements": "Agreements",
            "presskitdownload": "Logo & Press Kit Download",
            "chatWithSupport": "Chat with support"
        },
        "validation": {
            "accepted": "The {attribute} must be accepted.",
            "active_url": "The {attribute} is not a valid URL.",
            "after": "The {attribute} must be a date after {date}.",
            "alpha": "The {attribute} may only contain letters.",
            "alpha_dash": "The {attribute} may only contain letters, numbers, and dashes.",
            "alpha_num": "The {attribute} may only contain letters and numbers.",
            "array": "The {attribute} must be an array.",
            "before": "The {attribute} must be a date before {date}.",
            "between": {
                "numeric": "The {attribute} must be between {min} and {max}.",
                "file": "The {attribute} must be between {min} and {max} kilobytes.",
                "string": "The {attribute} must be between {min} and {max} characters.",
                "array": "The {attribute} must have between {min} and {max} items."
            },
            "boolean": "The {attribute} field must be true or false.",
            "confirmed": "The {attribute} confirmation does not match.",
            "date": "The {attribute} is not a valid date.",
            "date_format": "The {attribute} does not match the format {format}.",
            "different": "The {attribute} and {other} must be different.",
            "digits": "The {attribute} must be {digits} digits.",
            "digits_between": "The {attribute} must be between {min} and {max} digits.",
            "email": "The {attribute} must be a valid email address.",
            "filled": "The {attribute} field is required.",
            "exists": "The selected {attribute} is invalid.",
            "image": "The {attribute} must be an image.",
            "in": "The selected {attribute} is invalid.",
            "integer": "The {attribute} must be an integer.",
            "ip": "The {attribute} must be a valid IP address.",
            "max": {
                "numeric": "The {attribute} may not be greater than {max}.",
                "file": "The {attribute} may not be greater than {max} kilobytes.",
                "string": "The {attribute} may not be greater than {max} characters.",
                "array": "The {attribute} may not have more than {max} items."
            },
            "mimes": "The {attribute} must be a file of type: {values}.",
            "min": {
                "numeric": "The {attribute} must be at least {min}.",
                "file": "The {attribute} must be at least {min} kilobytes.",
                "string": "The {attribute} must be at least {min} characters.",
                "array": "The {attribute} must have at least {min} items."
            },
            "not_in": "The selected {attribute} is invalid.",
            "numeric": "The {attribute} must be a number.",
            "phone": "The {attribute} field contains an invalid number.",
            "regex": "The {attribute} format is invalid.",
            "required": "The {attribute} field is required.",
            "required_if": "The {attribute} field is required when {other} is {value}.",
            "required_with": "The {attribute} field is required when {values} is present.",
            "required_with_all": "The {attribute} field is required when {values} is present.",
            "required_without": "The {attribute} field is required when {values} is not present.",
            "required_without_all": "The {attribute} field is required when none of {values} are present.",
            "same": "The {attribute} and {other} must match.",
            "size": {
                "numeric": "The {attribute} must be {size}.",
                "file": "The {attribute} must be {size} kilobytes.",
                "string": "The {attribute} must be {size} characters.",
                "array": "The {attribute} must contain {size} items."
            },
            "string": "The {attribute} must be a string.",
            "timezone": "The {attribute} must be a valid zone.",
            "unique": "The {attribute} has already been taken.",
            "url": "The {attribute} format is invalid.",
            "custom": {
                "attribute-name": {
                    "rule-name": "custom-message"
                }
            },
            "after_or_equal": "after or equal",
            "before_or_equal": "before or equal",
            "dimensions": "dimensions",
            "distinct": "distinct",
            "file": "file",
            "in_array": "in array",
            "ipv4": "ipv4",
            "ipv6": "ipv6",
            "json": "json",
            "mimetypes": "mimetypes",
            "not_regex": "not_regex",
            "present": "present",
            "required_unless": "required unless",
            "uploaded": "uploaded",
            "attributes": {
                "price_admin": "Admin price"
            },
            "cpf": "The CPF must be 11 digits, only numbers."
        },
        "skk": {
            "type": "Type",
            "CreateApplicationForm": "Create application form",
            "testtype": "Test type",
            "class": "Class",
            "category": "Category",
            "species": "Species",
            "date_from": "Date from",
            "date_to": "Date to",
            "last_registration_date": "Last registration date",
            "referee": "Referee",
            "price_admin": "Price admin",
            "price_referee": "Price referee",
            "description": "Description",
            "descriptionPlaceholder": "Description",
            "MenuAdminRegistrations": "Registrations",
            "MenuAdminEvents": "Admin Events",
            "menuEvents": "Events",
            "manual": "Manual",
            "online": "Online",
            "menuReferees": "Referees",
            "events": "Events",
            "event": "Event",
            "referees": "Referees",
            "dog_is_too_young": "Your dog is not old enough. Minimum age to attend this test is 9 months",
            "hunddata": "Hunddata",
            "hunddata_results": "Results in Hunddata",
            "results_are_sent": "Results are sent. You can review the data sent below",
            "results_are_not_sent": "Results are not yet sent. Review the form below and then send",
            "create_results": "Create results",
            "created": "Created!",
            "not_created": "Not yet created",
            "test_type": "Test type",
            "start_date": "Start date",
            "end_date": "End date",
            "club_id": "Club-ID",
            "city": "City",
            "event_skk_id": "SKK Event ID",
            "test_date": "Test date",
            "user": "User",
            "day": "Day",
            "breed_code": "Breed code",
            "registration_number": "Registration number",
            "prize1": "Prize1",
            "prize2": "Prize2",
            "dog_deceased": "Dog deceased",
            "register": "register",
            "search": "Search",
            "unplanned": "Unplanned",
            "unable_to_edit_registration": "You are not able to edit this registration since the data is already sent to Hunddata",
            "club_xref_id": "SKK Club ID",
            "event_link": "Event link",
            "event_registrations_count": "Total registered",
            "report": "Report",
            "bark_frequency": "Bark Frequency",
            "send_result": "Send result",
            "terrain_type_deciduous_forest": "Deciduous forest",
            "terrain_type_dense": "Dense",
            "terrain_type_swamp": "Swamp",
            "terrain_type_open_field": "Open field",
            "terrain_type_hilly": "Hilly",
            "track_laid_out": "Track laid out",
            "round.comment": "Comment",
            "federation": "Federation",
            "academy": "Academy",
            "r_cacit": "R-Cacit",
            "d_cert": "D-cert",
            "no_d_cert": "No D-cert",
            "cacit": "Cacit",
            "handler": "Handler",
            "k": "K",
            "fgs-ekl-l": "skk.fgs-ekl-i",
            "good_b": "Good",
            "snow-and-bareground": "Snow & Bare ground",
            "federation_members": "Federation members",
            "no_award": "No reward",
            "no_placement_e": "Unplaced",
            "not_sufficient": "Not Sufficient",
            "minutes": "Minutes",
            "metres": "Metres",
            "num_eight": "8",
            "num_four": "4",
            "num_zero": "0",
            "previous_dog_shows": "Previous Dog Shows"
        },
        "sports": {
            "jiu_jitsu": "Jiu Jitsu",
            "judo": "Judo",
            "karate": "Karate",
            "thaiboxing": "Thaiboxing",
            "wrestling": "Wrestling",
            "jjif_ju_jutsu": "JJIF Ju-Jutsu",
            "taekwondo": "Taekwondo",
            "boxing": "Boxing",
            "mma": "MMA",
            "kickboxing": "Kickboxing",
            "sambo": "Sambo",
            "wushu_sanda": "Wushu Sanda",
            "fencing": "Fencing",
            "sumo": "Sumo",
            "uww_grappling": "UWW Grappling",
            "wrestling___folkstyle": "Wrestling - Folkstyle",
            "wushu_taolo": "Wushu Taolu",
            "allArmedSports": "All Armed Sports",
            "allGrapplingSports": "All Grappling Sports",
            "allstyle": "Allstyle",
            "kudo": "Kudo",
            "shooto": "Shooto",
            "luta_livre": "Luta Livre",
            "wrestling_submission": "Submission Wrestling",
            "adcc": "ADCC",
            "capoeira": "Capoeira",
            "wushu": "Wushu",
            "muay_thai": "Muay Thai",
            "savate": "Savate",
            "glima": "Glima",
            "hema": "Hema",
            "taido": "Taido",
            "kyokushin": "Kyokushin",
            "submission_only": "Submission only",
            "jjif_newaza": "JJIF Newaza",
            "karate_aau": "Karate AAU",
            "karate_kyokushin": "Karate Kyokushin",
            "karate_wkf": "Karate WKF",
            "katapatterns_general": "Kata/Patterns (General)",
            "pillow_fight": "Pillow Fight",
            "universal": "Universal",
            "kickboxing_wako": "Kickboxing WAKO",
            "wushu_taolu_iwuf": "Wushu Taolu IWUF",
            "taekwondo_wt": "Taekwondo WT",
            "jjif_fighting": "JJIF Fighting",
            "taekwondo_itf": "Taekwondo ITF",
            "wushu_taolu_basic": "Wushu Taolu Basic",
            "wushu_taolu": "Wushu Taolu"
        },
        "organizer": {
            "your_credits_are_handled_by_owner": "Your credits are handled by {owner}",
            "current_balance": "Current balance",
            "processing_credits": "{total} processing",
            "credits": "{0} {count} credits|{1} {count} credit|[2,*] {count} credits",
            "participant": "{0} {count} athletes|{1} {count} athlete|[2,*] {count} athletes",
            "buy_more_credits": "Buy more credits",
            "buy_credits": "Buy credits",
            "add_credit_card": "Add credit card",
            "auto_refill": "Auto refill",
            "auto_refill_description": "Auto refill my balance with {credits} credits before it's empty",
            "auto_refill_description_2": "With auto refill you don’t have to worry about your credits running out!",
            "configure": "Configure",
            "billing_notification": "Billing notification",
            "billing_notification_desc": "We'll email you when you reach 5 credits. When you reach 0, new registrations will remain unapproved until you refill your balance.",
            "enable_auto_refill": "Enable auto refill",
            "auto_refill_with": "Before your balance is empty we will auto refill it with",
            "credits_will_be_charged_from": "The credits will be charged from your {card} card ending with {last4}",
            "save_changes": "Save changes",
            "change_credit_card": "Change credit card",
            "save_card": "Save card",
            "credits_warning": "Credit warning",
            "credits_warning_description": "Your Smoothcomp credit balance has only {credits} credits left. If your balance reach 0 new registrations will remain unapproved until you refill your balance.",
            "credits_warning_description_with_link": "Your Smoothcomp credit balance has only {credits} credits left. If your balance reach 0 new registrations will remain unapproved until you <a href=\"{link}\">refill your balance.</a>",
            "billing_info": "Billing info",
            "credit_history": "Credit history",
            "admins_and_staff": "Admins & Staff",
            "competitions_teams": "Competition teams",
            "organization": "Organization",
            "currency": "Currency",
            "users_with_permissions": "Users with permissions for your organization",
            "sc_settings": "Smoothcomp admin settings",
            "stay22_description": "Turn on to allow the organizer to choose if they want to display Stay22 or not",
            "payment_settings": {
                "title": "Payment settings",
                "merchant_id": "Merchant Id",
                "set_default": "Set default",
                "label": "Label",
                "publishable_key": "Publishable key",
                "secret_key": "Secret key",
                "american_express_checkout": "This will require users to use the American Express Checkout when attempting to use an American Express card.",
                "create_account": "Create a {name} account",
                "ideal_through_stripe": "iDeal through Stripe (Used in Netherlands)",
                "requirements": "Requirements",
                "payment_key": "Payment key",
                "ideal": {
                    "requirements": {
                        "1": "You will need to enable iDeal payment methods on your Stripe account",
                        "2": "You must have a Stripe bank account in one of the following formats: EUR, USD, GBP"
                    }
                },
                "bancontact_through_stripe": "Bancontact through Stripe (Used in Belgium)",
                "bancontact": {
                    "requirements": "You are only able to accept payments in EUR. Organization currency must be in EUR."
                },
                "api_username": "API Username",
                "api_password": "API Password",
                "api_key": "API Key",
                "outlet_reference": "Outlet reference",
                "signature": "Signature",
                "test_mode": "Test mode (Sandbox)",
                "migs": {
                    "access_code": "Access Code",
                    "secure_hash": "Secure Hash"
                },
                "authorizeNet": {
                    "client_key": "Client Key",
                    "transaction_key": "Transaction Key"
                },
                "pagseguro": {
                    "token": "Token"
                },
                "public_key": "Public Key",
                "mercadopago": {
                    "access_token": "Access Token",
                    "client_secret": "Client Secret",
                    "refunds": "The integration with Mercado pago does not support refunds through Smoothcomp. All refunds must be handled manually from the dashboard of Mercado Pago.",
                    "currency": "Mercado Pago only allows payments in the local currency. That is, the merchant account created in Brasil only accepts payments in Brazilian real (BRL) and from clients that have an account in the same country. Make sure the currency of your Smoothcomp organizer account reflects the one of your Mercado Pago account's."
                },
                "client_id": "Client ID",
                "secret": "Secret",
                "username": "Username",
                "hook_key": "Hook key",
                "stripe": {
                    "secret_restricted_key": "Secret or restricted key"
                },
                "paypalOutdated": "Your PayPal integration is outdated and needs to be updated. It will just take a minute or two.",
                "signedUpForPartner": "You are signed up for PayPal Partner integration",
                "updatePaypal": "Update PayPal",
                "primaryEmailPaypal": "Primary email in PayPal: {email}",
                "confirmEmailPaypal": "You need to confirm your email with PayPal",
                "paypalNotWorking": "You are currently not able to receive payments to your PayPal account. Please check your account at your <a href=\"https://paypal.com\">PayPal dashboard</a> in case you have missing steps.",
                "refetchPaypal": "In case you have changed anything and it does not reflect on our page, try to                             refetch the latest information from PayPal with the button below.",
                "updateOnboardingStatus": "Update onboarding status",
                "useFor": "Use for:",
                "ppvPurchases": "SCTV purchases",
                "onlyForEvent": "Can only be used for event registrations"
            },
            "title": "Title",
            "description": "Description",
            "auto_approve_registration": "Auto approve registration",
            "create_new_event": "Create new event",
            "new_event": {
                "hello": "Hello",
                "name_of_event": "What's the name of your event?",
                "run_under_federation": "Run this event under a federation",
                "run_under_federation_question": "Do you want to run this event under a federation?",
                "where_will_happen": "Where will the fights happen?",
                "when_will_happen": "When is your event?",
                "start": "Start",
                "end": "End",
                "choose_event_template": "Choose event template",
                "duplicate_previous_event": "Duplicate previous event",
                "choose_from_template": "Choose from {name} template",
                "creating_event": "Creating event",
                "select_city": "Select city",
                "add_this_city": "Add this city"
            },
            "credits_used": "Credits used",
            "billing_information": "Billing information",
            "adjust_credits": "Adjust credits",
            "credits_total": "Credits total",
            "credits_adjustment": "Credits adjustment",
            "coupons": {
                "create_new": "Create new coupon",
                "create": "Create coupon code",
                "edit": "Edit coupon code",
                "save": "Save coupon code",
                "active_coupons": "Active coupons",
                "deactivated_coupons": "Deactivated coupons",
                "valid_for_event": "Valid for event|Valid for events",
                "valid_for_user": "Valid for UserId",
                "code": "Code",
                "validity": "Validity",
                "limit": "Limit",
                "created_by": "Created by",
                "from": "From",
                "to": "To",
                "unlimited": "Unlimited",
                "one_time": "One time",
                "used": "Used",
                "times": "{count} times|{count} time|{count} times",
                "user_ids": "User Ids",
                "user_ids_desc": "Leaving this blank will allow any user to redeem coupon. If [unlimited] option is also checked, these user ids will be allowed to use unlimited amount of times.",
                "user_ids_placeholder": "Separated by comma (1,2,3)",
                "any_event": "Any event",
                "confirm_delete": "Are you sure you want to delete this coupon?",
                "valid_from": "Valid from",
                "valid_to": "Valid until",
                "times_to_be_used": "Times to be used",
                "times_to_be_used_desc": "Unlimited in the amount of individual users. A user can only redeem once.",
                "percent_on_total_order": "% Percent on total order",
                "currency": "In {currency}",
                "all_my_events": "All my events",
                "redeemed_by": "Redeemed by",
                "deleted_at": "This coupon was deleted on {date}",
                "find_coupon_code": "Find coupon code",
                "delete": "Delete coupon"
            },
            "organization_code": "Organization code",
            "leave_federation": "Leave federation",
            "add_user": "Add user",
            "competition_teams": {
                "allow_customers_create_teams": "Allow customers to create their own teams",
                "title": "Competition teams",
                "new": "New competition team",
                "team_name": "Competition team name"
            },
            "total_number_of_events_with_registrations": "Total number of active events with <strong>approved</strong> registrations",
            "wallet": {
                "total_number_of_credits_bought": "Total number of credits bought",
                "total_income_on_credits": "Total income on those credits"
            },
            "select_currency": "Select a currency",
            "messaging_auto_refill_description_2": "With auto refill you don’t have to worry about your funds running out!",
            "balance_after": "Balance after",
            "message_center": {
                "title": "Message center",
                "description": "With our message service you are able to send SMS and e-mails to your competitors. This is done from the event's registrations list. Perfect for sending out promotions or just letting someone know they moved divisions."
            },
            "add_admin": "Add admin",
            "payment_settings_warning": "If you remove all active payment methods, your {count} published events will be unpublished. Do you wish to continue?",
            "addRefundPeriod": "Add refund period",
            "firstTimeDeal": "First-Time Deal",
            "oneTimeFeeHtml": "The one-time fee of <span>12.5€</span> gives you <span>20 credits</span> – worth 25€ ✌️",
            "contactSupportToCreateHtml": "<a href=\"/support\"> Contact support</a> to create an organizer account.",
            "yourNewOrganization": "Your new organization was created!",
            "billingOrganization": "Billing - Organization",
            "editTeam": "Edit team"
        },
        "notifications": {
            "eventsPublishedNearHometown": "Get notifications when events are published near your hometown",
            "newFollower": "Get notified when someone starts following you",
            "editDeadline": "Get notified ~24hrs before deadline to edit your registration",
            "scheduleUpdates": "Get notifications when your schedule updates on an event",
            "deadlineChanged": "Get notified when deadlines are changed, e.g. early bird, registration times etc.",
            "newDivision": "Get notified when a new division is added",
            "publishedBrackets": "Get notified when brackets are published",
            "followAthleteRegisters": "Get notified when someone you follow registers to an event",
            "followAthleteMatchResults": "Get notified when an athlete has finished a match",
            "followAthleteMatchStarted": "Get notified when an athlete starts a match",
            "followAthleteMoved": "Get notified when someone you follow are moved to another group",
            "followAthletePublishedBrackets": "Get notified when brackets are published on an event where you follow someone",
            "followAcademyJoins": "Get notified when an academy you follow joins an affiliation",
            "followAcademyRegisters": "Get notified when someone from an academy you follow registers to an event",
            "followAcademyMatchResults": "Get notified when a match with someone from an academy you follow has ended",
            "followAcademyMatchStarts": "Get notified when a match with someone from an academy you follow starts",
            "followAcademyPublishedBrackets": "Get notified when brackets are published at an event where an academy you follow are competing",
            "followOrganizerPublishedEvent": "Get notified when an organizer you follow publishes a new event",
            "timeSensitiveInfo": "Get notified before deadlines, e.g. early bird, registration times etc.",
            "followAthleteWeighIn": "Get notified when someone you follow passes or fails a weighin"
        },
        "email": {
            "user_was_moved_to_another_group": "You have been moved from <b>{originalGroup}</b> to <b>{targetGroup}</b>. Please check your account for more info.",
            "your_account": "Your account",
            "user_was_added_to_new_division": "You have been added to a new division at {event}. Please check your account for more info"
        },
        "skill-level": {
            "white": "White",
            "grey": "Grey",
            "yellow": "Yellow",
            "orange": "Orange",
            "green": "Green",
            "blue": "Blue",
            "purple": "Purple",
            "brown": "Brown",
            "black": "Black",
            "first_degree_black": "1st degree black",
            "second_degree_black": "2nd degree black",
            "third_degree_black": "3rd degree black",
            "fourth_degree_black": "4th degree black",
            "fifth_degree_black": "5th degree black",
            "sixth_degree_black": "6th degree black",
            "seventh_degree_black": "7th degree black",
            "eighth_degree_black": "8th degree black",
            "ninth_degree_red": "9th degree red",
            "tenth_degree_red": "10th degree red",
            "second_dan_black_nidan": "2nd Dan Black – Nidan",
            "third_dan_black_sandan": "3rd Dan Black – Sandan",
            "fourth_dan_black_yondan": "4th Dan Black – Yondan",
            "fifth_dan_black_godan": "5th Dan Black – Godan",
            "sixth_dan_black_rokudan": "6th Dan Black – Rokudan",
            "seventh_dan_black_shichidan": "7th Dan Black – Shichidan",
            "eighth_dan_black_hachidan": "8th Dan Black – Hachidan",
            "ninth_dan_black_kudan": "9th Dan Black – Kudan",
            "tenth_dan_black_judan": "10th Dan Black – Judan",
            "brown_senior": "Brown Senior",
            "red": "Red",
            "red_black": "Red/Black",
            "red_white": "Red/White",
            "junior_black": "Junior Black",
            "twelve_kyu": "12 kyu",
            "eleven_kyu": "11 kyu",
            "ten_kyu": "10 kyu",
            "nine_kyu": "9 kyu",
            "eight_kyu": "8 kyu",
            "seven_kyu": "7 kyu",
            "six_kyu": "6 kyu",
            "five_kyu": "5 kyu",
            "four_kyu": "4 kyu",
            "three_kyu": "3 kyu",
            "two_kyu": "2 kyu",
            "one_kyu": "1 kyu",
            "two_dan": "2 Dan",
            "three_dan": "3 Dan",
            "four_dan": "4 Dan",
            "five_dan": "5 Dan",
            "six_dan": "6 Dan",
            "seven_dan": "7 Dan",
            "eight_dan": "8 Dan",
            "nine_dan": "9 Dan",
            "ten_dan": "10 Dan",
            "black_second_dan": "Black 2nd dan",
            "black_third_dan": "Black 3rd dan",
            "black_fourth_dan": "Black 4th dan",
            "black_fifth_dan": "Black 5th dan",
            "black_sixth_dan": "Black 6th dan",
            "black_seventh_dan": "Black 7th dan",
            "black_eighth_dan": "Black 8th dan",
            "black_ninth_dan": "Black 9th dan",
            "black_tenth_dan": "Black 10th dan",
            "ninth_degree_black": "9th degree black",
            "tenth_degree_black": "10th degree black"
        },
        "invitation": {
            "title": "Invitation",
            "eventTitle": "Invitation to {event}",
            "acceptText": "Do you want to accept this invitation?",
            "inviteFor": "This invitation is for <span class=\"badge\">{name}</span>. Which profile would you like to connect it to?",
            "invitedByEvent": "{organization} invited your email to event {event}",
            "acceptButton": "Yes, accept registration",
            "declineButton": "No, this is not me",
            "chooseProfile": "- Choose profile -",
            "createNewProfile": "Create new profile for {name}"
        },
        "error": {
            "failedToLoadBracket": "Failed to load bracket data. Please try again later",
            "failedToLoadBrackets": "Failed to load brackets, please try again",
            "thisBracketNoLongerExists": "This bracket no longer exists"
        },
        "pagination": {
            "next": "Next &raquo;",
            "previous": "&laquo; Previous"
        },
        "results": {
            "publishAll": "Publish All"
        },
        "won_by": {
            "tech_fall": "Tech fall",
            "medical_forfeit": "Medical forfeit",
            "kill": "Won by kill",
            "kill_under_min": "Won by kill under 1 minute",
            "break": "Won by break",
            "break_under_min": "Won by break under 1 min",
            "pin": "Won by Pin",
            "stoppage": "Won by Stoppage",
            "ofp": "Won by Out from platform",
            "forcible_counting": "Won by Forcible Counting",
            "admonition": "Won by Admonition",
            "warnings": "Won by Warnings",
            "disqualification_over_weight": "Won by Weight",
            "head_judge_decision": "Won by Head Judge Decision"
        },
        "marketplace": {
            "image_recommendations": "Upload an image for your offer. Optimal size is 845x315, but otherwise it will be fitted automatically.",
            "offer_caps": "Offer",
            "offer_small": "offer",
            "target": "Target",
            "placeholder": {
                "title": "The title of the offer (required)",
                "desc": "A short description of the offer",
                "code": "The coupon code to use, if any",
                "expiration": "The expiration date of the offer, if any",
                "timezone": "Timezone for expiration date (required with expiration)",
                "link": "The link to the offer, if any",
                "categories": "Categories that apply to the offer (at least one required)",
                "target": "The target audience for the offer, if any",
                "company": "The company giving out the offer (required)"
            },
            "category": {
                "equipment": "Equipment",
                "apparel": "Apparel",
                "apps": "Apps"
            },
            "use_the_code": "Use the code",
            "go_to": "Go to",
            "expiration_passed": "Expiration date passed",
            "more_offers_from_market": "More offers from Smoothcomp market",
            "no_match": "No offers match your search, sorry!",
            "marketplace": "Marketplace"
        },
        "word": {
            "continue": "Continue",
            "cover": "Cover",
            "features": "Features",
            "logo": "Logo",
            "upload": "Upload",
            "website": "Website",
            "scoreboards": "Scoreboards",
            "registration": "Registration",
            "refunds": "Refunds",
            "pricing": "Pricing",
            "credit": "Credit",
            "discount": "Discount",
            "continent": "Continent",
            "wins": "Wins",
            "losses": "Losses",
            "fighterQuestion": "Athlete?",
            "organizerQuestion": "Organizer?",
            "ok": "OK",
            "dq": "DQ",
            "pending": "Pending",
            "membership": "Membership",
            "filter": "Filter",
            "federations": "Federations",
            "federation": "Federation",
            "region": "Region",
            "province": "Province",
            "county": "County",
            "city": "City",
            "member": "Member",
            "no": "No",
            "show": "Show",
            "reject": "Reject",
            "billing": "Billing",
            "card": "Card",
            "update_card": "Update card",
            "add_card": "Add card",
            "replace_card": "Replace card",
            "subscriptions": "Subscriptions",
            "expires_at": "Expires at",
            "subscribe": "Subscribe",
            "new": "New",
            "special_characters": "Special characters",
            "required": "Required",
            "required_by_default": "Required by default",
            "custom_data": "Custom data",
            "text": "Text",
            "text_area": "Text Area",
            "file": "File",
            "predefined_text": "Predefined text",
            "options": "Options",
            "options_description": "One new line (enter) for each option",
            "reason": "Reason",
            "new_reason": "New reason",
            "home": "Home",
            "loading": "Loading",
            "filtered_results": "Filtered results",
            "total_found": "Total found",
            "last_purchase": "Last purchase",
            "notes": "Notes",
            "invisible_for_the_academy": "invisible for the academy",
            "export": "Export",
            "medals": "Medals",
            "deadline": "Deadline",
            "early_bird_registrations": "Early bird",
            "early_bird_registrations_desc": "Offer a lower price before normal registration period",
            "early_bird_registrations_start_desc": "(when normal starts) <small>(prices are set in entries)</small>",
            "late_fee_ends_desc": "(when normal ends) <small>(prices are set in entries)</small>",
            "visibility": "Visibility",
            "won": "Won",
            "lost": "Lost",
            "double_wo_dq": "Double wo/dq",
            "default": "default",
            "awards": "Awards",
            "error": "Error",
            "how": "How",
            "watch": "Watch",
            "minutes": "Minute|Minutes",
            "overrides": "Overrides",
            "list": "List",
            "enter": "Enter",
            "display": "Display",
            "exceptions": "Exceptions",
            "achieved": "Achieved",
            "to_link": "Link",
            "order": "Order",
            "payment_made_by": "Payment made by",
            "defaults": "Defaults",
            "or": "or",
            "and": "and",
            "yes": "Yes",
            "add": "+ ADD",
            "review": "Require review process",
            "expiration": "Require expiration date",
            "male": "Male",
            "female": "Female",
            "everyone": "Everyone",
            "hide": "Hide",
            "from": "from",
            "to": "to",
            "created": "Created",
            "sort": "Sort",
            "where": "Where",
            "time": "Time",
            "now": "Now",
            "participants": "participant|participants",
            "you": "You",
            "more": "More",
            "hometown": "Hometown",
            "privacyPolicy": "Privacy Policy",
            "api_tokens": "API keys",
            "days": "days",
            "lifetime_days": "Lifetime (days)",
            "name": "Name",
            "bracket": "bracket",
            "approve": "Approve",
            "team": "Team",
            "actions": "Actions",
            "intro": "Intro",
            "signed": "Signed",
            "memberSince": "Member since",
            "personalNumber": "Personal number",
            "planExpires": "Plan expires",
            "products": "Products",
            "transactions": "Transactions",
            "payments": "Payments",
            "streetAddress": "Street address",
            "userType": "User type",
            "sharedAccounts": "Shared accounts",
            "clubMembership": "Club membership",
            "federationMembership": "Federation membership",
            "organizationAccess": "Organization access",
            "userId": "User ID",
            "paymentFailed": "Payment failed",
            "paymentError": "Payment error",
            "orderMessage": "Order message",
            "content": "Content",
            "january": "January",
            "february": "February",
            "march": "March",
            "april": "April",
            "may": "May",
            "june": "June",
            "july": "July",
            "august": "August",
            "september": "September",
            "october": "October",
            "november": "November",
            "december": "December",
            "sortAdjective": "Sort",
            "draw": "Draw",
            "draws": "Draws",
            "januaryShort": "Jan",
            "februaryShort": "Feb",
            "marsShort": "Mar",
            "aprilShort": "Apr",
            "mayShort": "May",
            "juneShort": "Jun",
            "julyShort": "Jul",
            "augustShort": "Aug",
            "septemberShort": "Sep",
            "octoberShort": "Oct",
            "novemberShort": "Nov",
            "decemberShort": "Dec",
            "min": "min",
            "sec": "sec",
            "hour": "hour|hours",
            "skill": "Skill|Skills",
            "points": "Points",
            "seconds": "Second|Seconds",
            "attendance": "Attendance",
            "marketing": "Marketing",
            "insights": "Insights"
        },
        "tiebreaker": {
            "group_general": "General",
            "group_grappling": "Grappling",
            "group_judo": "Judo",
            "group_jjif": "JJIF",
            "group_judo_jjif": "Judo, JJIF",
            "group_karate": "Karate",
            "group_striking_sports": "Striking sports",
            "group_wrestling": "Wrestling",
            "group_sambo": "Sambo",
            "group_sumo": "Sumo",
            "group_wushu_sanda": "Wushu-Sanda",
            "group_other": "Other",
            "head_to_head": "Head to head",
            "wonby_decision": "Number of wins by Decision",
            "wonby_dq": "Number of wins by Disqualification",
            "wonby_wo": "Number of wins by Walkover",
            "wonby_points": "Number of wins by points",
            "wonby_stoppage": "Number of wins by Stoppage",
            "classification_points": "Sum of all match points",
            "sumof_match_opponent_score": "Sum of all opponents score (lower is better)",
            "sumof_match_penalties": "Sum of match penalties (lower is better)",
            "sumof_match_score": "Sum of match scores",
            "sumof_won_penalties": "Sum of penalties in winning matches (lower is better)",
            "sumof_won_score": "Sum of score in winning matches",
            "sumof_match_time": "Shortest total fight time",
            "sumof_won_time": "Shortest total time in won matches",
            "fastest_submission": "Fastest submission (in seconds)",
            "wonby_submission": "Number of wins by submission",
            "sumof_match_advantages": "Sum of match advantages",
            "sumof_won_advantages": "Sum of advantages in winning matches",
            "wonby_ippon": "Number of wins by Ippon",
            "wonby_hansokumake": "Number of wins by Hansokumake",
            "wonby_fullippon": "Number of wins by full ippon",
            "wonby_wazari": "Number of wins by Wazari",
            "fastest_ippon": "Fastest ippon (in seconds)",
            "karate_weight": "Weight formula (used in Karate)",
            "sumof_ippons": "Total number of ippons",
            "sumof_wazaari": "Total number of waza ari",
            "sumof_genten": "Total number of genten",
            "sumof_chui": "Total number of chui",
            "wonby_knockout": "Number of wins by knockout",
            "wonby_vs0": "Number of wins by VSU (Technical Superiority)",
            "wonby_vt": "Number of wins by VFA (Fall)",
            "nordic_systems": "Nordic system tiebreaker rules",
            "fastest_fall": "Fastest win by fall (in seconds)",
            "wonby_technical_superiority_opponent_scored": "Number of wins by VSU1",
            "sumof_five_points_action": "Number of five points actions",
            "sumof_four_points_action": "Number of four points actions",
            "sumof_two_points_action": "Number of two points actions",
            "wonby_vp0": "Number of wins by VPO",
            "wonby_vp1": "Number of wins by VPO1",
            "wonby_vp": "Number of wins by VP (Beach wrestling only)",
            "wonby_four_zero": "Number of wins by 4-0",
            "wonby_three_one": "Number of wins by 3-1",
            "wonby_three_zero": "Number of wins by 3-0",
            "wonby_two_zero": "Number of wins by 2-0",
            "wonby_technique": "Number of wins by Technique",
            "wonby_first_to_win_two_rounds": "Number of wins by First to win two rounds",
            "wonby_forcible_counting": "Number of wins by Forcible counting",
            "wonby_admonition": "Number of wins by Admonition",
            "wonby_warnings": "Number of wins by Warnings",
            "wonby_head_judge_decision": "Number of wins by Head judge decision",
            "wonby_kill": "Number of wins by Kill",
            "wonby_kill_under_min": "Number of wins by Kill under a minute",
            "wonby_break": "Number of wins by Break",
            "wonby_break_under_min": "Number of wins by Break under a minute",
            "wonby_pin": "Number of wins by Pin",
            "wonby_pointbalance": "Point balance (points taken minus points given)",
            "pointbalance": "Point balance (points taken minus points given)",
            "group_UWW": "UWW",
            "wonby_default": "Number of wins by Default",
            "wonby_cautions": "Number of wins by Cautions",
            "wonby_forfeit": "Number of wins by Forfeit",
            "wonby_overtime": "Number of wins by Overtime"
        },
        "toplist": {
            "participant": "Athlete",
            "academy": "Academy",
            "team": "Affiliation",
            "team_academy": "Combined Affiliation & Academy",
            "team_or_academy": "Combined Affiliation or Academy",
            "nation": "Nation",
            "state": "State",
            "country": "Country",
            "template": "Template",
            "overridePointSettings": "Override point settings",
            "alwaysGivePoints": "Always give points, regardless of division size",
            "emptyRankingText": "There are no placements on this list yet. Keep an eye out for new ones soon!"
        },
        "by": {
            "decision": "By Decision",
            "disqualification": "By Disqualification (disqualification)",
            "dq": "By Disqualification (dq)",
            "draw": "Match was declared a draw",
            "fullippon": "By Full Ippon",
            "goldenpoint": "By Golden Point",
            "hansokumake": "By Hansokumake",
            "ippon": "By Ippon",
            "knockout": "By Knockout (knockout)",
            "ko": "By Knockout (ko)",
            "pointgap": "By Pointgap",
            "points": "By points",
            "rounds": "By rounds",
            "submission": "By Submission",
            "tko": "By Technical Knockout (tko)",
            "vs1": "By technical superiority (VSU1)",
            "vso": "By VSO (wrestling)",
            "vt": "By fall",
            "walkover": "By Walkover",
            "wazari": "By Wazari",
            "bye": "Via BYE",
            "technical-knockout": "By Technical Knockout (technical-knockout)",
            "double-dq": "Both athletes lost by DQ/WO",
            "double-walkover": "Both athletes lost by WO/DQ",
            "no-show": "Match cancelled due to No-Show",
            "double-no-show": "Match cancelled - Double No-show",
            "fastest_escape": "By Fastest Escape",
            "submission_overtime": "By Submission in Overtime",
            "submission_americana": "By Submission (Americana)",
            "submission_anaconda": "By Submission (Anaconda)",
            "decision_unanimous": "By Decision (Unanimous)",
            "decision_split": "By Decision (Split)",
            "decision_majority": "By Decision (Majority)",
            "decision_technical": "By Decision (Technical)",
            "submission_ankle_lock": "By Submission (Ankle Lock)",
            "submission_armbar": "By Submission (Armbar)",
            "submission_arm_triangle_choke": "By Submission (Arm Triangle Choke)",
            "submission_calf_crusher": "By Submission (Calf Crusher)",
            "submission_crucifix": "By Submission (Crucifix)",
            "submission_d_arce_choke": "By Submission (D'Arce Choke)",
            "submission_ezekiel": "By Submission (Ezekiel)",
            "submission_flying_armbar": "By Submission (Flying Armbar)",
            "submission_flying_triangle_choke": "By Submission (Flying Triangle Choke)",
            "submission_gogoplata": "By Submission (Gogoplata)",
            "submission_guillotine_choke": "By Submission (Guillotine Choke)",
            "submission_heel_hook": "By Submission (Heel Hook)",
            "submission_head_and_arm_choke": "By Submission (Head and Arm Choke)",
            "submission_kimura": "By Submission (Kimura)",
            "submission_kneebar": "By Submission (Kneebar)",
            "submission_neck_crank": "By Submission (Neck Crank)",
            "submission_north_south_choke": "By Submission (North-South Choke)",
            "submission_omoplata": "By Submission (Omoplata)",
            "submission_peruvian_necktie": "By Submission (Peruvian Necktie)",
            "submission_rear_naked_choke": "By Submission (Rear-Naked Choke)",
            "submission_reverse_armbar": "By Submission (Reverse Armbar)",
            "submission_triangle_choke": "By Submission (Triangle Choke)",
            "submission_twister": "By Submission (Twister)",
            "submission_other": "By Submission (Other)",
            "submission_scarf_hold": "By Submission (Scarf Hold)",
            "submission_bulldog_choke": "By Submission (Bulldog Choke)",
            "submission_von_flue_choke": "By Submission (Von Flue Choke)",
            "submission_inverted_triangle": "By Submission (Inverted Triangle)",
            "submission_smother_choke": "By Submission (Smother Choke)",
            "submission_triangle_armbar": "By Submission (Triangle Armbar)",
            "submission_achilles_lock": "By Submission (Achilles Lock)",
            "weigh_in_failed": "By Weigh In Failed",
            "med_exam_failed": "By Med Exam Failed",
            "keiken": "By Kiken",
            "shikkaku": "By Shikkaku",
            "hantei": "By Hantei",
            "senshu": "By Senshu",
            "major_decision": "By major decision",
            "fall": "By fall",
            "tech_fall": "By tech fall",
            "forfeit": "By forfeit",
            "medical_forfeit": "By medical forfeit",
            "injury": "By injury",
            "win_by_rule": "By rule",
            "final_score": "By Final score",
            "rsc": "By Referee stops contest",
            "superiority": "By superiority",
            "pun": "By referee’s punitive declaration",
            "golden_point_round": "By Golden point round",
            "withdrawal": "withdrawal",
            "vB": "By injury",
            "vd": "By disqualification",
            "vf": "By forfeit",
            "vp0": "By points (VPO)",
            "vp1": "By points (VPO1)",
            "vs0": "By technical superiority (VSU)",
            "v3": "By 3 cautions",
            "d2": "Double disqualification",
            "f2": "Double forfeit",
            "b2": "Double loss by injury (2VIN)",
            "vp": "By points (VP)",
            "no_contest": "By No contest",
            "performance": "By performance",
            "kill": "By Kill",
            "kill_under_min": "By Kill under 1 minute",
            "break": "By Break",
            "break_under_min": "By Break under 1 minute",
            "pin": "By Pin",
            "stoppage": "By Stoppage",
            "yuko": "By Yuko",
            "ofp": "By Out from platform",
            "forcible_counting": "By Forcible Counting",
            "admonition": "By Admonition",
            "warnings": "By Warnings",
            "disqualification_over_weight": "By Weight",
            "head_judge_decision": "By Head Judge Decision",
            "kill_americana": "By Kill (Americana)",
            "kill_anaconda": "By Kill (Anaconda)",
            "kill_ankle_lock": "By Kill (Ankle Lock)",
            "kill_armbar": "By Kill (Armbar)",
            "kill_arm_triangle_choke": "By Kill (Arm Triangle Choke)",
            "kill_calf_crusher": "By Kill (Calf Crusher)",
            "kill_crucifix": "By Kill (Crucifix)",
            "kill_d_arce_choke": "By Kill (D'Arce Choke)",
            "kill_ezekiel": "By Kill (Ezekiel)",
            "kill_flying_armbar": "By Kill (Flying Armbar)",
            "kill_flying_triangle_choke": "By Kill (Flying Triangle Choke)",
            "kill_gogoplata": "By Kill (Gogoplata)",
            "kill_guillotine_choke": "By Kill (Guillotine Choke)",
            "kill_heel_hook": "By Kill (Heel Hook)",
            "kill_head_and_arm_choke": "By Kill (Head and Arm Choke)",
            "kill_kimura": "By Kill (Kimura)",
            "kill_kneebar": "By Kill (Kneebar)",
            "kill_neck_crank": "By Kill (Neck Crank)",
            "kill_north_south_choke": "By Kill (North-South Choke)",
            "kill_omoplata": "By Kill (Omoplata)",
            "kill_peruvian_necktie": "By Kill (Peruvian Necktie)",
            "kill_rear_naked_choke": "By Kill (Rear-Naked Choke)",
            "kill_reverse_armbar": "By Kill (Reverse Armbar)",
            "kill_triangle_choke": "By Kill (Triangle Choke)",
            "kill_twister": "By Kill (Twister)",
            "kill_other": "By Kill (Other)",
            "kill_scarf_hold": "By Kill (Scarf Hold)",
            "kill_bulldog_choke": "By Kill (Bulldog Choke)",
            "kill_von_flue_choke": "By Kill (Von Flue Choke)",
            "kill_inverted_triangle": "By Kill (Inverted Triangle)",
            "kill_smother_choke": "By Kill (Smother Choke)",
            "kill_triangle_armbar": "By Kill (Triangle Armbar)",
            "kill_achilles_lock": "By Kill (Achilles Lock)",
            "kill_under_min_americana": "By Kill under 1 min (Americana)",
            "kill_under_min_anaconda": "By Kill under 1 min (Anaconda)",
            "kill_under_min_ankle_lock": "By Kill under 1 min (Ankle Lock)",
            "kill_under_min_armbar": "By Kill under 1 min (Armbar)",
            "kill_under_min_arm_triangle_choke": "By Kill under 1 min (Arm Triangle Choke)",
            "kill_under_min_calf_crusher": "By Kill under 1 min (Calf Crusher)",
            "kill_under_min_crucifix": "By Kill under 1 min (Crucifix)",
            "kill_under_min_d_arce_choke": "By Kill under 1 min (D'Arce Choke)",
            "kill_under_min_ezekiel": "By Kill under 1 min (Ezekiel)",
            "kill_under_min_flying_armbar": "By Kill under 1 min (Flying Armbar)",
            "kill_under_min_flying_triangle_choke": "By Kill under 1 min (Flying Triangle Choke)",
            "kill_under_min_gogoplata": "By Kill under 1 min (Gogoplata)",
            "kill_under_min_guillotine_choke": "By Kill under 1 min (Guillotine Choke)",
            "kill_under_min_heel_hook": "By Kill under 1 min (Heel Hook)",
            "kill_under_min_head_and_arm_choke": "By Kill under 1 min (Head and Arm Choke)",
            "kill_under_min_kimura": "By Kill under 1 min (Kimura)",
            "kill_under_min_kneebar": "By Kill under 1 min (Kneebar)",
            "kill_under_min_neck_crank": "By Kill under 1 min (Neck Crank)",
            "kill_under_min_north_south_choke": "By Kill under 1 min (North-South Choke)",
            "kill_under_min_omoplata": "By Kill under 1 min (Omoplata)",
            "kill_under_min_peruvian_necktie": "By Kill under 1 min (Peruvian Necktie)",
            "kill_under_min_rear_naked_choke": "By Kill under 1 min (Rear-Naked Choke)",
            "kill_under_min_reverse_armbar": "By Kill under 1 min (Reverse Armbar)",
            "kill_under_min_triangle_choke": "By Kill under 1 min (Triangle Choke)",
            "kill_under_min_twister": "By Kill under 1 min (Twister)",
            "kill_under_min_other": "By Kill under 1 min (Other)",
            "kill_under_min_scarf_hold": "By Kill under 1 min (Scarf Hold)",
            "kill_under_min_bulldog_choke": "By Kill under 1 min (Bulldog Choke)",
            "kill_under_min_von_flue_choke": "By Kill under 1 min (Von Flue Choke)",
            "kill_under_min_inverted_triangle": "By Kill under 1 min (Inverted Triangle)",
            "kill_under_min_smother_choke": "By Kill under 1 min (Smother Choke)",
            "kill_under_min_triangle_armbar": "By Kill under 1 min (Triangle Armbar)",
            "kill_under_min_achilles_lock": "By Kill under 1 min (Achilles Lock)",
            "break_americana": "By Break (Americana)",
            "break_anaconda": "By Break (Anaconda)",
            "break_ankle_lock": "By Break (Ankle Lock)",
            "break_armbar": "By Break (Armbar)",
            "break_arm_triangle_choke": "By Break (Arm Triangle Choke)",
            "break_calf_crusher": "By Break (Calf Crusher)",
            "break_crucifix": "By Break (Crucifix)",
            "break_d_arce_choke": "By Break (D'Arce Choke)",
            "break_ezekiel": "By Break (Ezekiel)",
            "break_flying_armbar": "By Break (Flying Armbar)",
            "break_flying_triangle_choke": "By Break (Flying Triangle Choke)",
            "break_gogoplata": "By Break (Gogoplata)",
            "break_guillotine_choke": "By Break (Guillotine Choke)",
            "break_heel_hook": "By Break (Heel Hook)",
            "break_head_and_arm_choke": "By Break (Head and Arm Choke)",
            "break_kimura": "By Break (Kimura)",
            "break_kneebar": "By Break (Kneebar)",
            "break_neck_crank": "By Break (Neck Crank)",
            "break_north_south_choke": "By Break (North-South Choke)",
            "break_omoplata": "By Break (Omoplata)",
            "break_peruvian_necktie": "By Break (Peruvian Necktie)",
            "break_rear_naked_choke": "By Break (Rear-Naked Choke)",
            "break_reverse_armbar": "By Break (Reverse Armbar)",
            "break_triangle_choke": "By Break (Triangle Choke)",
            "break_twister": "By Break (Twister)",
            "break_other": "By Break (Other)",
            "break_scarf_hold": "By Break (Scarf Hold)",
            "break_bulldog_choke": "By Break (Bulldog Choke)",
            "break_von_flue_choke": "By Break (Von Flue Choke)",
            "break_inverted_triangle": "By Break (Inverted Triangle)",
            "break_smother_choke": "By Break (Smother Choke)",
            "break_triangle_armbar": "By Break (Triangle Armbar)",
            "break_achilles_lock": "By Break (Achilles Lock)",
            "break_under_min_americana": "By Break under 1 min (Americana)",
            "break_under_min_anaconda": "By Break under 1 min (Anaconda)",
            "break_under_min_ankle_lock": "By Break under 1 min (Ankle Lock)",
            "break_under_min_armbar": "By Break under 1 min (Armbar)",
            "break_under_min_arm_triangle_choke": "By Break under 1 min (Arm Triangle Choke)",
            "break_under_min_calf_crusher": "By Break under 1 min (Calf Crusher)",
            "break_under_min_crucifix": "By Break under 1 min (Crucifix)",
            "break_under_min_d_arce_choke": "By Break under 1 min (D'Arce Choke)",
            "break_under_min_ezekiel": "By Break under 1 min (Ezekiel)",
            "break_under_min_flying_armbar": "By Break under 1 min (Flying Armbar)",
            "break_under_min_flying_triangle_choke": "By Break under 1 min (Flying Triangle Choke)",
            "break_under_min_gogoplata": "By Break under 1 min (Gogoplata)",
            "break_under_min_guillotine_choke": "By Break under 1 min (Guillotine Choke)",
            "break_under_min_heel_hook": "By Break under 1 min (Heel Hook)",
            "break_under_min_head_and_arm_choke": "By Break under 1 min (Head and Arm Choke)",
            "break_under_min_kimura": "By Break under 1 min (Kimura)",
            "break_under_min_kneebar": "By Break under 1 min (Kneebar)",
            "break_under_min_neck_crank": "By Break under 1 min (Neck Crank)",
            "break_under_min_north_south_choke": "By Break under 1 min (North-South Choke)",
            "break_under_min_omoplata": "By Break under 1 min (Omoplata)",
            "break_under_min_peruvian_necktie": "By Break under 1 min (Peruvian Necktie)",
            "break_under_min_rear_naked_choke": "By Break under 1 min (Rear-Naked Choke)",
            "break_under_min_reverse_armbar": "By Break under 1 min (Reverse Armbar)",
            "break_under_min_triangle_choke": "By Break under 1 min (Triangle Choke)",
            "break_under_min_twister": "By Break under 1 min (Twister)",
            "break_under_min_other": "By Break under 1 min (Other)",
            "break_under_min_scarf_hold": "By Break under 1 min (Scarf Hold)",
            "break_under_min_bulldog_choke": "By Break under 1 min (Bulldog Choke)",
            "break_under_min_von_flue_choke": "By Break under 1 min (Von Flue Choke)",
            "break_under_min_inverted_triangle": "By Break under 1 min (Inverted Triangle)",
            "break_under_min_smother_choke": "By Break under 1 min (Smother Choke)",
            "break_under_min_triangle_armbar": "By Break under 1 min (Triangle Armbar)",
            "break_under_min_achilles_lock": "By Break under 1 min (Achilles Lock)",
            "no_show_fusensho": "Match cancelled due to No-Show (Fusenshō)",
            "technique_kimarite": "By Technique (Kimarite)",
            "technique": "By Technique",
            "disqualification_hansoku": "By  Disqualification (Hansoku)",
            "criteria": "By Criteria"
        },
        "signup": {
            "checkEmail": "Check your email",
            "verify": "We need to verify that the email address belongs to you. Check your mailbox and follow the activation link.",
            "verifyAlert": "If you don't see a message in your inbox, check your spam or junk folder.",
            "learnMore": "Learn more about the Smoothcomp platform <a href=\"{url}\">here</a>",
            "resend": "Resend confirmation email",
            "tokenExpired": "Your confirmation token is expired",
            "emailConfirmed": "Your email is now confirmed"
        },
        "passwords": {
            "resetPassword": "Reset password",
            "sendPasswordResetLink": "Send password reset link",
            "password": "Passwords must be at least six characters and match the confirmation.",
            "user": "We can't find a user with that e-mail address.",
            "token": "This password reset token is invalid.",
            "sent": "We have e-mailed your password reset link!",
            "reset": "Your password has been reset!",
            "throttled": "Please wait before retrying."
        },
        "homepage": {
            "forOrganizers": "For organizers",
            "forCoaches": "For coaches",
            "forFighters": "For athletes",
            "onlinePaymentsBracketGeneration": "Online payments, bracket generation, scheduling and weigh-in. When it's time for the fights, the integrated scoreboard will make sure your tournament gets full points.",
            "beAbleToDoBulkRegistrations": "Be able to do bulk registrations, create new users and pay and search for all your athletes. We give you the overview you always wanted but never had.",
            "editRegistrationsAndSeeYourUpcomingFights": "Edit registrations and see your upcoming fights with a dynamic starting time. All the information you need is at your fingertip. We got your back every time.",
            "learnMoreAndGetStarted": "Learn more & get started",
            "upcomingEvents": "Upcoming events",
            "itsAnIndescribable": "\"It's an indescribable feeling to compete. To stand on a mat and face your opponent.\"",
            "watchTheMovie": "Watch the movie",
            "seeAllOurFeatures": "See all our features"
        },
        "sms": {
            "user_was_moved_to_another_group": "You've been moved to a new group for {event}. Please check {route}",
            "user_was_added_to_new_division": "You have been added to a new division at {event}. Please check {route}"
        },
        "dogshow": {
            "test": "testenglish",
            "upcoming_dog_shows": "Upcoming Dog Shows",
            "your_dog_shows": "Your Dog Shows",
            "previous_dog_shows": "Previous Dog Shows",
            "user_terms": "User Terms",
            "instructions": "Instructions",
            "find_club": "Find Club",
            "start_date": "Start Date",
            "end_date": "End Date",
            "type_of_dog_show": "Type of Dog Show",
            "sort_by_date": "Sort by Date",
            "dog_shows": "Dog Shows",
            "information": "Information",
            "entries": "Entries",
            "breeds": "Breeds",
            "rings": "Rings",
            "catalogue": "Catalogue",
            "main_ring_results": "Main Ring Results",
            "ring_schedule": "Ring Schedule",
            "for_prize_staff": "For Prize Staff",
            "location_and_accomodation": "Location & Accomodation",
            "admin": "Admin",
            "organising_club": "Organising Club",
            "location": "Location",
            "contct": "Contact",
            "find_breed": "Find Breed",
            "finals": "Finals",
            "catalogue_number_or_name": "Catalogue number or name",
            "breed": "Breed",
            "no_dogs_were_found": "No dogs were found (alternatively the catalogue is not yet published)",
            "results_from_the_main_ring_are_not_yet_finished_or_published": "Results from the main ring are not yet finished or published",
            "find_dog": "Find Dog",
            "catalogue_number": "Catalogue Number",
            "search": "Search",
            "no_dog_with_that_specific_catalogue_number_was_found": "No dog with that specific catalogue number was found (or the catalogue is not yet published).",
            "find_your_accomodation_close_to": "Find your accomodation close to this location. Use this map to find your accomodation close to this location.",
            "best_veteran": "Best Veteran",
            "best_progery_group": "Best Progeny Group",
            "best_breeders_group": "Best Breeder's Group",
            "best_puppy_6_9_months": "Best Puppy 6-9 Months",
            "best_junior": "Best Junior",
            "best_puppy_4_6_months": "Best Puppy 4-6 Months",
            "best_intermediate": "Best Intermediate",
            "best_working": "Best Working",
            "best_in_group": "Best in Group",
            "bos": "BOS",
            "bob": "BOB",
            "best_dog": "Best Dog",
            "best_bitch": "Best Bitch",
            "best_junior_2": "Best Junior",
            "best_veteran_2": "Best Veteran",
            "bitch": "Bitch",
            "dog": "Dog",
            "critique": "Critique",
            "reg_nr": "Reg-nr",
            "titles": "Titles",
            "breeder": "Breeder",
            "owner": "Owner",
            "born": "Born",
            "puppy_class": "Puppy Class",
            "junior_class": "Junior Class",
            "intermediate_class": "Intermediate Class",
            "working_class": "Working Class",
            "open_class": "Open Class",
            "champion_class": "Champion Class",
            "veteran_class": "Veteran Class",
            "best_dog_class": "Best Dog Class",
            "best_bitch_class": "Best Bitch Class",
            "progeny_class": "Progeny Class",
            "breeders_class": "Breeder's Class",
            "best_progeny_group": "Best Progeny Group",
            "write_your_catalogue_number": "Write your catalogue number here if you would like to print your critique.",
            "no_dog_with_that_specific_catalogue_number_were_found": "No dog with that specific catalogue number were found. (Or the catalogue is not yet published)",
            "find_dog_show": "Find Dog Show",
            "contact": "Contact",
            "main_ring_schedule": "Ring Schedule"
        },
        "win-types": {
            "submission": "Submission",
            "points": "Points",
            "decision": "Decision",
            "disqualification": "Disqualification",
            "dq": "Disqualification (DQ)",
            "walkover": "Walkover",
            "pointgap": "Pointgap",
            "draw": "Draw",
            "goldenpoint": "Golden Point",
            "fullippon": "Full Ippon",
            "ippon": "Ippon",
            "ko": "Knockout (KO)",
            "knockout": "Knockout (Knockout)",
            "tko": "Technical Knockout (TKO)",
            "technical-knockout": "Technical Knockout",
            "wazari": "Wazari",
            "rounds": "Rounds",
            "hansokumake": "Hansokumake",
            "vt": "Fall",
            "vso": "Technical Superiority (VSU)",
            "vs1": "Technical Superiority (VSU1)",
            "fall": "Fall",
            "tech_fall": "Tech Fall",
            "vp": "VP",
            "ofp": "Out from Platform",
            "forcible_counting": "Forcible Counting",
            "admonition": "Admonition",
            "disqualification_over_weight": "Weight",
            "head_judge_decision": "Head Judge Decision",
            "warnings": "Warnings",
            "b2": "Double Loss by Injury (2VIN)",
            "break": "Break",
            "break_under_min": "Break under 1 min",
            "bye": "BYE",
            "d2": "Double Disqualification",
            "decision_majority": "Decision (Majority)",
            "decision_split": "Decision (Split)",
            "decision_technical": "Decision (Technical)",
            "decision_unanimous": "Decision (Unanimous)",
            "double-dq": "DQ/WO",
            "double-no-show": "Double No Show",
            "double-walkover": "WO/DQ",
            "f2": "Double Forfeit",
            "fastest_escape": "Fastest Escape",
            "final_score": "Final Score",
            "forfeit": "Forfeit",
            "golden_point_round": "Golden Point Round",
            "hantei": "Hantei",
            "injury": "Injury",
            "keiken": "Keiken",
            "kill": "Kill",
            "kill_under_min": "Kill under 1 min",
            "major_decision": "Major Decision",
            "med_exam_failed": "Med Exam Failed",
            "medical_forfeit": "Medical Forfeit",
            "no_contest": "No Contest",
            "no-show": "No Show",
            "performance": "Performance",
            "pin": "Pin",
            "pun": "Referee’s Punitive Declaration",
            "rsc": "Referee Stops Contest",
            "senshu": "Senshu",
            "shikkaku": "Shikkaku",
            "stoppage": "Stoppage",
            "submission_achilles_lock": "Submission (Achilles Lock)",
            "submission_americana": "Submission (Americana)",
            "submission_anaconda": "Submission (Anaconda)",
            "submission_ankle_lock": "Submission (Ankle Lock)",
            "submission_arm_triangle_choke": "Submission (Arm Triangle Choke)",
            "submission_armbar": "Submission (Armbar)",
            "submission_bulldog_choke": "Submission (Bulldog Choke)",
            "submission_calf_crusher": "Submission (Calf Crusher)",
            "submission_crucifix": "Submission (Crucifix)",
            "submission_d_arce_choke": "Submission (D'Arce Choke)",
            "submission_ezekiel": "Submission (Ezekiel)",
            "submission_flying_armbar": "Submission (Flying Armbar)",
            "submission_flying_triangle_choke": "Submission (Flying Triangle Choke)",
            "submission_gogoplata": "Submission (Gogoplata)",
            "submission_guillotine_choke": "Submission (Guillotine Choke)",
            "submission_head_and_arm_choke": "Submission (Head and Arm Choke)",
            "submission_heel_hook": "Submission (Heel Hook)",
            "submission_inverted_triangle": "Submission (Inverted Triangle)",
            "submission_kimura": "Submission (Kimura)",
            "submission_kneebar": "Submission (Kneebar)",
            "submission_neck_crank": "Submission (Neck Crank)",
            "submission_north_south_choke": "Submission (North South Choke)",
            "submission_omoplata": "Submission (Omoplata)",
            "submission_other": "Submission (Other)",
            "submission_overtime": "Submission in Overtime",
            "submission_peruvian_necktie": "Submission (Peruvian Necktie)",
            "submission_rear_naked_choke": "Submission (Rear Naked Choke)",
            "submission_reverse_armbar": "Submission (Reverse Armbar)",
            "submission_scarf_hold": "Submission (Scarf Hold)",
            "submission_smother_choke": "Submission (Smother Choke)",
            "submission_triangle_armbar": "Submission (Triangle Armbar)",
            "submission_triangle_choke": "Submission (Triangle Choke)",
            "submission_twister": "Submission (Twister)",
            "submission_von_flue_choke": "Submission (Von Flue Choke)",
            "superiority": "Superiority",
            "v3": "3 Cautions",
            "vB": "Injury",
            "vd": "Disqualification",
            "vf": "Forfeit",
            "vp0": "Points (VPO)",
            "vp1": "Points (VPO1)",
            "vs0": "Technical Superiority (VSU)",
            "weigh_in_failed": "Weigh In Failed",
            "win_by_rule": "Rule",
            "withdrawal": "Withdrawal",
            "yuko": "Yuko",
            "double-bye": "Double BYE",
            "kill_achilles_lock": "Kill (Achilles Lock)",
            "kill_americana": "Kill (Americana)",
            "kill_anaconda": "Kill (Anaconda)",
            "kill_ankle_lock": "Kill (Ankle Lock)",
            "kill_arm_triangle_choke": "Kill (Arm Triangle Choke)",
            "kill_armbar": "Kill (Armbar)",
            "kill_bulldog_choke": "Kill (Bulldog Choke)",
            "kill_calf_crusher": "Kill (Calf Crusher)",
            "kill_crucifix": "Kill (Crucifix)",
            "kill_d_arce_choke": "Kill (D'Arce Choke)",
            "kill_ezekiel": "Kill (Ezekiel)",
            "kill_flying_armbar": "Kill (Flying Armbar)",
            "kill_flying_triangle_choke": "Kill (Flying Triangle Choke)",
            "kill_gogoplata": "Kill (Gogoplata)",
            "kill_guillotine_choke": "Kill (Guillotine Choke)",
            "kill_head_and_arm_choke": "Kill (Head and Arm Choke)",
            "kill_heel_hook": "Kill (Heel Hook)",
            "kill_inverted_triangle": "Kill (Inverted Triangle)",
            "kill_kimura": "Kill (Kimura)",
            "kill_kneebar": "Kill (Kneebar)",
            "kill_neck_crank": "Kill (Neck Crank)",
            "kill_north_south_choke": "Kill (North South Choke)",
            "kill_omoplata": "Kill (Omoplata)",
            "kill_other": "Kill (Other)",
            "kill_peruvian_necktie": "Kill (Peruvian Necktie)",
            "kill_rear_naked_choke": "Kill (Rear Naked Choke)",
            "kill_reverse_armbar": "Kill (Reverse Armbar)",
            "kill_scarf_hold": "Kill (Scarf Hold)",
            "kill_smother_choke": "Kill (Smother Choke)",
            "kill_triangle_armbar": "Kill (Triangle Armbar)",
            "kill_triangle_choke": "Kill (Triangle Choke)",
            "kill_twister": "Kill (Twister)",
            "kill_von_flue_choke": "Kill (Von Flue Choke)",
            "kill_under_min_achilles_lock": "Kill under 1 min (Achilles Lock)",
            "kill_under_min_americana": "Kill under 1 min (Americana)",
            "kill_under_min_anaconda": "Kill under 1 min (Anaconda)",
            "kill_under_min_ankle_lock": "Kill under 1 min (Ankle Lock)",
            "kill_under_min_arm_triangle_choke": "Kill under 1 min (Arm Triangle Choke)",
            "kill_under_min_armbar": "Kill under 1 min (Armbar)",
            "kill_under_min_bulldog_choke": "Kill under 1 min (Bulldog Choke)",
            "kill_under_min_calf_crusher": "Kill under 1 min (Calf Crusher)",
            "kill_under_min_crucifix": "Kill under 1 min (Crucifix)",
            "kill_under_min_d_arce_choke": "Kill under 1 min (D'Arce Choke)",
            "kill_under_min_ezekiel": "Kill under 1 min (Ezekiel)",
            "kill_under_min_flying_armbar": "Kill under 1 min (Flying Armbar)",
            "kill_under_min_flying_triangle_choke": "Kill under 1 min (Flying Triangle Choke)",
            "kill_under_min_gogoplata": "Kill under 1 min (Gogoplata)",
            "kill_under_min_guillotine_choke": "Kill under 1 min (Guillotine Choke)",
            "kill_under_min_head_and_arm_choke": "Kill under 1 min (Head and Arm Choke)",
            "kill_under_min_heel_hook": "Kill under 1 min (Heel Hook)",
            "kill_under_min_inverted_triangle": "Kill under 1 min (Inverted Triangle)",
            "kill_under_min_kimura": "Kill under 1 min (Kimura)",
            "kill_under_min_kneebar": "Kill under 1 min (Kneebar)",
            "kill_under_min_neck_crank": "Kill under 1 min (Neck Crank)",
            "kill_under_min_north_south_choke": "Kill under 1 min (North South Choke)",
            "kill_under_min_omoplata": "Kill under 1 min (Omoplata)",
            "kill_under_min_other": "Kill under 1 min (Other)",
            "kill_under_min_peruvian_necktie": "Kill under 1 min (Peruvian Necktie)",
            "kill_under_min_rear_naked_choke": "Kill under 1 min (Rear Naked Choke)",
            "kill_under_min_reverse_armbar": "Kill under 1 min (Reverse Armbar)",
            "kill_under_min_scarf_hold": "Kill under 1 min (Scarf Hold)",
            "kill_under_min_smother_choke": "Kill under 1 min (Smother Choke)",
            "kill_under_min_triangle_armbar": "Kill under 1 min (Triangle Armbar)",
            "kill_under_min_triangle_choke": "Kill under 1 min (Triangle Choke)",
            "kill_under_min_twister": "Kill under 1 min (Twister)",
            "kill_under_min_von_flue_choke": "Kill under 1 min (Von Flue Choke)",
            "break_achilles_lock": "Break (Achilles Lock)",
            "break_americana": "Break (Americana)",
            "break_anaconda": "Break (Anaconda)",
            "break_ankle_lock": "Break (Ankle Lock)",
            "break_arm_triangle_choke": "Break (Arm Triangle Choke)",
            "break_armbar": "Break (Armbar)",
            "break_bulldog_choke": "Break (Bulldog Choke)",
            "break_calf_crusher": "Break (Calf Crusher)",
            "break_crucifix": "Break (Crucifix)",
            "break_d_arce_choke": "Break (D'Arce Choke)",
            "break_ezekiel": "Break (Ezekiel)",
            "break_flying_armbar": "Break (Flying Armbar)",
            "break_flying_triangle_choke": "Break (Flying Triangle Choke)",
            "break_gogoplata": "Break (Gogoplata)",
            "break_guillotine_choke": "Break (Guillotine Choke)",
            "break_head_and_arm_choke": "Break (Head and Arm Choke)",
            "break_heel_hook": "Break (Heel Hook)",
            "break_inverted_triangle": "Break (Inverted Triangle)",
            "break_kimura": "Break (Kimura)",
            "break_kneebar": "Break (Kneebar)",
            "break_neck_crank": "Break (Neck Crank)",
            "break_north_south_choke": "Break (North South Choke)",
            "break_omoplata": "Break (Omoplata)",
            "break_other": "Break (Other)",
            "break_peruvian_necktie": "Break (Peruvian Necktie)",
            "break_rear_naked_choke": "Break (Rear Naked Choke)",
            "break_reverse_armbar": "Break (Reverse Armbar)",
            "break_scarf_hold": "Break (Scarf Hold)",
            "break_smother_choke": "Break (Smother Choke)",
            "break_triangle_armbar": "Break (Triangle Armbar)",
            "break_triangle_choke": "Break (Triangle Choke)",
            "break_twister": "Break (Twister)",
            "break_von_flue_choke": "Break (Von Flue Choke)",
            "break_under_min_achilles_lock": "Break under 1 min (Achilles Lock)",
            "break_under_min_americana": "Break under 1 min (Americana)",
            "break_under_min_anaconda": "Break under 1 min (Anaconda)",
            "break_under_min_ankle_lock": "Break under 1 min (Ankle Lock)",
            "break_under_min_arm_triangle_choke": "Break under 1 min (Arm Triangle Choke)",
            "break_under_min_armbar": "Break under 1 min (Armbar)",
            "break_under_min_bulldog_choke": "Break under 1 min (Bulldog Choke)",
            "break_under_min_calf_crusher": "Break under 1 min (Calf Crusher)",
            "break_under_min_crucifix": "Break under 1 min (Crucifix)",
            "break_under_min_d_arce_choke": "Break under 1 min (D'Arce Choke)",
            "break_under_min_ezekiel": "Break under 1 min (Ezekiel)",
            "break_under_min_flying_armbar": "Break under 1 min (Flying Armbar)",
            "break_under_min_flying_triangle_choke": "Break under 1 min (Flying Triangle Choke)",
            "break_under_min_gogoplata": "Break under 1 min (Gogoplata)",
            "break_under_min_guillotine_choke": "Break under 1 min (Guillotine Choke)",
            "break_under_min_head_and_arm_choke": "Break under 1 min (Head and Arm Choke)",
            "break_under_min_heel_hook": "Break under 1 min (Heel Hook)",
            "break_under_min_inverted_triangle": "Break under 1 min (Inverted Triangle)",
            "break_under_min_kimura": "Break under 1 min (Kimura)",
            "break_under_min_kneebar": "Break under 1 min (Kneebar)",
            "break_under_min_neck_crank": "Break under 1 min (Neck Crank)",
            "break_under_min_north_south_choke": "Break under 1 min (North South Choke)",
            "break_under_min_omoplata": "Break under 1 min (Omoplata)",
            "break_under_min_other": "Break under 1 min (Other)",
            "break_under_min_peruvian_necktie": "Break under 1 min (Peruvian Necktie)",
            "break_under_min_rear_naked_choke": "Break under 1 min (Rear Naked Choke)",
            "break_under_min_reverse_armbar": "Break under 1 min (Reverse Armbar)",
            "break_under_min_scarf_hold": "Break under 1 min (Scarf Hold)",
            "break_under_min_smother_choke": "Break under 1 min (Smother Choke)",
            "break_under_min_triangle_armbar": "Break under 1 min (Triangle Armbar)",
            "break_under_min_triangle_choke": "Break under 1 min (Triangle Choke)",
            "break_under_min_twister": "Break under 1 min (Twister)",
            "break_under_min_von_flue_choke": "Break under 1 min (Von Flue Choke)",
            "no_show_fusensho": "No Show (Fusenshō)",
            "disqualification_hansoku": "Disqualification (Hansoku)",
            "technique_kimarite": "Technique (Kimarite)",
            "technique": "Technique",
            "criteria": "Criteria",
            "wp": "WP",
            "rscs": "Referee Stops Contest (Safety)",
            "rsci": "Referee Stops Contest (Injury)",
            "rsch": "Referee Stops Contest (Head Strike)",
            "rscb": "Referee Stops Contest (Body Strike)",
            "rsco": "Referee Stops Contest (Outclass)",
            "ccl": "Compulsory Count Limit",
            "koh": "Knockout (Head Strike)",
            "kob": "Knockout (Body Strike)",
            "ret": "Retirement",
            "wo": "Walkover",
            "nc": "No Contest",
            "draw_leading": "Draw (Leading off / Better Style)",
            "draw_defence": "Draw (Better Defence)",
            "draw_other": "Draw (Other)",
            "wo_short": "WO",
            "penalties": "Penalties",
            "four_zero": "4-0",
            "three_one": "3-1",
            "three_zero": "3-0",
            "two_zero": "2-0",
            "total_rounds_won_majority": "Total rounds won majority",
            "first_to_win_two_rounds": "First to win two rounds"
        },
        "bracket": {
            "common": {
                "min": "min",
                "sec": "sec",
                "countUp": "Count up",
                "countDown": "Count down",
                "judgesCount": "Judges count",
                "judge": "Judge",
                "customJudgeNames": "Custom judge names",
                "cancelHighestLowestScore": "Cancel highest & lowest score?",
                "optionKeepAllScores": "No, include all scores",
                "optionRemoveOutliers": "Yes, remove",
                "autoCriteria": "Auto criteria",
                "refereeCount": "Referee count",
                "showPointLog": "Show point log",
                "showScoresInScoreboard": "Show scores in the scoreboard",
                "includeAdvantagesInScoreboard": "Include advantages in the scoreboard",
                "includeDoublePenaltyInScoreboard": "Include double penalty in the scoreboard",
                "enableSubtypeWinType": "Enable specific submissions as win type when saving match",
                "stopClockOnIppon": "Stop match clock on Ippon score"
            },
            "colors": {
                "red": "Red",
                "blue": "Blue",
                "darkblue": "DarkBlue",
                "darkerblue": "DarkerBlue",
                "white": "White",
                "black": "Black",
                "yellow": "Yellow",
                "green": "Green",
                "orange": "Orange",
                "pink": "Pink"
            },
            "presets": {
                "bjj-fullscreen": {
                    "bjj_standard": "BJJ Default",
                    "bjj_blue_red": "BJJ Blue/Red",
                    "bjj_red_green": "BJJ Red/Green"
                },
                "bjj-supercup": {
                    "bjj_supercup_standard": "BJJ Supercup Default"
                },
                "catchwrestling": {
                    "catchwrestling_standard": "Catch Wrestling Default"
                },
                "wrestleclaw": {
                    "wrestleclaw_default": "Wrestleclaw default"
                },
                "bjj-ebi": {
                    "default": "Default",
                    "ava": "AVA Standard",
                    "ebi": "EBI Standard"
                },
                "bjj-ocean": {
                    "bjj_ocean": "BJJ Ocean"
                },
                "pgf-world": {
                    "pgf_world_standard": "PGF World Default"
                },
                "universal": {
                    "universal_standard": "Universal Default",
                    "universal_no_score": "Without scores"
                },
                "sumo": {
                    "sumo_standard": "Sumo Default"
                },
                "judo": {
                    "judo_standard": "Judo Default"
                },
                "njudo": {
                    "judo_2025_standard": "Judo 2025 Default"
                },
                "karate-aau": {
                    "karate_aau_standard": "Karate AAU Default",
                    "karate_aau_rotational": "Rotational"
                },
                "karate-kyokushin": {
                    "karate_kyokushin_default": "Karate Kyokushin Default"
                },
                "karate-wkf": {
                    "karate_wkf_default": "Karate WKF Default"
                },
                "karate-wkf-new": {
                    "karate_wkf_default": "Karate WKF Default"
                },
                "adcc": {
                    "adcc_standard": "ADCC Default"
                },
                "ufc-fpi": {
                    "ufc_fpi_standard": "UFC FPI Default"
                },
                "ajp": {
                    "ajp_standard": "AJP Default"
                },
                "newaza": {
                    "newaza_standard": "Newaza Default"
                },
                "jj": {
                    "figthing_standard": "JJIF Fighting Default"
                },
                "kickboxing": {
                    "kickboxing_default": "Kickboxing Default"
                },
                "kickboxing-wako": {
                    "kickboxing_wako": "WAKO Kickboxing"
                },
                "jjif-duo": {
                    "duo_standard": "Duo Default"
                },
                "jj-quintet": {
                    "quintet_default": "Quintet Default"
                },
                "taekwondo": {
                    "taekwondo_default": "Taekwondo Best of Three",
                    "taekwondo_cumulative_scoring": "Taekwondo Cumulative Scoring"
                },
                "taekwondo-itf": {
                    "taekwondo_itf_default": "Taekwondo ITF Default"
                },
                "karate": {
                    "karate_default": "Karate Default"
                },
                "sambo": {
                    "sambo_default": "Sambo Default"
                },
                "wushu-sanda": {
                    "sanda_default": "Sanda Default"
                },
                "sjjif": {
                    "sjjif_default": "SJJIF Default",
                    "sjjif_submission_default": "SJJIF Submission Default"
                },
                "wrestling": {
                    "wrestling_default": "Wrestling Default",
                    "wrestling_beach_default": "Wrestling Beach Default"
                },
                "mma": {
                    "mma_default": "MMA Default"
                },
                "mma-kata": {
                    "mma_kata_default": "MMA Kata Default"
                },
                "muay-thai": {
                    "muay_thai_default": "Muay Thai Default"
                },
                "wrestling-folkstyle": {
                    "folkstyle_default": "High school",
                    "folkstyle_college": "College"
                },
                "uww-fullscreen": {
                    "uww_default": "UWW Default",
                    "grappling_default": "Grappling",
                    "beach_default": "Beach"
                },
                "kudo": {
                    "kudo_default": "Kudo Default"
                },
                "pfc": {
                    "pfc_default": "PFC Default"
                },
                "acbjj-bluered": {
                    "acbjj_standard": "Battle",
                    "acbjj_superfights": "SuperFights"
                },
                "acbjj-whiteblack": {
                    "acbjj_standard": "Standard"
                }
            },
            "index": {
                "restBetweenRounds": "Rest between rounds",
                "restNone": "None (0 Seconds)",
                "rest30Sec": "30 Seconds",
                "minutes": "Minutes",
                "majorityWin": "Majority win",
                "estimatedTimePerMatch": "Estimated time per match",
                "estimatedTimePerMatchTooltip": "Your estimated average. We use this to estimate match start times",
                "scoreboardSettings": "Scoreboard settings",
                "custom": "Custom",
                "hideOptions": "Hide options",
                "showOptions": "Show options",
                "player1Background": "Player 1 background",
                "player2Background": "Player 2 background",
                "player1Text": "Player 1 text",
                "player2Text": "Player 2 text",
                "auto": "-- Auto --",
                "previewPlayer1": "Preview Player 1",
                "previewPlayer2": "Preview Player 2",
                "enableTiebreaker": "Enable tiebreaker",
                "enableOvertime": "Enable overtime",
                "enableStalling": "Enable stalling/hold timer",
                "showNationalityFlags": "Display the athletes nationality flags",
                "noFlags": "-- No flags --",
                "athleteFlags": "Athlete flags",
                "academyFlags": "Academy flags",
                "enableNoShow": "Enable \"No show\"",
                "showAcademyAffiliation": "Display the athletes academy/affiliation",
                "display": "Display",
                "displayBoth": "Both Academy and Affiliation",
                "displayAcademyOnly": "Only Academy",
                "displayAffiliationOnly": "Only Affiliation"
            },
            "roundSettings": {
                "roundsPerMatch": "Rounds per match",
                "roundsPerMatchTooltip": "1 in most sports but some have multiple rounds with short rest in between",
                "timePerRound": "Time per round",
                "timePerRoundTooltip": "Matches can have multiple rounds"
            },
            "dynamicRoundSettings": {
                "timePerPeriod": "Time per period",
                "timePerPeriodTooltip": "Matches can have multiple periods",
                "hidePeriodSettings": "Hide period settings",
                "showPeriodSettings": "Show period settings",
                "removePeriod": "Remove period",
                "addNormalPeriod": "Add Normal Period",
                "addOvertimePeriod": "Add Overtime Period",
                "addGoldenScorePeriod": "Add Golden Score Period",
                "infoNormalTitle": "Normal period:",
                "infoNormalText": "Adds a normal period",
                "infoOvertimeTitle": "Overtime:",
                "infoOvertimeText": "A period that will start only if the scores are tied",
                "infoGoldenScoreTitle": "Golden Score:",
                "infoGoldenScoreText": "Same as overtime, but will stop once someone scores",
                "period": "Period",
                "overtimePeriod": "Overtime Period",
                "of": "of"
            },
            "roundPreview": {
                "unknown": "Unknown",
                "countsDownFrom": "counts down from",
                "countsUpTo": "counts up to",
                "coinFlip": "Coin flip"
            },
            "roundEdit": {
                "normal": "Normal",
                "overtime": "Overtime",
                "goldenscore": "Goldenscore",
                "noCoinFlip": "No coin flip",
                "coinFlip": "Coin flip",
                "otherWrestlersPick": "Other wrestlers pick"
            },
            "overtime": {
                "firstToScoreWins": "First to score wins",
                "goldenScoreMode": "Golden score mode",
                "goldenScoreModeHint": "(first to score wins)"
            },
            "ebiOvertime": {
                "periods": "periods"
            },
            "stalling": {
                "name": "name",
                "to": "To"
            },
            "types": {
                "bjjEbi": {
                    "includePenalties": "Include penalties in the scoreboard",
                    "drawOnTieAfterOt": "If tied after OT, end the match as draw"
                },
                "bjjFullscreen": {
                    "includePenalty": "Include penalty in the scoreboard",
                    "includeDoublePenaltyWithPoints": "Include double penalty with points assignment"
                },
                "bjjSupercup": {
                    "showLastToScore": "Display last to score in scoreboard"
                },
                "jjifDuo": {
                    "disableMatchTimer": "Disable match timer"
                },
                "njudo": {
                    "allowFullOsaekomiInGs": "Allow osae komi to run the full duration during golden score"
                },
                "kata": {
                    "scoringIntervalTitle": "What is the scoring interval?",
                    "scoreDecimalPlaces": "Score decimal places",
                    "scoreMinValue": "Score minimum value",
                    "scoreMaxValue": "Score maximum value",
                    "scoreCalculation": "Score calculation",
                    "average": "Average",
                    "total": "Total",
                    "accumulatePoints": "Should points accumulated from previous rounds?",
                    "no": "No",
                    "yes": "Yes",
                    "showMatchClock": "Show match clock"
                },
                "karateAau": {
                    "enableRotational": "Enable Rotational",
                    "autoEndOnPointLead": "End game automatically after point lead"
                },
                "kickboxing": {
                    "injuryTimer": "Injury timer",
                    "includeKnockdown": "Include knockdown",
                    "includeExit": "Include exit"
                },
                "taekwondo": {
                    "style": "Style",
                    "bestOfThreeRounds": "Best of Three Rounds",
                    "cumulativeScoring": "Cumulative Scoring",
                    "pointGap": "Point gap",
                    "pointGapHint": "(end the round when there's a 12 point difference)",
                    "pointGapAllMatches": "Use point gap for all matches",
                    "pointGapAllExceptFinals": "Use point gap for all matches, except semifinals and finals",
                    "pointGapOff": "Do not use point gap"
                },
                "wushuSanda": {
                    "enableRemoteScoring": "Enable remote scoring",
                    "hideJudgesScoreInSpectator": "Hide judges score in spectator view"
                },
                "wushuTaolu": {
                    "matchClock": "Match clock",
                    "groups": "Groups",
                    "groupB": "Group B",
                    "groupAB": "Group A & B",
                    "groupABC": "Group A, B & C",
                    "qualityOfMovement": "Quality of movement (QM)",
                    "judgesCountLabel": "judges count",
                    "overallPerformance": "Overall performance (OP)",
                    "degreeAndDifficulty": "Degree and difficulty (DD)",
                    "showClockInSpectator": "Show clock in spectator"
                },
                "wushuTaoluMi": {
                    "category": "Category",
                    "enableClock": "Enable clock",
                    "minimumTime": "Minimum time",
                    "maximumTime": "Maximum time",
                    "timeDeduction": "Time Deduction",
                    "pt": "pt",
                    "judges": "Judges",
                    "aJudgesCount": "A judges count",
                    "bJudgesCount": "B judges count",
                    "cJudgesCount": "C judges count",
                    "cancelHighestAndLowestValues": "Cancel highest and lowest values",
                    "judgesBOnly": "B Judge Only",
                    "judgesAB": "A+B Judges",
                    "judgesABC": "A+B+C Judges"
                },
                "sumo": {
                    "useClock": "Use clock"
                },
                "wrestling": {
                    "beach": "Beach"
                },
                "wrestlingFolkstyle": {
                    "enableRidingTime": "Enable riding time",
                    "ridingInheritColor": "Riding timer inherits athletes custom colors",
                    "nextRoundAuto": "Go to next round on round end",
                    "awardedPointsForTakedown": "Awarded points for takedown",
                    "takedownHighSchool": "2 points (High school)",
                    "takedownCollege": "3 points (College)"
                },
                "mmaKata": {
                    "openScoring": "Open Scoring",
                    "openScoringHint": "(display scores after each round)",
                    "displayAccumulate": "Display and accumulate scores after each round",
                    "autoDisplayScorecards": "Automatically display scorecards between rounds",
                    "autoDisplayScorecardsHint": "(when all judges has published their round scores)",
                    "lockScoringDuringRounds": "Lock scoring during rounds",
                    "lockScoringDuringRoundsHint": "(Allow judges to input scores only during the rest period after each round)"
                },
                "judoKata": {
                    "kata": "Kata"
                },
                "uwwFullscreen": {
                    "includeInjuryTimer": "Include injury timer in the scoreboard",
                    "excludeTwoPoint": "Exclude two point option in the scoreboard",
                    "enableTimer": {
                        "medical": "Enable medical timer",
                        "uniform": "Enable uniform timer",
                        "passivity": "Enable passivity timer"
                    }
                },
                "sjjif": {
                    "submissionOnly": "Submission Only"
                }
            },
            "timer": {
                "to": "To",
                "name": "name"
            },
            "reseed": {
                "oldWrestlebackLayout": "This division uses the old wrestleback layout and cannot be reseeded or redrawn. Delete its brackets and generate them again to rebuild it."
            }
        },
        "features": {
            "featuresOfSmoothcomp": "Features of the Smoothcomp software.",
            "weEmpowerTheWorld": "We empower the world's greatest tournaments and athletes",
            "noOneTournamentSoftwareFor": "No 1<strong> Tournament software for combat sports</strong>",
            "theBracketBuilder": "<strong>The bracket builder </strong>will do the heavy lifting.",
            "scTournament": "SC Tournament",
            "oneMinuteAgo": "1m ago",
            "handleRegistrations": "<strong>Handle registrations,</strong> payments and even SMS notifications.",
            "hiAnna": "Hi Anna! We're all really excited that...",
            "goLiveWithStyle": "<strong>Go live with style. </strong>Built in streaming with digital scoreboards.",
            "reachOurGlobalCommunity": "<strong>Reach our global community</strong>of over 1.3 million users.",
            "goBigOurBracketBuilder": "Go big. Our bracket builder can handle it.",
            "missingSomething": "<strong>Missing something?</strong><br>Let's talk!",
            "smoothcompHasGrownThanks": "Smoothcomp has grown thanks to our community. How can we make your sport better?",
            "singleDisplay": "Single display",
            "dualDisplay": "Dual display",
            "enlarge": "Enlarge",
            "shrink": "Shrink",
            "theScoreboardPowered": "<strong>The scoreboard, </strong>powered by the bracket system (and you).",
            "tryForFree": "Try for free",
            "goLiveGiveYourPlayers": "<strong>Go live.</strong> Give your players something to remember.",
            "automaticScoreboardIn": "Automatic scoreboard in stream",
            "streamWithIphonesAndIpads": "<strong>Stream with iPhones, iPads and Android devices</strong> using the Smoothstreamer app",
            "streamWithComputerUsing": "<strong>Stream with computer,</strong> using OBS or any other software",
            "mixAndMatchPlayAround": "<strong>Mix & match.</strong> Play around with what you have and scale up",
            "whensMyNextMatch": "When's my next match?",
            "saidNoOneEverAgain": "said no one ever again",
            "checkInLikeAFiveStar": "Check-in like a five star hotel",
            "createYourFirstEvent": "Create your first event today",
            "allInOnePackage": "All in one package",
            "registrationAndPayment": "Registration & Payment",
            "manageEntries": "Manage entries",
            "paymentsThroughStripe": "Payments through Stripe, Paypal and more",
            "connectYourStripeOrPaypal": "Connect your Stripe- or Paypal-account directly to your Smoothcomp organization to start taking charge. We don't take any percentage inbetween.",
            "customPayment": "Custom payment",
            "ifYouPreferBank": "If you prefer bank transfer or payment in hand, we got you covered as well. All payments can easily be handled through your admin panel.",
            "discountsAndCoupons": "Discounts & Coupons",
            "lateAndEarlyBird": "Late and early bird fees",
            "communication": "Communication",
            "customEventPage": "Custom event page",
            "customSmsAndEmails": "Custom SMS and emails",
            "exportRegistrations": "Export registrations to Mailchimp or similar",
            "bracketsAndScheduling": "Brackets & Scheduling",
            "automaticBracketGeneration": "Automatic bracket generation",
            "dragAndDropOfBracket": "Drag and drop of bracket planning",
            "realTimeEstimation": "Real time estimation",
            "tvModeForSchedules": "TV-Mode for schedules",
            "worksSeamlesslyWith": "Works seamlessly with the bracket system",
            "theScoreboardIsReady": "The scoreboard is ready to be launched directly from your bracket page. When the game is over you just continue onto the next game and start taking scores.",
            "tabletAndDesktopReady": "Tablet & desktop ready",
            "embedScoreboard": "Embed scoreboard in streaming",
            "freeAppForMacAndPc": "Free app for Mac and PC with dedicated TV-Mode",
            "connectYourComputer": "Connect your computer to the biggest screen you can find and everybody will feel like world champions.",
            "podium": "Podium",
            "rankingListsForBest": "Ranking lists for best team, club, junior, adult and more",
            "publicResultPage": "Public result page after the event",
            "tvModeForPrice": "TV-Mode for awarding ceremony",
            "livestreaming": "Livestreaming",
            "addPpvToYour": "Add PPV (Pay per view) to your event",
            "integratedScoreboard": "Integrated scoreboard in streaming",
            "youtubeStreaming": "Youtube streaming",
            "worksWithAllSoftwares": "Works with all softwares, for example Ecamm, OBS and vMix",
            "freeStreamingApp": "Free streaming App for iPhone, iPad & Android",
            "pavingTheWayFor": "Paving the way for federations across all sports",
            "membershipManagement": "Membership management for athletes and academies",
            "yourOwnLandingPage": "Your own landing page with your own subdomain",
            "rankingListsWith": "Ranking lists with support for seasons and tours",
            "importAndExportWith": "Import and export with custom metadata",
            "nameOfOrganization": "Name of organization",
            "becomeAnOrganizer": "Become an Organizer",
            "noOneTournamentSoftwareTitle": "Get the #1 tournament software for {sport}",
            "noOneTournamentSoftwareHeading": "<strong>Get the <span>#1</span> tournament software for <span>{sport}</span></strong>",
            "worksWithAnyBarcode": "Works with any QR and barcode reader",
            "instantWeighinsWithOur": "Instant weighins with our supported smart-scales",
            "simplePricing": "Simple pricing.",
            "OneCreditOneParticipant": "1 credit = 1 athlete",
            "payAsYouGo": "Pay as you go",
            "OneEurCredit": "<strong>1.25 EUR </strong>/ credit",
            "buyOneThousandCredits": "Buy 1000 credits",
            "oSevenFiveEurCredit": "<strong>0.9 EUR </strong>/ credit",
            "buyFiveThousandCredits": "Buy 5000 credits",
            "oFiveZeroEurCredit": "<strong>0.6 EUR </strong>/ credit",
            "whatCountsAsAParticipant": "What counts as an athlete?",
            "aParticipantIsOne": "An athlete is one individual competitor per event. They can register in multiple entries and still only count as one credit. If an athlete drops out before the event, you keep the credit.",
            "differentPercentageForDifferentOccasions": "Different percentage for different occasions. Can be handed out as cash or in coupons.",
            "poweredByTheBracket": "Powered by the bracket system – and you",
            "theDigitalScoreboardInstantlyConnects": "The digital scoreboard instantly connects with your competition at Smoothcomp.                 It’s as easy as clicking “Go to scoreboard” in the bracket. When the match is done, click “Go to next match”.",
            "dedicatedTvMode": "Dedicated TV mode with dual displays",
            "theTvWillDisplay": "The TV will display a clean scoreboard without any buttons. Buttons are only visible to the scorekeeper.",
            "freeDownload": "Free download",
            "sinceSmoothcompIntroduced": "Since Smoothcomp introduced the multi-sport scoreboard, it has enabled tournaments around the world to highlight scores in better ways. Pushing the experience closer to people.",
            "universalScoreboard": "Universal scoreboard",
            "canBeUsedForAnySport": "Can be used for any sport with (or without) clock and points.",
            "genericKataPatternScoreboard": "Generic kata/pattern scoreboard",
            "canBeUsedForGenericPerformances": "Can be used for generic performances.",
            "competitionWithoutThePaperwork": "Competition without the paperwork",
            "smoothcompHasEnabledTournaments": "Smoothcomp has enabled tournaments around the world to run smoother. Pushing the experience closer to people every day.",
            "shareTheMoments": "Share the moments.",
            "streamAndRecordYourEvent": "Stream and record your event.",
            "theSmoothstreamerAppAllows": "The Smoothstreamer app allows you stream events with overlays for scoreboard and the Tale of the Tape.",
            "startStreamingInSeconds": "Start streaming in seconds",
            "createANewStream": "Create a new stream",
            "scanTheQr": "Scan the QR",
            "startStreaming": "Start streaming",
            "scoreboardOverlay": "Scoreboard overlay",
            "theScoreboardLivesOnline": "The scoreboard lives online, and our solution automatically overlays it into the stream. If you use the Smoothstreamer app, this process is fully automated. If you use third-party software, you only need to overlay a webpage to get started.",
            "streamAnywhere": "Stream anywhere",
            "streamAnywhereAnd": "... and Baller TV, Dacast, FITE, FloSports and hundreds of more services. <span class=\"highlight\">Any platform that supports RTMP(S) or SRT.</span>",
            "getPaidWithPayPerView": "Get paid with Pay per view (PPV)",
            "ifYouWantToLivestreamYourEvent": "<p>If you want to livestream your event and monetize it as a pay-per-view option, we have built a groundbreaking solution called Smoothcomp TV. </p><p>When livestreaming to Smoothcomp TV it will use our cut & connect technology and cut each match into individual files and connect them to the brackets and user profiles.</p><p>The watchpage has search and filters that will give the user a truly unique watch experience.</p>",
            "buildYourOwnPlatform": "Build your own platform and stream or upload your videos, sell subscriptions and PPV´s.",
            "goingPro": "Going pro?",
            "runAMultiCameraSetup": "Run a multi camera setup with scoreboard overlays.",
            "weGotYouCovered": "We got you covered. Our solution supports most streaming softwares such as Ecamm and OBS for Mac or vMix for PC.",
            "streamAnywhereSupportBoth": "<span>Stream anywhere.</span> Support both RTMP(S) and SRT. Stream to YouTube, Vimeo, Rokfin, Flo and much more.",
            "overlay": "<span>Overlay.</span> Automatically overlays the scoreboard.",
            "yourEverydaySportCompanion": "Your everyday sport companion",
            "participateAndFollowEvents": "Participate and follow events, athletes and family around the world. Build your profile and celebrate victories.",
            "followEventsAndAthletes": "Follow events and athletes and get real time notifications on things that matter to you as an athlete, coach or parent.",
            "turnOnNotifications": "Turn on notifications to receive important updates and changes.",
            "proFeature": "Pro Feature",
            "stayConnectedNeverMiss": "Stay connected. Never miss a match.",
            "trackYourMatchesWithLive": "Track your matches with a live countdown. Updated in real time on your lock screen.",
            "upgradeToPro": "Upgrade to Pro",
            "limitedLifetimeOffer": "Limited Life-time Offer",
            "countdownOnLockScreen": "Countdown on Lock Screen",
            "followEvents": "Follow Events, Academies & Friends",
            "fullAccessToNotifications": "Full access to all notifications",
            "getNotifiedTenMinutes": "Get notified 10 min before match",
            "beFirstToTryNew": "Be first to try new Pro features",
            "lastMinuteChanges": "Last minute changes notifications",
            "stayAheadOfYourNextMatches": "Stay Ahead of Your Next Matches",
            "livestream": "Livestream",
            "goLiveShareTheMoments": "Go Live. Share the Moments with Cutting Edge Streaming.",
            "orUseOwnSetup": "Or use own setup - like OBS or vMix",
            "goLiveInSeconds": "Go Live in Seconds - Easy as 1-2-3",
            "letUsCreateTheStream": "Let us create the stream",
            "goLive": "Go live",
            "setTheStageWith": "Set the Stage with",
            "yourOwnStreamingPlatformOn": "Your own streaming platform on Smoothcomp",
            "weCutConnectAndMakeEach": "We cut, connect & make each match searchable",
            "searchAndFilterTheMatch": "Search and filter the match you’re looking for. Each match are turned into an experience to watch live or as a replay.",
            "onlyWith": "Only with",
            "createYourOwnPpvPackages": "Create your own Pay Per View Packages (PPV)",
            "sellAccessToYourStreams": "Sell access to your streams via packages that you can create on your own. Get insights of your statistics and sales via our analytics tools.",
            "replaysDirectlyInTheBracket": "Replays directly in the bracket",
            "replaysAreInstantlyGenerated": "Replays are instantly generated to each match in the bracket. Just tap on any match to catch the replay!",
            "smoothcompTvYoutubeFacebook": "Smoothcomp TV, YouTube, Facebook and anywhere else. Support both RTMP(S) and SRT.",
            "customStreamQuestion": "Custom Stream?",
            "runAMultiCameraSetupWithObs": "Run a Multi Camera Setup with OBS, Ecamm or vMix",
            "cantFindYourSport": "Can’t find your sport?",
            "letsTalk": "Let’s talk",
            "grapplingSports": "Grappling<br><span>Sports</span>",
            "otherSports": "Other<br><span>Sports</span>",
            "supportedSports": "Supported sports",
            "easySetup": "Easy setup.",
            "scanTheQrStart": "Scan the QR code. Start streaming!",
            "graphics": "Graphics.",
            "scoreboardAndTaleOfTheTape": "Scoreboard and Tale of the Tape overlayed – automatically.",
            "autoCut": "Auto cut",
            "weCutAndConnectYourMatches": "We cut and connect your matches and brackets. No more day-long streams.",
            "noUpfrontCosts": "No upfront costs",
            "boostYourIncomeWithRevshare": "Boost your income with revshare that is split automatically and hassle-free.",
            "upToFourMatches": "Up to 4 matches at once",
            "aLotGoingOnChoose": "A lot going on? Choose which matches you like to watch.",
            "setYourOwnPrices": "Set your own prices",
            "createYourOwnStreamingPackages": "Create your own streaming packages and gain insights on sales and statistics.",
            "theScoreboardClockAndTale": "The Scoreboard, Clock and Tale of the Tape can be overlayed in OBS, vMix and many softwares. Automatically and customizable.",
            "flexibleSolution": "Flexible Solution.",
            "supportForBothRtmpAndSrtUse": "Support for both RTMP(S) and SRT streams. Use multiple cameras and audio equipment in your production together with your graphics.",
            "recordAndStore": "Record and Store.",
            "ifYouDontHaveEnoughBandwidth": "If you don’t have enough bandwidth to stream the whole event you can record it and upload later to YouTube.",
            "mixed": "Mixed",
            "grappling": "Grappling",
            "standUp": "Stand Up",
            "setYourOwnPrice": "Set your own price",
            "turnsEveryMatchInto": "Turns every match into its own clip",
            "multiWindowViewWithFilters": "Multi-window-view with filters",
            "seeAllFeatures": "See all features",
            "revenueShare": "Revenue Share",
            "noUpfrontFees": "No Upfront Fees.",
            "riskFreeRevshare": "Risk Free Revenue Share.",
            "weShareTheRevenueOf": "We share the revenue of the sold streaming tickets. If you sell, you earn. If you don’t sell, you owe nothing.",
            "starter": "Starter",
            "greatForFriendsAndFamily": "Great for friends & family events with multiple mats and day-long streaming.",
            "youKeepPercentageOfTheStreamingSales": "You keep 60% of the streaming sales. 40% is used to cover bandwidth, storage, and streaming technology.",
            "premium": "Premium",
            "greatForSuperfightEventsWith": "Great for superfight events with more paying viewers and fewer streaming minutes.",
            "higherRevshareAvailable": "Higher revenue share available.",
            "contactUsOnceYouHaveSigned": "Contact us once you have signed up for Starter",
            "getPaidForLivestreaming": "Get Paid for Livestreaming with Smoothcomp PPV",
            "forGrasrootsEvents": "For grassroots events to high-profile championships",
            "getYourOwnStreamingPlatform": "Get your own streaming platform on Smoothcomp and sell streams on Pay Per View. Individual matches are cut automatically and made searchable.",
            "getStartedWithPpv": "Get started with PPV",
            "ppvPlatformOnSmoothcomp": "PPV Platform on Smoothcomp",
            "watchExample": "Watch example",
            "noOneTournamentSoftwareForHero": "<span>No 1 </span><strong>tournament software for combat sports</strong>",
            "bestTournamentSoftwareFor": "The best tournament software for {sport}",
            "reachOurGlobalCommunityOfPlayers": "<strong>Reach our global community</strong> of 1 million players.",
            "singleElimination": "Single elimination",
            "doubleElimination": "Double elimination",
            "roundRobin": "Round robin",
            "threePlayersWithComeback": "3 players with comeback",
            "multistage": "Multistage",
            "votingWithJudgesScore": "Voting with judges score",
            "placementBracket": "Placement bracket",
            "twoPlayersBestOfThree": "2 players - best of three",
            "pavingTheWayForFederations": "Paving the way for federations across all sports",
            "standUpSports": "Stand Up <br> <span>Sports</span>",
            "mixedSports": "Mixed <br> <span>Sports</span>"
        },
        "event": {
            "termsOfService": "Terms of service",
            "detectedPosition": "Detected position",
            "hideMap": "Hide map",
            "showMap": "Show map",
            "sortByDistance": "Sort by distance",
            "sortByDate": "Sort by date",
            "eventsNearMe": "Events near me",
            "eventsInsideMap": "Events inside map",
            "moreEvents": "More events",
            "visibilityWarning": "This event is only visible for you. Change <a href='{link}' class='alert-link'>event visibility</a> when you are ready to go public.",
            "bracketsUnpublishedWarning": "This event`s brackets are only visible for you. <a href='{link}' class='alert-link'>Publish brackets</a> when you are ready to go public.",
            "shared_on": "Shared on",
            "share_on_fb": "Share on Facebook",
            "remember_to_change_start_time": "Remember to also change the start times for the <a href=\"{route}\">mats</a> if necessary",
            "pre_check_in": "Pre-check-in",
            "pre_check_in_desc": "Enable an extra check-in option <span class=\"muted\">(for example interview or medical clearance)</span>",
            "registration_periods": "Registration periods",
            "max_registrations": "Max registrations",
            "max_registrations_desc": "Max capacity of registrations on this event",
            "normal_reg_period": "Normal",
            "late_fee": "Late fee",
            "late_fee_desc": "Offer a higher price after normal registration period",
            "hide_registrations_list": "Hide registrations lists",
            "hide_incomplete_registrations": "Hide incomplete registrations in registrations list",
            "visibility": {
                "hidden": "Only organizer",
                "unlisted": "Everyone with a direct link",
                "public": "Everyone, also include in {name} event calendar",
                "unpublished": "Unpublished by Smoothcomp admin",
                "none_selected": "None selected"
            },
            "hide_name_over_image": "Hide event name over cover image",
            "arena_name": "Arena name",
            "hide_location_and_accommodations": "Hide Location and accommodations",
            "cover_image_recommendations": "Upload an image for your event. Optimal size is 845x315, but otherwise it will be fitted automatically.",
            "registration_info_desc": "Shown to athletes above entry selection in the registration checkout.",
            "entry": {
                "create": "Create new entry",
                "new_from_scratch": "New from scratch",
                "add_new": "Add new entry"
            },
            "entries": {
                "duplicate_from_events": "Duplicate from your events",
                "duplicate_from_federation": "Duplicate from {name} template",
                "create": {
                    "event_required": "You need to choose Event",
                    "entries_required": "You need to choose entries to duplicate.",
                    "title_required": "Entry title is required"
                },
                "problem_occured": "Problem occured, action not saved",
                "normal_class": "Normal class",
                "weight_class": "Weight class",
                "creates_division": "Creates division",
                "add_new_value": "Add new value",
                "new_class": "New class",
                "value_settings": "Value settings",
                "weight_limits": "Weight limits",
                "rule_name": "Rule name",
                "light_weight": "Light weight",
                "choose_field": "Choose field",
                "choose_type": "Choose type",
                "age_year_only": "User: Age, year only",
                "age_on_event_day": "User: Age, on event start day",
                "gender": "User: Gender / Sex",
                "skill": "Skill",
                "classes": "Classes",
                "settings_pricing": "Settings & pricing",
                "custom_rule_name": "Custom rule name",
                "belt": "Belt"
            },
            "select_entries": "Select entries",
            "seed_options": {
                "title": "Seed options <span class=\"mute\">(single and double eliminations)</span>",
                "separate_seed_by": {
                    "desc_1": "Avoid team mates and nations facing each other.",
                    "desc_2": "When creating brackets, athletes will be placed (seeded) automatically and random. Although, to avoid team mates or nations facing each other in the first match we can separate the seed and place athletes as far away from each other as possible.",
                    "title": "Separate seed by"
                },
                "seed_by_rank": "Seed by rank",
                "activate_ranking_positions": "Activate ranking positions",
                "activate_ranking_positions_desc": "This option allows you to assign ranking numbers in the registrations list. Those ranking numbers will later be taken into account when creating the seeds.",
                "ranks_from_toplists": "Relate bracket seed to federation ranking. <span class=\"mute\">(Add lists below)</span>"
            },
            "brackets": {
                "repechage": {
                    "how_many": "How many will able to qualify to the loser bracket",
                    "required_amount": "Requires {amount} athletes"
                },
                "manage_packages": "Manage bracket packages",
                "automatic_packages": "Automatic bracket packages",
                "manual_brackets": "Manual brackets",
                "select_bracket_type": "Select bracket type",
                "calculate_placements_by": "Calculate placements by",
                "edit_packages": "Edit Bracket Packages",
                "rules": "Bracket rules",
                "amount_of_players": "Amount of athletes",
                "use_bracket": "Use bracket",
                "add_interval": "Add interval",
                "tiebreaker_settings": "Tiebreaker Settings"
            },
            "discounts": {
                "if_registered_for_entry": "If one of these are registered",
                "together_with": "together with one of these",
                "how": {
                    "in_discount": "In discount on their total",
                    "in_coupon_code": "In a coupon code"
                },
                "save": "Save discount"
            },
            "applicable_coupon_codes": "Applicable coupon codes for this event",
            "coupons": {
                "view_all": "View all coupon codes for all your events"
            },
            "livestreams": {
                "status": "Livestream status <span class=\"muted\">only visible for you</span>",
                "create": "Create live stream",
                "no_more_streams": "No more streams to create",
                "test_stream": "Test stream",
                "test_stream_label": "Create a test stream (only visible for you)",
                "link_account_required": "You have to link an account to be able to create new streams."
            },
            "match_rest_settings": "Match rest settings",
            "rest": {
                "min": "Minimum rest",
                "before_final": "Rest before final"
            },
            "points": {
                "dont_give_points_if": "Do not give points if division has",
                "dont_give_points_or": "or less athletes"
            },
            "toplist_name_and_type": "Top list name and type",
            "toplist_name": "Top list name",
            "toplists": {
                "do_not_give_points_if": "Do not give points if division only have players from the same",
                "offset_rules_applies": "Offset ranking rules applies",
                "offset_rules_desc": "With offset ranking rules you are able to manually give or deduct points.",
                "filter": {
                    "is": "is",
                    "is_not": "is not",
                    "contains": "contains",
                    "doesnt_contain": "does not contain",
                    "starts_with": "starts with",
                    "does_not_contain": "does not contain"
                }
            },
            "statistics": {
                "cancel_event_and_refund_players": "Cancel event and refund players"
            },
            "import": {
                "country_format": "Country format",
                "country_format_more_info": "For more info see <a href=\"https://www.adducation.info/general-knowledge-travel-and-transport/international-country-codes/\" target=\"_blank\">comparison between country formats</a> (opens in new window)",
                "set_country_to": "Set country to",
                "set_approved_to": "Set approved to",
                "import_settings": "Import settings",
                "set_status_to": "Set status to"
            },
            "save_toplist": "Save top list",
            "no_previous_seasons": "No previous seasons",
            "noEntriesWarning": "This event does not have any entries to register for. Please add at least one <a href=\"{link}\" class=\"alert-link\">entry</a>.",
            "noOrganizationCurrencyWarning": "Add a <a href=\"{link}\" class=\"alert-link\">currency</a> to your organizer account in order to be able to publish the event.",
            "noOrganizationPaymentMethodWarning": "Add a <a href=\"{link}\" class=\"alert-link\">payment solution</a> to your organizer account in order to be able to publish the event.",
            "tiebreaker": {
                "public_tiebreaker_result": "Show public tiebreaker results"
            },
            "all_seasons": "All seasons",
            "show_public_event_credentials": "Enable public credentials download",
            "hide_public_registration_weighin": "Hide weigh in value in public registration list",
            "bout-schedule": "Activate bout scheduler",
            "bout_schedule": "Bout scheduler",
            "type_your_text": "Type your text here...",
            "unpublishedWarning": "This event has been unpublished by a Smoothcomp admin. If you want to know why, please contact us for more information.",
            "noEntryWithinWeek": "To publish your event, you need to have an <a href=\"{link}\" class=\"alert-link\">entry</a> where the registration start is at least seven days ahead of the event start.",
            "eventInTrashbinWarning": "This event is currently in the trashbin. To publish it, please <a href=\"{link}\" class=\"alert-link\">restore</a> it from the trashbin first.",
            "trashbin_warning": "If the chosen event is currently published it will be unpublished, are you sure you want to continue?",
            "noContactsWarning": "This event has no <a href=\"{link}\" class=\"alert-link\">contact information</a>. If you wish to publish the event, contact information needs to be added first.",
            "noPaymentMethodWarning_noLink": "Add a payment solution to your organizer account in order to be able to publish the event.",
            "noContactsWarning_noLink": "This event has no contact information. If you wish to publish the event, contact information needs to be added first.",
            "noCurrencyWarning_noLink": "Add a currency to your organizer account in order to be able to publish the event.",
            "hide_birth_registrations_list": "Hide birth year in public registrations list",
            "matchPoints": "Points: {left} - {right}",
            "matchTime": "Time: {time}",
            "matchDetails": "Match details",
            "resolveCancelled": "Resolve cancelled",
            "openJudge": "Open {name}",
            "teamScoreBreakdown": "Team score breakdown",
            "multipleRegistrations": "Multiple registrations",
            "displayAndCountEntries": "Display and count entries in public registrations and on the first page under entries",
            "teamCompetitionDescription": "Team competition (only activate this for team versus team competition using this entry)",
            "requestEstimatedWeight": "Request athlete to input expected weigh-in weight upon registration (applies to classes that activate the weight-class setting)",
            "nandu": "Nandu",
            "useWushuNandu": "Use Wushu Nandu (used by C-Judges) on this entry",
            "wushuStyleNorthern": "Northern (Changquan, Jianshu, Daoshu, Qiangshu and Gunshu)",
            "wushuStyleSouthern": "Southern (Nanquan, Nandao and Nangun)",
            "wushuStyleTaiji": "Taiji (Taijiquan, Taijijian and Taijishan)",
            "useEventRegistrationDates": "Use registration dates from event settings",
            "whenNormalStarts": "(when normal starts)",
            "whenNormalEnds": "(when normal ends)",
            "earlyBirdPrice": "Early bird price",
            "totalAmount": "(total amount)",
            "activateInEventSettings": "(activate in event settings)",
            "normalPrice": "Normal price",
            "latePrice": "Late price",
            "onlyAvailableFor": "Only available for",
            "onlyAvailableForDescription": "To be able to register for this entry you can set that a user must also register in another entry first before they can register for this one.",
            "notAvailableFor": "Not available for",
            "notAvailableForDescription": "To be able to register for this entry you can set that a user cannot be registered for any of the following entries.",
            "maxRegistrationsQuestion": "How many times can a single user register for this entry?",
            "times": "Times",
            "entryCannotBeDeleted": "This entry cannot be deleted",
            "deleteEntryAndClassesConfirm": "Delete entry and classes?",
            "deleteEntry": "Delete entry",
            "className": "Class name",
            "guardianInformationProvided": "Guardian information must be provided for athletes who haven't had their {age} birthday.",
            "reloadSchedule": "Reload schedule",
            "bracketMissing": "Bracket missing",
            "missingBracketId": "Missing bracket_id = {id}",
            "bundleSettings": "Bundle settings",
            "unableToLoadMats": "Unable to load mats",
            "addToplist": "Add toplist",
            "bracketSettingsTitle": "Bracket settings",
            "liveTeamScoresTitle": "Live team scores (adapted for US Wrestling rules)",
            "activateTeamScores": "Activate team scores",
            "scoringAthletesDesc": "Each academy/school assigns a number of scoring athletes per event. Points determined according to the National Federation of State High School Associations rules. Intended for Double Elimination bracketing.",
            "maxScoringAthletesForEvent": "Max scoring athletes for the event",
            "maxScoringAthletesPerBracket": "Max scoring athletes per bracket/division",
            "showAccumulatedAcademyScores": "Show accumulated academy scores",
            "showAccumulatedTeamScores": "Show accumulated team scores",
            "showAccumulatedAthleteScores": "Show accumulated athlete scores",
            "doubleEliminationRepechageTitle": "Double elimination repechage",
            "crossBracketing": "Cross bracketing",
            "crossBracketingDesc": "Determines how the repechage places matches",
            "rrTiebreakSettings": "Tiebreaker settings for Round Robin",
            "rrTiebreakSettingsHtml": "Tiebreaker settings <span class=\"mute\">for Round Robin</span>",
            "finishedMatches": "Finished matches",
            "currentlyApprovedUsers": "Currently approved users",
            "prevApprovedUsers": "Previously approved users",
            "refundedUsers": "Refunded users",
            "totalCreditsDrawn": "Total credits drawn from wallet",
            "regByCountry": "Approved registrations by country",
            "regByAcademy": "Approved registrations by academy",
            "regByTeam": "Approved registrations by team",
            "entryX": "Entry {entry}",
            "organizerNotes": "Organizer notes",
            "public": "Public",
            "statusWeighIn": "Status (weigh-in)",
            "somethingWentWrong": "Something went wrong while retrieving event information, please try again later!",
            "matchNotFound": "Match not found",
            "bookedEvents": "Booked events",
            "competitionHistory": "Competition history",
            "periodsMustBeInOrder": "Registration periods must be in order (early bird, registration, late entry). Check that your dates do not overlap.",
            "endAndStartMustBeConnected": "Early bird end and registration start must be connected (same datetime or consecutive minutes, e.g. 23{59} / 00{00}).",
            "endAndLateStartMustBeConnected": "Registration end and late entry start must be connected (same datetime or consecutive minutes, e.g. 23{59} / 00{00}).",
            "eventInTrashbinWarning_noLink": "This event is currently in the trashbin. To publish it, please restore it from the trashbin first.",
            "deletePage": "Delete page?",
            "allEntries": "All entries",
            "registrations": "Registrations",
            "addVerificationRule": "Add verification rule",
            "deleteDiscountConfirm": "Are you sure you want to delete this discount?",
            "needToEnterFee": "You need to enter early bird, normal and late fee",
            "addRound": "Add round",
            "teamMatch": "Team match",
            "roundNrTo": "Round {round} {last}",
            "bracketStartedUnableToMoveReg": "{bracket} bracket already started, unable to move registrations",
            "bracketStartedUnableToMoveGroup": "{bracket} bracket already started, unable to move to group",
            "classDeactivated": "Class deactivated.",
            "activateValueToActivateClass": "Activate value to activate class.",
            "addValueToActivateClass": "Add value to activate class.",
            "createDivisionBasedOnThese": "Create divisions on registration page based on these values",
            "moveUp": "Move up",
            "moveDown": "Move down",
            "deactivateClass": "Deactivate class",
            "activateClass": "Activate class",
            "deleteClass": "Delete class"
        },
        "app": {
            "about": "About",
            "aboutSmoothcomp": "About Smoothcomp",
            "aboutUs": "About us",
            "academy": "Academy/Club",
            "academyName": "Academy name",
            "academyNotConfirmed": "Academy not confirmed",
            "account": "Account",
            "add": "Add",
            "addCouponCode": "Add coupon code",
            "addFighter": "Add athlete",
            "addFighters": "Add athletes",
            "addLabel": "Add label",
            "addNote": "Add note",
            "address": "Address",
            "advancedOptions": "Advanced options",
            "affiliationManager": "Affiliation manager",
            "affiliationTeam": "Affiliation/Team",
            "all": "All",
            "allBrackets": "All brackets",
            "allRegistrationsAreAlreadyChecked": "All registrations are already checked",
            "amount": "Amount",
            "approved": "Approved",
            "approveFederationMember": "Approved Federation Member",
            "areYouSureThisCantBeUndoned": "Are you sure? This can’t be undone",
            "back": "Back",
            "batchCreateBrackets": "Batch create brackets",
            "beReadyInBullPen": "Be ready in bull pen",
            "birth": "Birthyear",
            "birthdate": "Birthdate",
            "born": "Born",
            "bracketsC": "Bracket|Brackets",
            "bracketType": "Bracket type",
            "bracketsAndScheduleNav": "Brackets<span class=\"hidden-xs\"> & schedule</span>",
            "bracketsAreUpdatedDoYouWantToRedraw": "Brackets are updated. Do you want to redraw the brackets?",
            "bracketsFlaggedForAttention": "Brackets flagged for attention",
            "calendar": "Calendar",
            "cancel": "Cancel",
            "cancelledByOrganizer": "Cancelled by organizer",
            "cantFindYourAcademy": "Can't find your Academy?",
            "cardNumber": "Card number",
            "categories": "category|categories",
            "categoriesC": "Category|Categories",
            "changeStatus": "Change status",
            "checkout": "Checkout",
            "chooseAcademy": "Choose academy",
            "chooseAffiliation": "Choose affiliation",
            "chooseClub": "Select academy / club",
            "chooseExistingGroup": "Choose existing group",
            "chooseOrganization": "Choose organization",
            "city": "City",
            "close": "Close",
            "closeWeighIn": "Close weigh-in",
            "clubs": "club|clubs",
            "clubsC": "Club|Clubs",
            "coach": "Coach",
            "coachManager": "Coach manager",
            "coachRegistration": "Coach registration",
            "comment": "Comment",
            "confirmation": "Confirmation",
            "confirmEmail": "Confirm email",
            "confirmPassword": "Confirm password",
            "contact": "Contact",
            "contactAndResidence": "Contact & residence",
            "continueToPayment": "Continue to payment",
            "copy": "Copy",
            "copyRegistrations": "Copy registrations",
            "country": "Country",
            "countryOfResidence": "Country of residence",
            "couponCode": "Coupon code",
            "couponCodes": "Coupon codes",
            "couponsC": "Coupon|Coupons",
            "coverImage": "Cover image",
            "createBracket": "Create bracket",
            "createEmptyGroup": "Create empty group",
            "createGroup": "Create group",
            "createNewGroup": "Create new group",
            "createUser": "Create user",
            "credentials": "Credentials",
            "creditCard": "Credit card",
            "currentlyFighting": "Currently ongoing",
            "currentMatches": "Current matches",
            "date": "Date",
            "day": "Day",
            "defineInExactNumberOrRange": "Define in exact number or a range. Separate by comma (,)",
            "division": "Division",
            "download": "Download",
            "dragTheImageToPosition": "Drag the image to position",
            "edit": "Edit",
            "editSeed": "Edit seed",
            "editSchedule": "Edit schedule",
            "eliminationStage": "Elimination stage",
            "email": "Email",
            "emptyGroup": "Empty group",
            "entries": "entry|entries",
            "entriesC": "Entry|Entries",
            "estimated": "Estimated",
            "estimatedTimePerMatch": "Estimated time per match",
            "etaEnd": "Eta end",
            "event": "Event",
            "events": "Events",
            "eventCalendar": "Events",
            "eventStarts": "Event starts",
            "expired": "Expired",
            "expiredFederationMember": "Expired Federation Member",
            "expires": "Expires",
            "extendedInfo": "Extended info",
            "featuresAndPricing": "Features & pricing",
            "federationPlatform": "Federation Platform",
            "fighterNotWeighedIn": "Athlete not weighed in",
            "fighterReadyToGo": "Athlete ready to go",
            "fighters": "athlete|athletes",
            "filter": "Filter",
            "filterOnClub": "Filter on club",
            "filterOnEntry": "Filter on entry",
            "filterOnMat": "Filter on mat",
            "filteredOf": "Filtered: {filtered} of {total}",
            "filteredOfName": "Filtered {filtered} of {total} {name}",
            "findGroupsWith": "Find groups with",
            "findMatches": "Find matches",
            "findParticipantsWithPlacement": "Find athletes with placement",
            "finished": "Finished",
            "firstName": "First name",
            "gameType": "Game type",
            "gender": "Gender",
            "goToBullPen": "Go to bull pen",
            "groups": "group|groups",
            "groupsC": "Group|Groups",
            "haveBrackets": "Have brackets",
            "hidePendingParticipants": "Hide pending athletes",
            "import": "Import",
            "information": "Information",
            "informationNav": "Info<span class=\"hidden-xs\">rmation</span>",
            "invalidCoupon": "Invalid coupon",
            "invalidObject": "Invalid object",
            "lastName": "Last name",
            "lateRegistration": "Late registration",
            "location": "Location",
            "matches": "match|matches",
            "matchesCanHaveMultipleRounds": "Matches can have multiple rounds, see below",
            "mats": "mat|mats",
            "matsC": "Mat|Mats",
            "matSettings": "Mat settings",
            "memberCard": "Member card",
            "memberships": "Memberships",
            "middleName": "Middle name",
            "month": "Month",
            "move": "Move",
            "moved": "Moved",
            "moveRegistration": "Move registration",
            "moveRegistrations": "Move registrations",
            "moveRegistrationsTo": "Move registrations to",
            "moveRegistrationsToNewGroup": "Move registrations to new group",
            "name": "Name",
            "nationality": "Nationality",
            "next": "Next",
            "newGroupName": "New group name",
            "noAssignedOrganizations": "No assigned organizations",
            "noBrackets": "No brackets",
            "noEntries": "No entries",
            "noIllDoItManually": "No, I'll do it manually",
            "noMatchesToDisplay": "No matches to display",
            "noMatsToDisplay": "No mats to display",
            "noShowMissedWeight": "No-show/missed weight",
            "notApproved": "Not approved",
            "notApprovedRegistrations": "Not approved registrations",
            "note": "Note",
            "notFederationMember": "Not a Federation Member",
            "noTeamAssociation": "No team/association",
            "notPaid": "Not paid",
            "notPaidApprovedInTime": "Not paid/approved in time",
            "normalRegistration": "Normal registration",
            "numberOfParticipantsInEachGroup": "Number of athletes in each group",
            "numberThatQualifiesToEliminationRound": "Number that qualifies to elimination round, from each group",
            "okChangeStatus": "Ok, change status",
            "oneInMostSports": "1 in most sports but some have multiple rounds with short rest in between",
            "optional": "optional",
            "orderHistory": "Order history",
            "organizer": "Organizer",
            "organizerManager": "Organizer manager",
            "paid": "Paid",
            "participants": "athlete|athletes",
            "participantsHaveBeenUpdated": "Athletes have been updated. Please check the seed.",
            "pastEvents": "Past events",
            "password": "Password",
            "pay": "Pay",
            "payLater": "Pay later",
            "payment": "Payment",
            "paymentMethod": "Payment method",
            "payRenew": "Pay/renew",
            "pendingFederationMember": "Pending Federation Member",
            "pendingParticipants": "Pending athletes",
            "pendingRegistrations": "Pending registrations",
            "phone": "Phone",
            "pleaseEnterYourMobileNumber": "Please enter your mobile number",
            "price": "Price",
            "proceed": "Proceed",
            "product": "Product",
            "profileImage": "Profile image",
            "profileSettings": "Profile settings",
            "provinceState": "Province/State",
            "publicNote": "Public note",
            "qualifierStage": "Qualifier stage",
            "rank": "Rank",
            "refundCancel": "Refund/Cancel",
            "register": "Register",
            "registerFor": "Register for",
            "registerNew": "Register new",
            "registerToEvent": "Register to event",
            "registrationInfo": "Registration info",
            "registrations": "registration|registrations",
            "registrationsC": "Registration|Registrations",
            "rejected": "Rejected",
            "rejectedFederationMember": "Rejected Federation Member",
            "removeImage": "Remove image",
            "restBetweenRounds": "Rest between rounds",
            "result": "Result",
            "results": "Results",
            "resultPlacementInBracket": "Result/Placement in bracket",
            "restoreRegistration": "Restore registration",
            "roundsPerMatch": "Rounds per match",
            "running": "Running",
            "save": "Save",
            "saveAndContinue": "Save and continue",
            "saveAndKeep": "Save & keep",
            "saveChanges": "Save changes",
            "saveFor": "Save for",
            "saveLabel": "Save label",
            "saveName": "Save name",
            "scheduleSettings": "Schedule settings",
            "scoreboard": "Scoreboard",
            "search": "Search",
            "searchEvent": "Search event...",
            "searchFighter": "Search athlete",
            "searchName": "Search name",
            "seeBracketsAndSchedule": "See brackets and schedule",
            "select": "Select",
            "selectCountries": "Select countries",
            "selectCountry": "Select country",
            "selectGameTypes": "Select game types",
            "selectGender": "Select gender",
            "selectGroupAutomatically": "Select group automatically",
            "selectGroupManually": "Select group manually",
            "selectImage": "Select image",
            "selectNewImage": "Select new image",
            "selectOption": "Select option",
            "selectParticipantsToViewEventCards": "Select athletes to view event cards",
            "selectedUser": "Selected user",
            "settings": "Settings",
            "showEmptyGroups": "Show only empty groups",
            "showBracketsThatMightHaveIncorrectSeeds": "Show brackets that might have incorrect seeds",
            "showMoreResults": "Show more results",
            "showPublished": "Show published",
            "showRegistrations": "Show registrations",
            "showUnpublished": "Show unpublished",
            "somethingWentWrong": "Something went wrong",
            "statistics": "Statistics",
            "status": "Status",
            "statusNote": "Status note",
            "teamName": "Team name",
            "teams": "team|teams",
            "teamsC": "Team|Teams",
            "termsAndConditions": "Terms and Conditions",
            "termsOfService": "Terms of Service",
            "theFunctionCloseWeighIn": "The function \"close weigh-in\" is used when you use a separate weigh-in before the event, with a set closing time. It is not intended for weigh-in by the mat.",
            "thisIsTheListYourParticipantsSee": "This is the list that your athletes see",
            "timePerMatch": "Time per match",
            "timePerRound": "Time per round",
            "timesAreDynamicWatchThisScreen": "Times are <strong>dynamic</strong> and change in real time. Watch this screen for updates.",
            "timezone": "Timezone",
            "toBeDecided": "To be decided",
            "today": "Today",
            "toggleAll": "Toggle all",
            "toggleDropdown": "Toggle dropdown",
            "toplistSettings": "Ranking settings",
            "total": "Total",
            "totalEta": "Total eta",
            "totalFighters": "Total athletes",
            "totalGroups": "Total groups",
            "trashed": "Trashed",
            "type": "Type",
            "unknown": "Unknown",
            "unpaid": "Unpaid",
            "upcomingEvents": "Upcoming events",
            "userDetails": "User details",
            "usersData": "Users' data",
            "viewBracket": "View bracket",
            "viewMat": "View mat",
            "viewPublicParticipantsList": "View public athletes list",
            "waiting": "Waiting",
            "waitingForPaymentApproval": "Waiting for payment/approval",
            "weight": "Weight",
            "weigh-in": "Weigh-in",
            "withSelected": "With selected",
            "why": "Why?",
            "wonBy": "Won by",
            "year": "Year",
            "yesRedrawAutomatically": "Yes, redraw automatically",
            "yourAcademies": "Your academies",
            "yourAcademyAndTeamAssociation": "Your academy and team/association",
            "yourCart": "Your cart",
            "yourCoupons": "Your coupons",
            "yourEstimatedAverageTime": "Your estimated average. We use this to estimate match start times",
            "yourEvents": "Your events",
            "youHaventSavedYourChanges": "You haven't saved your changes. Continue without saving?",
            "youNeedToCreateMatsFirst": "You need to create mats first",
            "youNeedToSelectParticipants": "You need to select athletes",
            "youNeedToSelectParticipantsToContinue": "You need to select athletes to continue",
            "yourRegistrations": "Your registrations",
            "yourUpcomingMatches": "Your upcoming matches",
            "zip": "ZIP",
            "awardedPoints": "Awarded points",
            "tournament": "Tournament",
            "eventVisibility": "Event visibility",
            "availability": "Availability",
            "publishBrackets": "Publish brackets",
            "starts": "Starts",
            "ends": "Ends",
            "defaultScoreboard": "Default scoreboard",
            "matchNumber": "Match number",
            "showMatchNumberInScoreboard": "Show match number in scoreboard",
            "registrationStarts": "Registration starts",
            "canYourParticipantsSeeBrackets": "Can your athletes see the brackets?",
            "lateEntryStarts": "Late entry starts",
            "registrationCloses": "Registration closes",
            "lastChanceToEdit": "Last chance to edit",
            "lastChanceToCancel": "Last chance to cancel",
            "refund": "Refund",
            "offerRefundOnCancel": "Offer refund on cancel",
            "until": "Until",
            "usersHaveToAcceptOurTOS": "Users have to accept our Terms of Service",
            "toContinueRegistrationUsersHaveToAcceptTOS": "To continue registration users have to accept these Terms of Services",
            "localization": "Localization",
            "dateFormat": "Date format",
            "use12HourClock": "Use 12 hour clock (am/pm)",
            "support": "Support",
            "community": "Community",
            "academies": "Academies",
            "affiliations": "Affiliations",
            "logIn": "Log in",
            "createAccount": "Create account",
            "users": "Users",
            "wallets": "Wallets",
            "dashboard": "Dashboard",
            "myAccount": "My account",
            "logOut": "Log out",
            "linkedProfiles": "Linked profiles",
            "manageProfiles": "Manage profiles",
            "theWorldsBestTournamentSoftwareForCombatSports": "The world's best tournament software for combat sports",
            "theSmoothestWayToParticipate": "The smoothest way to participate, organize and follow competitions",
            "browseEvents": "Find events",
            "learnMore": "Learn more",
            "smoothcompIsATournamentSoftwareForCombatSports": "Smoothcomp is a tournament software for combat sports. The smoothest way to participate, organize and follow competitions. See you on the mat!",
            "getSupport": "Get support",
            "menu": "Menu",
            "tvMode": "TV-Mode",
            "podiumTvMode": "Podium TV-Mode",
            "advancedStatistics": "Advanced statistics",
            "print": "Print",
            "competitorName": "Athlete name",
            "groupName": "Group Name",
            "allNationalities": "All nationalities",
            "allCategories": "All categories",
            "totalMedals": "Total medals",
            "gold": "Gold",
            "silver": "Silver",
            "bronze": "Bronze",
            "unpublish": "Unpublish",
            "publish": "Publish",
            "nations": "Nations",
            "bestTeamAndAcademy": "Best team & academy",
            "schedule": "Schedule",
            "upcomingMatches": "Upcoming matches",
            "pointsAndMedalsForBestNation": "Points and medals for best nation",
            "adultAndMastersAcademy": "Adult & Masters<br class=\"hidden-tv\"> academy",
            "bestAcademy": "Best<br class=\"hidden-tv\"> academy",
            "juniorAndJuvenileAcademy": "Junior & Juvenile<br class=\"hidden-tv\"> academy",
            "overallTeam": "Overall<br class=\"hidden-tv\"> Team",
            "bestTeamGi": "Best<br class=\"hidden-tv\"> Team Gi",
            "bestTeamNoGi": "Best<br class=\"hidden-tv\"> Team No-Gi",
            "defaultLanguage": "Default Language",
            "selectLanguages": "Select languages",
            "selectLanguage": "Select language",
            "language": "Language",
            "completedBrackets": "Completed Brackets",
            "registrationNotCompleted": "This registration is not complete yet",
            "completed": "Completed",
            "incomplete": "Incomplete",
            "completedAndIncompleted": "Completed and incompleted",
            "incompleteRegistrations": "Incomplete registrations",
            "hideIncompleteRegistrations": "Hide incomplete registrations",
            "orderCompleteRegistrationLater": "Complete registration later",
            "athletes": "Athletes",
            "myProfile": "My Profile",
            "hideRegistrationCountInEventMenuBar": "Hide registration count in event menu bar",
            "sharedUserData": "Shared user data",
            "sharedUserDataInfoText": "Shared with event organizers, Academy managers/coaches and Federation admins.",
            "eventsAndOrganizers": "Events/Organizers",
            "userData": "User data",
            "hideUserDataFromEventOrganizers": "Do not share your user data with this event",
            "federationMemberships": "Federation memberships",
            "greatSuccess": "Great success",
            "ranking": "Ranking",
            "yourNextMatch": "Your next match",
            "timesAreDynamicCheckBackHere": "Times are <strong>dynamic</strong> and change in real time. Your match number and mat are subject to change. Please check back here for updates.",
            "addMore": "Add more",
            "clearFilter": "Clear filter",
            "seeAllEvents": "See all events",
            "seasons": "Seasons",
            "any": "Any",
            "completeRegistration": "Complete registration",
            "continue": "Continue",
            "eventDuration": "Event dates",
            "middle_name": "Middle name",
            "earlyRegistration": "Early bird registrations",
            "numberOfPools": "Number of pools",
            "pending": "Pending",
            "update": "Update",
            "updateandsave": "Update and save settings (for future imports)",
            "upcomingEvent": "Upcoming event",
            "createEvent": "Create event",
            "athlete": "Athlete",
            "toplist": "Top list",
            "toplists": "Top lists",
            "youHaveUpcomingMatches": "You have upcoming matches!",
            "organizations": "Organizations",
            "hideMoreResults": "Hide more results",
            "quarantined": "Suspended",
            "latin_firstname": "English first name",
            "latin_lastname": "English last name",
            "latin_middle_name": "English middle name",
            "latin_name_description": "Enter your name in only English letters (A-Z)",
            "smoothstreams": "Smoothstreams",
            "livestreams": "Livestreams",
            "competitionTeam": "Competition team",
            "accommodations": "Location & Accommodation",
            "findAccommodations": "Find accommodations near",
            "mapWithAccommodations": "Use this map to find hotels and accommodations near this location.",
            "displayMedalsOnResultsPage": "Display medals count on results page",
            "areYouSureThisCantBeUndone": "Are you sure? This cant be undone.",
            "toggleDebugbar": "Toggle Debugbar",
            "unsupportedBrowserWarning": "We have detected that you may be using an outdated browser that is not compatible with our website.",
            "vat": "VAT",
            "upcoming": "Upcoming",
            "ongoing": "Ongoing",
            "past": "Past",
            "stats": "Stats",
            "company": "Company",
            "user": "User",
            "credits": "Credits",
            "receipt": "Receipt",
            "system": "System",
            "restore": "Restore",
            "delete": "Delete",
            "typed_text_not_match_delete": "Typed text does not match 'delete'",
            "type_delete_to_confirm": "Type '<strong>delete</strong>' in the input below to confirm",
            "cannot_undo_action": "You cannot undo this action!",
            "remove": "Remove",
            "manager": "Manager",
            "staff": "Staff",
            "active": "Active",
            "inactive": "Inactive",
            "create": "Create",
            "undo": "Undo",
            "removeOrganizerDenied": "You can't remove yourself. You need to give another person organizer-role before removing yourself.",
            "eventAwardedPoints": "Event awarded points",
            "comments": "Comments",
            "partially_paid": "Partially paid",
            "pendingPayment": "Pending payment",
            "paymentCompleted": "Payment completed",
            "desiredDate": "Desired date",
            "scheduledAt": "Scheduled date",
            "open": "Open",
            "title": "Title",
            "summary": "Summary",
            "parents": "Parents",
            "findLocation": "Find Location",
            "deleteAccount": "Delete account",
            "county": "county",
            "acceptTermsOfService": "Accept Terms Of Service",
            "accept": "Accept",
            "decline": "Decline",
            "federation": "Federation",
            "federations": "Federations",
            "saved": "Saved!",
            "deleted": "Deleted!",
            "defaultScoreboardSettings": "Scoreboard settings",
            "channels": "Channels",
            "pendingRegistrationMessage": "You now have a pending registration. You need to pay your fee according to the information provided by the organizer before you are approved.",
            "unpaidRegistration": "Unpaid registration",
            "joinAcademy": "Join academy",
            "linkedAccounts": "Linked accounts",
            "academyPermissionDescription": "At this section you can set which academy or (in some cases) which academies that you represent. By adding an academy to this list you accept that the responsible coach of that academy have the right to handle your application/cancellation and payment/refund to any competition within Smoothcomp.",
            "publicProfile": "Public Profile",
            "hidePublicProfile": "Hide public profile",
            "publicProfileDescription": "This setting hides your public profile page, however your name will still show up in the results list of events that you have participated in.",
            "planned": "Planned",
            "published": "Published",
            "unplanned": "Unplanned",
            "revenue": "Revenue",
            "federation_members": "Federation members",
            "import_pending": "Import pending",
            "processing_import": "Processing import",
            "import_completed": "Import completed",
            "import_error": "Import error",
            "residence": "Residence",
            "copy_selected": "Copy selected",
            "delete_selected": "Delete selected",
            "unpublish_selected": "Unpublish selected",
            "publish_selected": "Publish selected",
            "copy_selected_toplists": "Copy selected toplists",
            "list_settings": "List settings",
            "season": "Season",
            "last_calculated": "Last calculated",
            "update_in_progress": "Update in progress",
            "force_update": "Force update",
            "delete_ranking": "Delete ranking",
            "create_new_ranking": "Create new ranking",
            "toplist_categories": "Toplist categories",
            "changes_saved": "Changes saved",
            "unable_to_save_your_changes": "Unable to save your changes",
            "event_start_date": "Event start date",
            "export": "Export",
            "start_date": "Start date",
            "action": "Action",
            "federation_template": "Federation template",
            "event_page": "Event page",
            "approve_event": "Approve event",
            "save_and_approve": "Save & Approve",
            "reject_event": "Reject event",
            "paymentReference": "Payment reference",
            "save_settings": "Save settings",
            "only_latin_names": {
                "title": "Only allow names with English letters (A-Z)",
                "text": "Turn this option on if you don't want to allow for example Russian or Chinese characters. Users are asked to write their names in English characters."
            },
            "academy_profile": "Academy profile",
            "managers": "Managers",
            "event_title": "Event title",
            "submit": "Submit",
            "search_user": {
                "not_found": "No such user exists in our database. Please create the user account first and then add the email again."
            },
            "page": "Page|Pages",
            "bracket_packages": "Bracket packages",
            "event_toplists": "Event top lists",
            "type_to_search": "Type to search",
            "add_contact_information": "Add contact information",
            "background_image": "Background image",
            "set_image": "Set image",
            "page_title": "Page title",
            "create_new_page": "Create new page",
            "delete_page": "Delete page",
            "class": "Class|Classes",
            "share": "Share",
            "brackets": {
                "create_new_package": "Create new package",
                "choose": "Choose bracket"
            },
            "repechage": "Repechage",
            "add_rule": "Add rule",
            "match_points": "Match points",
            "points_for_different_win_methods": "Points awarded for different win methods.",
            "add_points": "Add points",
            "your_changes_have_been_saved": "Your changes have been saved",
            "problem_occured": "Problem occurred, action not saved",
            "add_new_discount": "Add new discount",
            "choose_entry": "Choose entry",
            "add_all_entries": "Add all entries",
            "add_another_entry": "Add another entry",
            "discounts": {
                "then_give_this_discount": "Then give this discount",
                "during_early_bird": "During early bird",
                "during_normal_fee": "During normal fee",
                "during_late_fee": "During late fee",
                "title": "Discounts"
            },
            "mat_categories": "Mat categories",
            "duplicate": "Duplicate",
            "delete_category": "Delete category",
            "delete_mat_category": "Delete mat category",
            "view": "View",
            "create_mat": "Create mat",
            "create_category": "Create category",
            "streams": "stream(s)",
            "starts_at": "Starts at",
            "prefix": "Prefix",
            "prefix_desc": "Displayed with the matchnumber (keep it short, one letter is recommended).",
            "message": "Message",
            "mat": {
                "message": {
                    "description": "If you wish, you can type a message that will appear on the schedule view for this mat."
                },
                "hide_from_schedule": "Hide from schedule",
                "hide_from_search": "Hide from search / Find matches",
                "hide_from_user_account": "Hide from athlete user account"
            },
            "mat_visibility": "Mat visibility",
            "delete_mat": "Delete mat",
            "select_mat": "Select mat(s)",
            "publish_on": "Publish on",
            "link_account": "Link account",
            "placement_points": "Placement points",
            "placement_points_desc": "Define how many points teams and academies will earn depending on athlete placement in match.",
            "add_placement": "Add placement",
            "extra_points": "Extra points",
            "extra_points_desc": "Points awarded for different win methods. These are added on top of placement points.",
            "add_extra_points": "Add extra points",
            "type_group_by": "Type / Group by",
            "create_new_top_list": "Create new top list",
            "set_offset_points": "Set offset points",
            "filter_win_type": "Filter win type",
            "ranking_points": "Ranking points",
            "fastest_win": "Fastest win",
            "select_categories": "Select categories",
            "manage": "Manage",
            "belt_skill_levels": "Belt/Skill levels",
            "add_new": "Add new",
            "add_belt_skill": "Add Belt/skill",
            "belt_skill": "Belt/skill",
            "non_available": "Non available",
            "featured_event": "Featured event",
            "user_must_be_a_federation_member": "Users must be a member of the federation",
            "must_be_approved": "Must be approved",
            "must_have_active_plan": "Must have an active payment plan",
            "academies_must_be_a_member_of_the_federation": "Academies must be a member of the federation",
            "event_data": "Event data",
            "remove_federation": "Remove federation",
            "link_event_to_federation": "Link this event to a federation",
            "primary_federation": "Primary federation",
            "change_primary": "Change primary",
            "users_have_to_accept_tos_to_register": "Users have to accept the Terms of Service in order to register.",
            "filter_on_country": "Filter on country",
            "group_unique_athletes": "Group unique athletes",
            "count_individual_athletes_as_one": "Count individual athletes as one",
            "reset_filter": "Reset filter",
            "totals": "Totals",
            "total_registrations": "Total registrations",
            "approved_registrations": "Approved registrations",
            "canceled": "Canceled",
            "credits_breakdown": "Credits breakdown",
            "details": "Details",
            "group_by": "Group by",
            "affiliation": "Affiliation",
            "include_entries": "Include entries",
            "view_report": "View report",
            "registrations_by": "Registrations by",
            "overview": "Overview",
            "match_list": "Match list",
            "financial": "Financial",
            "total_paid": "Total paid",
            "total_unpaid": "Total unpaid",
            "total_order_value": "Total order value",
            "from_date": "From date",
            "to_date": "To date",
            "ranking_points_top_x_events": "Ranking points - Top X events",
            "previous_season": "Previous season",
            "number_of_events": "Number of events",
            "divide_toplist": "Divide toplist",
            "one_global_ranking": "One global ranking",
            "by_continent_and_country": "By continent and country",
            "special_rules": "Special rules",
            "include_registrations_that_meet_following_criteria": "Include registrations that meet the following criteria:",
            "filter_registrations": "Filter registrations",
            "event_name": "Event name",
            "academy_nation": "Academy nation",
            "user_nation": "User nation",
            "inherit_other_toplist": "Inherit other toplist",
            "disabled": "Disabled",
            "description": "Description",
            "sendMessage": "Send message",
            "send": "Send",
            "message_will_be_sent_to": "Message below will be sent to {count} athletes",
            "characters": "character|characters",
            "message_will_be_sent_to_count": "Will be sent to {count} athletes.",
            "athletes_is_missing_phone": "selected athletes is missing phone number.",
            "see_list": "See list",
            "text_message": "Text message",
            "notify_by_email": "Notify athlete by email | Notify athletes by email",
            "notify_by_text_message": "Notify athlete by text message | Notify athletes by text message",
            "enabled": "Enabled",
            "history": "History",
            "send_message": "Send message|Send messages",
            "each_sms_will_count_as": "Each message will count as {count} SMS.",
            "send_sms": "Send SMS",
            "send_email": "Send email",
            "add_funds": "Add funds",
            "athletes_is_missing_email": "selected athletes is missing email.",
            "gotoEvent": "Go to event",
            "gotoRegistration": "Go to registration",
            "paymentConfirmation": "Payment confirmation",
            "notAReceipt": "This is not a receipt. This is a confirmation that you have placed an order at {owner}.",
            "paymentConfirmationDescription": "Your receipt is usually distributed from the payment service provider such as Paypal, Stripe, Authorize, Mastercard or similar. If you have not received it (and really need it!) please contact {owner}.",
            "loginOrCreateAccount": "Log in or create account to visit that page",
            "contactPersons": "Contact Persons",
            "approveAll": "Approve all",
            "rejectAll": "Reject all",
            "pendingMembers": "Pending members",
            "approvedMembers": "Approved members",
            "viewProfile": "View profile",
            "noPendingMembers": "There's no pending members",
            "eventRegistrations": "Event registrations",
            "upcomingEventRegistrations": "Upcoming event registrations",
            "registerMembersToEvent": "Register members to event",
            "clubEventRegistrations": "Registrations",
            "selectEventToRegisterMembers": "Select the event that you want to register members to",
            "pastEventsRegistrations": "Past event registrations",
            "affiliationMemberships": "Affiliation memberships",
            "pendingApprovalFromAffiliationManager": "Pending approval from affiliation manager",
            "leaveAffiliation": "Leave affiliation",
            "leave": "Leave",
            "applyToAffiliation": "Apply to new affiliation",
            "applyAffiliation": "Apply",
            "leaveAcademy": "Leave academy",
            "chooseUser": "Choose user",
            "createANewUser": "Create a new user",
            "newUser": "New user",
            "existingUsers": "Existing users",
            "completeAllRegistrations": "Complete all registrations",
            "expiredRegistrations": "Expired registrations",
            "completedRegistrations": "Completed registrations",
            "registrationsNotCompletedBeforeDueDate": "Registrations not completed before closing date",
            "paymentNeedsVerificationByOrganizer": "Payment is to be verified by organizer",
            "shared": "Shared",
            "notConfirmed": "Not confirmed",
            "confirmed": "Confirmed",
            "permissions": "Permissions",
            "autoChannel": "Auto select scoreboard",
            "includeEmptyGroups": "Include empty groups",
            "hostaTournament": "Host a tournament",
            "academyWallets": "Academy wallets",
            "solidarityWithUkraine": "Smoothcomp stands with Ukraine.\nOur platform is meant to unite the world in peaceful competitions. <a href=\"https://www.icrc.org/en/where-we-work/europe-central-asia/ukraine\">Help stop the unprovoked war</a>",
            "ranking_half_points": "50% for kids and white belts",
            "if_same_division": "If the division only has players from the same",
            "add_override_for_division": "Add override for a division",
            "unclaimed": "Unclaimed",
            "unclaimed_tooltip": "User has not confirmed the emailadress associated with this account.",
            "duplicate_reason_samefile": "This user is imported twice or more, update will be ignored.",
            "duplicate_reason_existing": "Existing account found, you are not allowed to update personal data of confirmed users, only membership data (Status/plans/dates)",
            "duplicate_reason_membernumber": "Existing account with matching data found. Choose merge to update the original account.",
            "plan": "Plan",
            "club": "Academy",
            "notes": "Notes",
            "expire_at": "Expire date",
            "created_at": "Member since",
            "duplicate_reason_nochange": "No new data found, no updated needed",
            "import_email": "Import Email",
            "confirm_import_email": "Confirm Import Email",
            "sorryRegistrationListNotPublic": "Sorry, registrations list is not public for this event.",
            "adminNote": "Admin note",
            "paymentNote": "Payment note",
            "athletesBeforeMove": "athletes before move",
            "athletesAfterMove": "athletes after move",
            "attention": "Attention",
            "playersNotAvailableInBracket": "players is not available in a <span class=\"capitalize\">{bracket}</span>bracket",
            "takeAction": "Take action",
            "currentBracket": "Current bracket",
            "keepAsItWasFixManually": "Keep as it was - I will fix it manually later",
            "convertToSE": "Convert to Single elimination",
            "movePlayersKeepSeed": "Move players - keep seed",
            "redrawBracketRandomSeed": "Redraw the bracket - random seed",
            "addToFirstAvailableSpot": "Add to first available spot",
            "whenRegisteringMembers": "when registering members",
            "noMatchingRankingList": "We could not match this group with a suitable ranking list. Pleas try looking for it manually or review your setup in admin /brackets (add toplists)",
            "bracketStartedWarning": "This bracket has started so you can not change the seed. To update the seed go to manual seed or delete the bracket and retry.",
            "membersToReview": "{count} members to review",
            "upload_new_file": "Upload new file",
            "informational_link": "https://yourlink.com",
            "informational_link_description": "Link description. For example 'download the form here' or 'rules can be found here'",
            "timesAreDynamicRefreshYourBrowser": "Times are <strong>dynamic</strong> and change in real time. Refresh your browser for the latest information.",
            "referees": "Referees",
            "reason": "Reason for suspension",
            "status_note": "Add note for suspension",
            "participation": "Participation points",
            "participation_desc": "Give points to every athlete in a bracket (not including those who get placement 0)",
            "participation_exclusion_placement_points": "Exclude athletes that already took placement points",
            "months": "Months",
            "years": "Years",
            "user_account": "User account",
            "additional_info": "Additional information",
            "create_new_rule": "Create new rule",
            "rules": {
                "and": "AND",
                "or": "OR",
                "registrations": "Registrations (Max capacity of registrations on this event)",
                "division": "Division (Max capacity of registrations per division)",
                "division_and_academy": "Division & Academy (Max capacity of registrations per academy and division)",
                "class": "Class",
                "rules": "Rules",
                "how_to_find_user_id": "How to find a competitor´s user ID",
                "user": "Allowable registrations per athlete (max capacity of registrations per athlete)"
            },
            "entry": "Entry",
            "is": "is",
            "is_not": "is not",
            "contains": "contains",
            "does_not_contain": "does not contain",
            "tracking": "Tracking",
            "add_tracking": "Add tracking information",
            "exit": "Exit",
            "greater_or_eq": "greater or eq",
            "less_or_eq": "less or eq",
            "years_lc": "years",
            "choose_values": "Choose values",
            "role": "Access level",
            "rejectSelected": "Reject selected",
            "hideNotFiltered": "Hide not filtered",
            "showAll": "Show all",
            "eventPass": "Event pass",
            "hideUnapprovedRegistrations": "Hide unapproved registrations",
            "showUnapprovedRegistrations": "Show unapproved registrations",
            "approveSelected": "Approve Selected",
            "seed": "Seed",
            "registration": "Registration",
            "ranked": "Ranked",
            "public_event_card": "Public event card",
            "unapproved_registrations": "unapproved registrations",
            "search_athlete_division": "Search athlete or division",
            "download_credential": "Download credential",
            "admins": "Admins",
            "removeAdminDenied": "The federation needs at least one admin. If you wish to remove this admin, please add another one first.",
            "add_admin": "Add admin",
            "search_organization": "Search organization",
            "search_federation": "Search federation",
            "search_contact": "Search contact person",
            "hide_ignored": "Hide ignored",
            "last_payment": "Last payment",
            "activated": "Activated",
            "not_activated": "Not activated",
            "credits_balance": "Credits (balance)",
            "credits_used": "Credits used",
            "contact_person": "Contact person",
            "wallet_owner": "Wallet owner",
            "ignored": "Ignored",
            "information_and_settings": "Information and settings",
            "trashbin": "Trashbin",
            "see_active": "See active",
            "see_trashbin": "See trashbin",
            "labels": "Labels",
            "label": "Label",
            "create_new_label": "Create new label",
            "no_labels_message": "You don´t have any labels at the moment.",
            "done": "Done",
            "label_name": "Label name...",
            "label_desc": "Label description...",
            "add_label": "Add label",
            "no_active_members": "There are no active members.",
            "no_pending_members": "There are no pending members.",
            "none": "None",
            "update_in_queue": "Position {pos} in queue",
            "update_scheduled": "Update scheduled",
            "wallet_manager": "Wallet manager",
            "managing_wallets_for": "Managing wallets for",
            "no_connected_organizations": "You currently don´t have any organizations connected to your wallet.",
            "remove_from_wallet": "Remove from wallet",
            "are_you_sure": "Are you sure?",
            "leave_wallet": "Leave wallet",
            "see_archived": "See archived",
            "archived": "Archived",
            "archive": "Archive",
            "goToFederation": "Go to federation",
            "locked_for_changes": "You have received transactions on this payment provider so it is now locked for editing. Contact support@smoothcomp.com if you need assistance.",
            "locked_for_changes_method": "{method} can not be updated, it has past transactions associated. Reach out to support@smoothcomp.com if you need assistance.",
            "user_id": "user ID",
            "completedMatches": "Show completed matches",
            "general": "General",
            "data": "Data",
            "contactTheOrganizerForRefundDetails": "Automated refund disabled for your order, please contact the event organizer for a manual refund of your payment.",
            "NoRefundWithCurrentPaymentMethod": "The payment option used does not support refunds through Smoothcomp. Please refund the customer using another method (through the Mercado Pago dashboard or similar).",
            "completeSelectedRegistrations": "Complete {count} registration|Complete {count} registrations",
            "selectRegistrationsToComplete": "Select registrations to complete",
            "round": "Round",
            "semifinal": "Semifinal",
            "quarterfinals": "Quarterfinals",
            "finals": "Finals",
            "eighthFinals": "Eighth-finals",
            "16thFinals": "16th-finals",
            "32ndFinals": "32nd-finals",
            "64thFinals": "64th-finals",
            "final": "Final",
            "finalQualification": "Final qualification",
            "bronzeMatch": "Bronze match",
            "group": "Group",
            "consolation": "Consolation",
            "possibleFinal": "Possible final",
            "possibleBronzeMatch": "Possible bronze match",
            "bracketIsStartedWarningAtRedraw": "Bracket is started, changes will reset your finished matches and results.",
            "linkRankingToplist": "Link ranking toplist",
            "change_type": "Change type",
            "notify_external_host": "You will now leave Smoothcomp and be redirected to {link}",
            "organizerAndMerchant": "Organizer & merchant",
            "cancelRefundPolicy": "Cancel/Refund policy",
            "refundNotActivated": "Refund: Not activated for this event",
            "expirationMonthError": "Month cannot be higher than 12",
            "expirationYearError": "Year cannot be a past year",
            "permissons": "Permission",
            "coachCheckoutCapacityReached": "Your group checkout is not possible due to capacity limits. You can try complete registrations one by one",
            "quarantinedFederationMember": "Suspended Federation Member",
            "addEdit": "Add/Edit",
            "capacityRules": "Capacity rules",
            "sortWithinGroup": "Sort within group",
            "placement": "Placement",
            "measuredWeight": "Measured weight",
            "filtered": "Filtered",
            "collapseAll": "Collapse all",
            "expandAll": "Expand all",
            "seedRank": "Seed (rank)",
            "academyAffiliation": "Academy/Affiliation",
            "linkToRanking": "Link to a ranking list",
            "linkAutomatically": "Link automatically",
            "clearAllSeeds": "Clear all seeds",
            "updateFromRanking": "Update from ranking list",
            "unlockSeed": "Unlock seed",
            "copied": "Copied!",
            "quickFilters": "Quick filters",
            "academyFinder": "Academy finder",
            "academyRankings": "Academy rankings",
            "typeOfGame": "Type of game",
            "end_date": "End date",
            "numberOneSoftware": "Get the <span>#1</span> tournament software for combat sports",
            "moreSports": "More sports",
            "aDigitalScoreboard": "A digital scoreboard for all sports",
            "downloadForWindows": "Download for windows",
            "downloadForMac": "Download for Mac",
            "needACustomScoreboard": "Need a custom scoreboard?",
            "letsTalk": "Let's talk",
            "allFeatures": "All features",
            "contactUsToLearnMore": "Contact us to learn more",
            "createNewAffiliation": "Create new affiliation",
            "myAffiliations": "My affiliations",
            "topAffiliations": "Top affiliations",
            "last100Days": "Last 100 days",
            "largestAffiliation": "Largest affiliation",
            "mostGoldMedals": "Most gold medals",
            "bestWinLossDifference": "Best win/loss difference",
            "shareToplist": "Share toplist",
            "promotedBy": "Promoted by",
            "addPromotedBy": "Add promoted by",
            "addDate": "Add date",
            "achieved": "Achieved",
            "viewingUnpublishedProfile": "Viewing unpublished profile",
            "age": "Age",
            "resultsNotPublishedYet": "Results are not published by the organizer yet",
            "won": "Won",
            "win": "Win",
            "loss": "Loss",
            "offerForAcademyManagers": "Offer for academy managers",
            "hide": "Hide",
            "show": "Show",
            "scAccountUserData": "Smoothcomp account user data",
            "scAccountSettings": "Smoothcomp account settings",
            "user_data_included": "User data included in the export. Columns \"<strong>User ID</strong>\" and \"<strong>Name</strong>\" are always included.",
            "membership_data_included": "Membership data included in the export. Column \"<strong>Is AJP member</strong>\" is always included.",
            "data_included_in_export": "Data included in export",
            "date_span_for_creation": "Date span for user account creation date",
            "export_users": "Export users",
            "is_ajp_member": "Is AJP member",
            "admin": "Admin",
            "age_in_months": "Age in months",
            "set_value_to": "Set value to",
            "points_lifetime": "Points lifetime",
            "accountSettings": "Account settings",
            "mobileApp": "Athlete App",
            "passed": "Passed",
            "lastChanceFor": "Last chance for",
            "findAPlaceToStay": "Find a place to stay",
            "pleaseNoteRefundPolicy": "Please note: Refund policy applies to event participation, and not other products or services provided by the organizer",
            "getTheApp": "Get the app",
            "waitingForPayment": "Waiting for Payment",
            "getReadyForTheEvent": "Get ready for the event",
            "registrationSaved": "Registration saved",
            "registrationCompleted": "Registration completed",
            "backToEvent": "Back to event",
            "nothing_found": "Nothing found",
            "remove_card": "Remove card",
            "failed_to_remove_card": "Failed to remove card",
            "card_removed": "Card removed",
            "card_removed_successfully": "Card removed successfully",
            "packages": "Packages",
            "search_packages": "Search packages",
            "search_date": "Search date",
            "refund_verb": "Refund",
            "logInWithSmoothcomp": "Log in with Smoothcomp",
            "stepXOfY": "Step {x} of {y}",
            "notifications": "Notifications",
            "profile": "Profile",
            "findEventsCloser": "Find events closer yo you",
            "allowSmoothcompToFindEvents": "Allow Smoothcomp to find events closer to you by sharing your location while using the app.",
            "oneTimeFee": "One-time fee",
            "liveActivity": "Live Activity",
            "activityFeed": "Activity Feed",
            "eventsForYou": "Events for You",
            "peopleYouFollow": "People you follow",
            "upgrade": "Upgrade",
            "whereWillYouGoNext": "Where will you go next?",
            "fromYourLocalClubTo": "From you local club to the entire world. Participate in the greatest tournaments.",
            "countdown": "Countdown",
            "matchesC": "Match|Matches",
            "showMore": "Show more",
            "goToX": "Go to {x}",
            "selectSport": "Select Sport",
            "currentLocation": "Current Location",
            "chooseACity": "Choose a City",
            "setHometown": "Set hometown",
            "searchCity": "Search City",
            "selectAll": "Select all",
            "experiencedOrganizer": "Experienced organizer",
            "followEvent": "Follow event",
            "off": "Off",
            "on": "On",
            "followX": "Follow {entity}",
            "followingX": "Following {entity}",
            "checkIn": "Check in",
            "recurringOrganizer": "Recurring organizer",
            "newOnSmoothcomp": "New on Smoothcomp",
            "navigateHere": "Navigate here",
            "registrationClosed": "Registration closed",
            "externalLink": "External link",
            "showEmail": "Show email",
            "editClosesOn": "Edit closes on",
            "editsClosed": "Edits closed",
            "payOrEdit": "Pay or Edit",
            "lastChanceForXY": "Last chance for {percent} {type}",
            "noMatchesFound": "No matches found",
            "score": "Score",
            "penalty": "Penalty",
            "advantage": "Advantage",
            "noMatCatSelected": "No mat category selected",
            "totalEst": "Total est.",
            "noBracketsFound": "No brackets found",
            "etaStart": "Eta. start",
            "winnerFrom": "Winner from",
            "showAllXPlacements": "Show all {amount} placements",
            "global": "Global",
            "noToplistPosted": "No toplist posted yet",
            "noAthletesFound": "No athletes found",
            "clearAll": "Clear all",
            "following": "Following",
            "ongoingAndUpcoming": "Ongoing & Upcoming Events",
            "followedX": "Successfully followed {entity}",
            "unfollowedX": "Successfully unfollowed {entity}",
            "blockedX": "Successfully blocked {entity}",
            "unblockedX": "Successfully unblocked {entity}",
            "turnOnAlertsFromX": "Turn on alerts from {entity}",
            "turnOnAlerts": "Turn on alerts",
            "notNow": "Not now",
            "couldNotFollowX": "Could not follow {entity}, please try again",
            "couldNotUnfollowX": "Could not unfollow {entity}, please try again",
            "somethingWrongTryAgain": "Something went wrong, please try again",
            "alerts": "Alerts",
            "unitsAndFormat": "Units and format",
            "switchProfile": "Switch profile",
            "unlinkProfile": "Unlink profile",
            "restorePurchases": "Restore purchases",
            "logOutConfirm": "Log out?",
            "switchProfileConfirm": "Switch profile?",
            "helpAndSupport": "Help & Support",
            "fullProfile": "Full profile",
            "followers": "Followers",
            "followingSettings": "Following settings",
            "block": "Block",
            "unblock": "Unblock",
            "unfollow": "Unfollow",
            "unitOfMeasurements": "Unit of measurements (distance)",
            "clearHometownConfirm": "Clear hometown?",
            "clearHometown": "Clear hometown",
            "resetAppSettings": "Reset App settings",
            "build": "Build",
            "yourInformation": "Your information",
            "resetSettingsConfirm": "Reset settings?",
            "feed": "Feed",
            "latest": "Latest",
            "earlier": "Earlier",
            "markAllAsRead": "Mark all as read",
            "newFollower": "New Follower",
            "eventsNearYou": "Events near you",
            "newFollowers": "New followers",
            "reminderForEditDeadline": "Reminder for edit registration deadline",
            "scheduleUpdates": "Schedule updates",
            "deadlineChanged": "Deadline changed",
            "timeSensitiveInfo": "Time sensitive info",
            "newDivision": "New division",
            "publishedBrackets": "Published bracket",
            "otherAthletes": "Other athletes",
            "matchResults": "Match results",
            "movedAthlete": "Moved athlete",
            "clubJoinsAffiliation": "Club joins affiliation",
            "organizers": "Organizers",
            "eventAdded": "Event added",
            "trySmoothcompPro": "Try Smoothcomp Pro",
            "fromYourHometown": "From your {link}",
            "blockXConfirm": "Block {entity}?",
            "dontHaveFollowers": "You don't have any followers",
            "notFollowingAny": "You are not following anyone",
            "xMembers": "1 member|{count} members",
            "unblockXConfirm": "Unblock {entity}?",
            "unfollowXConfirm": "Unfollow {entity}?",
            "matchStarted": "Match started",
            "xYears": "{count} years",
            "belts": "Belts",
            "distanceFromX": "Distance from {entity}",
            "sortBy": "Sort by",
            "nearestLocation": "Nearest location",
            "soonestInTime": "Soonest in time",
            "markAsRead": "Mark as read",
            "finalEditsClosing": "Final edits for {entity} is closing in less than 24hrs",
            "xHasBeenPublished": "{entity} has been published, get your spot now!",
            "checkOutX": "Check out {entity}",
            "updatedFeedRefresh": "Updated feed - Tap here to refresh",
            "thisProfileIsPrivate": "This profile is private",
            "receiveNotificationAboutEvent": "Receive notifications about this event, such as registration reminders and brackets published.",
            "receiveNotificationAboutUser": "Receive notifications about their matches, results, and more during the event.",
            "receiveNotificationAboutClub": "Receive notifications about the academy and its members, such as matches and results.",
            "successfullyXAlertsForY": "Successfully {type} alerts for {name}",
            "xAlertsForY": "Successfully {type} alerts for {name}",
            "couldNotXAlertsForY": "Could not {type} alerts for {name}",
            "enable": "enable",
            "disable": "disable",
            "enabledL": "enabled",
            "disabledL": "disabled",
            "eventsOfInterest": "Events of interest",
            "chooseLocation": "Choose location",
            "turnOnLocation": "Turn on location",
            "locationInstructions": "Go to Settings > Smoothcomp and allow the app to access your location while using the app.",
            "openSettings": "Open settings",
            "noEventsFound": "No events found",
            "noEventsNearby": "No events nearby, would you like to expand your search range?",
            "couldNotFindNearbyEvents": "Could not find any nearby events.",
            "expand": "Expand",
            "xYAway": "{distance} {prefix} away",
            "xYFromZ": "{distance} {prefix} from {location}",
            "couldntFetchData": "Couldn't fetch data - Pull down to refresh",
            "countXPrefixY": "{count} {prefix}",
            "earlyBird": "Early bird",
            "startsX": "Starts {date}",
            "untilX": "Until {date}",
            "lateFeeStartsX": "Late fee starts {date}",
            "deadlineX": "Deadline {date}",
            "lastEditX": "Last edit {date}",
            "xEntries": "{count} entries",
            "oneEntry": "1 entry",
            "xUnpaid": "{count} unpaid",
            "newMatchesRefresh": "New matches - Tap here to refresh",
            "live": "Live",
            "fetchMoreMatches": "Fetch more matches",
            "noPastEventsOnSc": "No past events on Smoothcomp",
            "firstTimeOrgOnSc": "First time organizing on Smoothcomp",
            "noMatsFound": "No mats found",
            "xMatches": "1 match|{count} matches",
            "pause": "Pause",
            "bracketsNotPublished": "Brackets are not published yet",
            "xParticipants": "1 participant|{count} participants",
            "dayX": "Day {day}",
            "xMinutes": "{count} minutes",
            "xPoints": "{count} p",
            "editRegistration": "Edit registration",
            "earlyBirdEndsInX": "Early bird ends in {time}",
            "editClosesOnX": "Edit closes on {date}",
            "refundPolicy": "Refund Policy",
            "couponRefund": "coupon refund",
            "xBelt": "{sport} belt",
            "verifiedByX": "Verified by {name}",
            "dateOfVerification": "Date of verification",
            "verifiedByType": "Verified by type",
            "verifiedByUser": "Verified by user",
            "addedBy": "Added by",
            "level": "Level",
            "actionLevelUpdated": "Skill level updated",
            "actionLevelAdded": "Skill level added",
            "actionLevelRemoved": "Skill level removed",
            "competedOnSmoothcomp": "Competed on Smoothcomp",
            "unverifiedByX": "Unverified by {name}",
            "addNoteOptional": "+ Add note <span style=\"color: #888;\">(optional)</span>",
            "actionNoun": "Action",
            "noHistoryFound": "No history found for this user.",
            "removeSkillLevelConfirmation": "Are you sure you want to remove this skill level?",
            "removeSkillLevelQuestion": "Remove skill level?",
            "dateOfUnverification": "Date of unverification",
            "unverifiedByType": "Unverified by type",
            "unverifiedByUser": "Unverified by user",
            "competedWithThisSkillLevel": "Competed with this skill level on Smoothcomp",
            "viewProfileForCompleteHistory": "View profile for complete history",
            "allowVerificationRequests": "Allow Verification Requests",
            "automaticVerificationThroughAcademy": "Automatic Verification through Academy",
            "automaticVerificationThroughCompetition": "Automatic Verification through competition",
            "noSettingsFound": "No settings found",
            "saveAndEdit": "Save & Edit",
            "ifAcademyIsAnApprovedMember": "If academy is an approved member",
            "ifCoachesSkillLevelIsVerified": "If coach's skill level is verified",
            "ifCoachesSkillLevelIsXOrHigher": "If coaches skill level is {skillLevel} or higher",
            "userCanRequestVerification": "User can request skill level verification from the federation",
            "automaticDelegatedVerification": "Automatic / Delegated Verification",
            "skillLevelCanBeVerifiedAutomatically": "Skill level can be verified automatically through academies and/or competition",
            "allowAutomaticVerification": "Allow automatic verification",
            "whenAthleteCompetesWithThis": "When athlete competes with this skill level",
            "athleteCompetedOnAnEventUnderX": "The athlete competed on an event under {federation} and got a placement with this skill level",
            "saveAndPublish": "Save & Publish",
            "addReviewData": "Add Review Data",
            "linkDescription": "Link Description",
            "link": "Link",
            "whenSkillLevelIsVerifiedByAcademy": "When skill level is verified by academy",
            "ifCoachHasThisLevelOrHigher": "If added by a coach with this skill level or higher:",
            "skillLevelMustBeVerifiedByX": "The skill level must also be Verified by {federation}",
            "ifAcademyIsAnApprovedMemberOfX": "If academy is an approved member of {federation}",
            "enterOptionsSeparatedByNewLine": "Enter options separated by new line",
            "goBack": "Go back",
            "verification": "Verification",
            "has_livestream": "Has livestream",
            "has_no_livestream": "Has no livestream",
            "delete_news": "Delete news",
            "delete_news_confirm": "Are you sure you want to delete this news?",
            "removedVerifiedByX": "Removed: Verified by {name}",
            "removedByType": "Removed by type",
            "removedByUser": "Removed by user",
            "dateOfRemoval": "Date of removal",
            "scoreboardPresets": "Scoreboard Presets",
            "scoreboardPresetsDescription": "Set your preferred settings for different occasions, allowing easy access and reliable usage.",
            "createNewPreset": "Create new preset",
            "newPreset": "New preset",
            "delete_preset": "Delete preset",
            "delete_preset_confirm": "Do you want to delete this preset?",
            "roundX": "Round {nr}",
            "pendingVerificationFromX": "Pending verification from {name}",
            "notVerifiedByX": "Not verified by {name}",
            "requestSubmitted": "Request submitted!",
            "verificationRequestSubmittedText": "Your verification request is now pending and there's nothing more you need to do at this time.",
            "verificationRequestUpdatedText": "Your verification request is pending.",
            "requestUpdated": "Request updated!",
            "applyForVerification": "Apply for verification",
            "updateRequest": "Update request",
            "submitForReview": "Submit for review",
            "submitted": "Submitted",
            "reserves": "Reserves",
            "teamPointsAwarded": "Team points awarded",
            "addNewOffset": "Add new offset",
            "editPointsFor": "Edit points for",
            "titleForGivenPoints": "Title for given points",
            "onlyVisibleForOrganizer": "Visible only for organizer",
            "judge": "Judge",
            "match": "Match",
            "visibleForAll": "Visible for all",
            "addMessageOptional": "+ Add message <span style=\"color: #888;\">(optional)</span>",
            "showRequestHistory": "Show request history",
            "rejectedVerificationFromX": "Rejected verification from {name}",
            "requestApproved": "Request approved!",
            "requestRejected": "Request rejected!",
            "verificationRequestApprovedText": "The verification request has been approved and the user has been notified.",
            "verificationRequestRejectedText": "The verification request has been rejected and the user has been notified.",
            "addMessage": "Add message",
            "requestHistory": "Request history",
            "requestsToReview": "{count} requests to review",
            "presetDetails": "Preset details",
            "sports": "Sports",
            "acceptAndContinue": "Accept & Continue",
            "scrollDownToContinue": "Scroll Down to Continue",
            "free": "Free",
            "pricing": "Pricing",
            "features": "Features",
            "bookADemo": "Book a Demo",
            "navigation": "Navigation",
            "athleteRanking": "Athlete Ranking",
            "academyRanking": "Academy Ranking",
            "internationalRanking": "International Ranking",
            "eventAccess": "Event Access",
            "smoothcompOffer": "Smoothcomp offer",
            "academyManagerOffer": "Offer for academy managers",
            "gameTypeSettings": "Game Type Settings",
            "create_token": "Create key",
            "no_expiration": "No expiration",
            "cannotDeleteCategoryHasBrackets": "This category has mats with brackets, you need to move or delete all brackets first.",
            "cannotDeleteMatHasBrackets": "This mat has brackets, you need to move or delete all brackets first.",
            "updateAccordingToBracketPackage": "Update according to Bracket Package ({bracketType})",
            "playersNotAvailable": "players is not available in a",
            "unselectAll": "Unselect all",
            "noDataAvailable": "No data available",
            "somethingWentWrongTryAgain": "Something went wrong, please try again later",
            "errorOccurredPleaseTryAgain": "An error occurred. Please try again later.",
            "requestErrorPleaseTryAgain": "There has been an error with your request. Please try again later.",
            "requestErrorPleaseRefresh": "There has been an error with your request. Please refresh the page and try again.",
            "errorPleaseTryAgain": "There was an error. Please try again later.",
            "thereWasAnError": "There was an error.",
            "searchPlaceholder": "Search...",
            "sending": "Sending...",
            "filtersAreApplied": "Filters are applied",
            "template": "Template",
            "fromAddress": "From address",
            "fromName": "From Name",
            "subject": "Subject",
            "organization": "Organization",
            "organizationName": "Organization name",
            "billingInformation": "Billing Information",
            "importPreview": "Import preview",
            "goToCheckout": "Go to checkout",
            "createRefund": "Create refund",
            "createManualRefund": "Create manual refund",
            "winTypes": "Win types",
            "needToFillRequiredFields": "You need to fill all required fields",
            "invalidPhoneNumber": "Invalid phone number",
            "needToChooseEntry": "You need to choose an entry",
            "unableToFetchTranslations": "Unable to fetch translations",
            "unableToSaveImage": "Unable to save image",
            "unableToSave": "Unable to save",
            "downloadScoreboardApp": "Download the scoreboard app here",
            "noPaymentMethods": "No payment methods available",
            "deleteImage": "Delete image",
            "rejectAcademyConfirm": "Reject academy?",
            "selectAffiliation": "Affiliation",
            "searchOrganizer": "Search organizer",
            "upcomingEventsMoreThan": "Upcoming events more than",
            "registrationsFrom": "Registrations from",
            "selectCategory": "- Category -",
            "selectDivision": "- Division -",
            "selectRank": "- Rank -",
            "selectWeight": "- Weight -",
            "categoryNamePlaceholder": "Category name",
            "selectCurrency": "Select a currency",
            "fileFormat": "File format",
            "selectDateFormat": "Select date format",
            "replaceLogo": "Replace logo",
            "membersFrom": "Members from",
            "academiesFrom": "Academies from",
            "upcomingEventsFrom": "Upcoming events from",
            "noWalletSelected": "No wallet is selected.",
            "unableToLoadAgreement": "Unable to load agreement",
            "needToChooseBelt": "You need to choose a belt.",
            "needToSelectAcademy": "You need to select an academy",
            "unableToCreateAcademyWallet": "Unable to create academy wallet",
            "alreadyManagingWallet": "You are already managing this wallet",
            "invitationCodeNoMatch": "The invitation code doesn't match any organization",
            "paymentAttemptError": "There was an error with your payment attempt. Please try again later.",
            "paymentNotCompleted": "Payment not completed",
            "cardExpiryPlaceholder": "MM / YY",
            "cvcPlaceholder": "CVC",
            "removeUserPermissions": "Remove user permissions",
            "removeFromOrganization": "Remove from Organization",
            "removeFromFederation": "Remove from federation",
            "removeFromAffiliation": "Remove from Affiliation",
            "deleteWallet": "Delete wallet",
            "clubNamePlaceholder": "Club name...",
            "matLabel": "Mat",
            "seeAll": "See all",
            "counterpartInfo": "Counterpart info",
            "image": "Image",
            "uploadHeaderImage": "Upload header image",
            "introduction": "Introduction",
            "introInstructions": "One or two short sentences describing your event. Put longer text below.",
            "locked": "Locked",
            "actionRequired": "Action Required",
            "loadingDots": "Loading...",
            "mailMarketing": "Mail Marketing",
            "nrOfMatches": "Nr of matches",
            "placedParticipants": "Placed participants",
            "unplacedParticipants": "Unplaced participants",
            "unscheduled": "Unscheduled",
            "area": "Area",
            "bracket_package": "Bracket package",
            "seeding_by": "Seeding by",
            "bracketNotPublished": "Bracket is not published",
            "goToBracket": "Go to bracket",
            "addToThisBlock": "Add to this block",
            "labelPlaceholder": "Label...",
            "dragToSelectMatches": "Drag to select matches",
            "addSelectedMatches": "Add selected matches to new block",
            "mergeAllBlocks": "Merge all blocks",
            "selectMat": "Select mat",
            "backToBracket": "Back to bracket",
            "changeBracketType": "Change bracket type",
            "automaticRedraw": "Automatic redraw <small>(includes unplaced fighters)</small>",
            "unpublishBracket": "Unpublish bracket",
            "publishBracket": "Publish bracket",
            "newBracketType": "New bracket type:",
            "saveManualSeed": "Save manual seed",
            "deleteBracket": "Delete bracket",
            "unplace": "Unplace",
            "dropHere": "Drop here",
            "dropAthleteHere": "Drop athlete here",
            "bracketSettings": "Bracket settings",
            "unplacedPlural": "Unplaced",
            "goToScoreboard": "Go to scoreboard",
            "goToTeamMatch": "Go to team match",
            "signUp": "Sign Up",
            "unlink": "Unlink",
            "unauthorizedAction": "Unauthorized action",
            "countries": "Countries",
            "federationAdmin": "Federation admin",
            "headerImage": "Header image",
            "freeText": "Free text",
            "swedishPersonalNumber": "Swedish Personal number",
            "optionalC": "Optional",
            "plusAdd": "+ Add",
            "hidden": "Hidden",
            "languagePlaceholder": "- Language -",
            "forceUpdateSelected": "Force update selected",
            "seasonPlaceholder": "- Season -",
            "previous": "Previous",
            "first": "First",
            "last": "Last",
            "member": "Member",
            "typePlaceholder": "- Type -",
            "eventPlaceholder": "- Event -",
            "smsPrice": "SMS price",
            "pricePerSms": "${price} / SMS for {country}",
            "completePriceList": "Complete price list",
            "emailPrice": "E-mail price",
            "pricePerEmail": "${price} / e-mail",
            "dispatches": "Dispatches",
            "recipients": "Recipients",
            "viewRecipients": "View recipients",
            "sentCount": "Sent {count}",
            "notSentCount": "Not sent {count}",
            "errorCount": "Error {count}",
            "typeOfSkill": "Type of skill",
            "filteredEst": "Filtered est.",
            "filteredMatches": "Filtered matches",
            "unscheduledMatches": "Unscheduled matches",
            "addPause": "Add pause",
            "printBrackets": "Print brackets",
            "searchForMore": "Search for more...",
            "showMoreAcademies": "Show more academies",
            "couldntFindLocation": "Could not find location",
            "visitAcademyProfile": "Visit academy profile",
            "scTournament": "SC Tournament",
            "1mAgo": "1m ago",
            "plusMore": "+ More",
            "linkedSeed": "Linked seed",
            "manualSeed": "Manual seed",
            "notPossibleNoClasses": "Not possible (group has no classes)",
            "convertToManualSeed": "Convert to manual seed",
            "linkToAnotherRankingList": "Link to another ranking list",
            "viewRankingList": "View ranking list",
            "lockSeed": "Lock seed",
            "notPossibleBracketCreated": "Not possible (bracket is created)",
            "wonGold": "Won Gold",
            "wonSilver": "Won Silver",
            "wonBronze": "Won Bronze",
            "wonByX": "Won by {wonBy}",
            "upcomingMatch": "Upcoming match",
            "drawScore": "Draw {score}",
            "lostByX": "Lost by {lostBy}",
            "couldntAccessClipboard": "Couldn't access the clipboard",
            "errorSavingSkillLevel": "Error saving skill level",
            "errorSavingVerification": "Error saving verification",
            "dueToPreviousPlacement": "Due to a previous placement in this skill level you can no longer change this value.",
            "ifThisIsNotCorrect": "If this is not correct, please contact {contact} to have this rectified.",
            "confirmDeletePlan": "Are you sure you want to delete this plan?",
            "welcomeBonusCreditsHtml": "<strong>Welcome bonus!</strong> Add funds and get <strong>$10 in bonus</strong>",
            "reset": "Reset",
            "teamMatches": "Team matches",
            "newSchedule": "New schedule",
            "viewTeamMatch": "View team match",
            "filteredCount": "{count} filtered:",
            "saveXChanges": "Save {count} changes",
            "distribute": "Distribute",
            "selectedCount": "{count} selected:",
            "groupAdjective": "Group",
            "processingYourAction": "Processing your action...",
            "selectPlaceholder": "Select...",
            "youMustSaveYourChanges": "You must save your changes before you can continue. Do you want to save changes?",
            "editHeaderImage": "Edit header image",
            "errorSavingCoverImage": "An error occurred while saving the cover image. Please try again.",
            "deleteBracketQuestion": "Delete bracket?",
            "deleteBracketText": "This will remove the bracket, matches and results.",
            "wonByPointsX": "Won by Points {score}",
            "orderContent": "Order content",
            "refundAmount": "Refund amount",
            "refundCommentHtml": "Refund comment <small>(visible on order)</small>",
            "refundMethod": "Refund method",
            "resetChanges": "Reset changes",
            "success": "Success",
            "settingsSavesSuccessfully": "Settings saved successfully",
            "priceCurrency": "Price ({currency})",
            "package": "Package",
            "dateTimezoneUtcHtml": "{date} <small style=\"opacity: 0.5\">(Timezone: UTC)</small>",
            "pleaseTryAgain": "Please try again or contact support",
            "cookieConsentMessage": "We use cookies to personalize your site experience and analyze the site traffic.",
            "successStatus": "Success",
            "sctvWallet": "SCTV Wallet",
            "lost": "Lost",
            "plusOrHtml": "<span class=\"icon-plus\" /> OR",
            "unmuteNotifications": "Unmute notifications",
            "muteFor24h": "Mute notifications for 24hrs",
            "notificationsMutedUntil": "Notifications muted until {time} ({timezone})",
            "unableToFetchNotificationStatus": "Unable to fetch notification status",
            "countOfMaxCharacters": "{count} / {max} characters",
            "tiebreakers": "Tiebreaker|Tiebreakers",
            "mostWins": "Most Wins",
            "mostTotalMedals": "Most Total medals",
            "mostSilverMedals": "Most Silver medals",
            "mostBronzeMedals": "Most Bronze medals",
            "plusAnd": "+ And",
            "plusOr": "+ Or",
            "categoryPlaceholder": "- Category -",
            "editProfile": "Edit profile",
            "noSkillsAdded": "No skills added",
            "failedToFetchSkillLevels": "Failed to fetch skill levels",
            "approve": "Approve",
            "verifiedByBeltchecker": "Verified by Beltchecker.com",
            "verifiedThroughBeltchecker": "Verified through Beltchecker.com. Click for more info.",
            "achievedYear": "Achieved {year}",
            "promotedByX": "Promoted by {name}",
            "competedOnX": "Competed on {platform}",
            "andXMore": "And {count} more...",
            "beltName": "{degree} {label}",
            "beltNameInGroup": "{belt} in {group}",
            "competedAsBeltClickForHistory": "Competed as {belt}. Click for history.",
            "competedAsBeltOnPlatform": "Competed as {belt} on {platform}",
            "showCancelRefund": "Show Cancel/Refund policy",
            "hideCancelRefund": "Hide Cancel/Refund policy",
            "passedDate": "Passed",
            "lastChanceForXRefund": "Last chance for {percent}% refund",
            "lastChanceForXCoupon": "Last chance for {percent}% coupon refund",
            "appliesToAllEntriesExcept": "Applies to all entries except these...",
            "signedAgreements": "Signed agreements",
            "versionXCreatedX": "Version {version} (created {created})",
            "userProfile": "User profile",
            "editStatus": "Edit status",
            "deletedAccount": "Deleted account",
            "reenableAccount": "Re-enable account",
            "accountDeletedOnX": "This account was deleted on: <br><br> {date}",
            "areYouSure": "Are you sure?",
            "deleteQuestion": "Delete?",
            "useThisID": "Use this {platform} ID to identify yourself and have a smooth checkin at the event",
            "userIdX": "User ID {id}",
            "showThisId": "Show this ID at check in / weigh in. It will help the organizer to find your registrations easier.",
            "idMoreInformation": "More information about this feature can be found <a href=\"https://support.smoothcomp.com/article/274-smoothcomp-id\" target=\"_blank\">here »</a>",
            "organizerX": "Organizer: {name}",
            "optionOnlyAvailable": "Option only available 2 weeks after the event.",
            "paymentConfirmationDescriptionEmail": "Your receipt is usually distributed from the payment service provider such as Paypal, Stripe, Authorize, Mastercard or similar. If you have not received it (and really need it!) please contact {owner} at <a href=\"mailto:{email}\">{email}</a>",
            "orderId": "Order #{id}",
            "dateTimezoneUtc": "{date} (Timezone: UTC)",
            "paymentMethodColon": "Payment method:",
            "orderMessageColon": "Order message:",
            "eventColon": "Event:",
            "federationColon": "Federation:",
            "linkToEvent": "Link to event",
            "organizerAndMerchantColon": "Organizer & merchant:",
            "refundPolicyColon": "Refund Policy:",
            "refundAvailableNo": "Refund available: No",
            "pleaseNoteRefundPolicyBold": "<b>Please note:</b> Refund policy applies to event participation, and not other products or services provided by the organizer.",
            "totalColon": "Total:",
            "mostActiveAthlete": "Most active athlete",
            "presentedBy": "Presented by",
            "sinceX": "Since {date}",
            "couldNotRetrieveToplist": "Could not retrieve Toplist. Please refresh the page and try again.",
            "noResultsPostedYet": "No results posted yet",
            "updateRequired": "Update required",
            "yourVersionIsOutdated": "Your version is outdated. Please update to continue using the app.",
            "updateAvailable": "Update available",
            "thereIsAnUpdateAvailable": "There is an update available. Please update the app for the best experience!",
            "searchMatches": "Search matches",
            "filters": "Filters",
            "tomorrow": "Tomorrow",
            "judgeX": "Judge {number}",
            "stream": "Stream",
            "openProfileInWeb": "Open profile in web",
            "couldNotRetrieveProfile": "Could not retrieve Profile information. Please refresh the page and try again.",
            "rankedAcademy": "Ranked Academy",
            "rankedAthlete": "Ranked Athlete",
            "noMorePostsToShow": "No more posts to show.",
            "noMoreAlerts": "No more alerts to show.",
            "goldCount": "{count} Gold",
            "findAthletes": "Find athletes",
            "findAthlete": "Find athlete",
            "earnYourRank": "Earn your <span class=\"mute\">Rank</span>",
            "goToProfile": "Go to profile",
            "continentPlaceholder": "- Continent -",
            "affiliationPlaceholder": "- Affiliation -",
            "genderPlaceholder": "- Gender -",
            "topAthletes": "Top Athletes",
            "lastHundredDays": "Last 100 days",
            "xGolds": "{count} <span class=\"mute-less\">gold</span>",
            "africa": "Africa",
            "asia": "Asia",
            "europe": "Europe",
            "northAmerica": "North America",
            "southAmerica": "South America",
            "oceania": "Oceania",
            "urlHasBeenCopied": "URL has been copied to your clipboard",
            "customTime": "Custom time",
            "endOfDay": "End of day",
            "startOfDay": "Start of day",
            "seeAllWins": "See all wins",
            "excitingTimesGetStartedHtml": "Exciting times!<br> Let's get started on Smoothcomp",
            "excitingTimesNameHtml": "Exciting times! <br>Let's get <span>{name}</span> on Smoothcomp",
            "greatSuccessExclamation": "Great success!",
            "recipient": "Recipient",
            "processedAt": "Processed at",
            "seeAllRankings": "See all rankings",
            "eventTopLists": "Event Top Lists",
            "signedUpForEntries": "{name} signed up for {count} entry|{name} signed up for {count} entries",
            "verificationRules": "Verification Rules",
            "isVerifiedBy": "is verified by",
            "selectSkillLevel": "Select skill level",
            "selectFederation": "Select federation",
            "anyGender": "Any gender",
            "noGender": "No gender",
            "missingClass": "Missing class!",
            "missingValue": "Missing value!",
            "academyAndAffiliation": "Academy & Affiliation",
            "pastEventsTitle": "Past Events",
            "unsaved": "Unsaved",
            "pleaseChooseGroup": "Please choose group.",
            "somethingWentWrongUnableToMoveGroup": "Something went wrong, unable to move to new group.",
            "somethingWentWrongChangingCategoryValues": "Something went wrong when changing category values!",
            "athletesHideDetailsWarning": "One or more athletes does not share personal information with the event",
            "chooseTeam": "Choose team",
            "chooseYourTeam": "Choose your team",
            "needToChooseTeam": "You need to choose a team",
            "notAbleToMoveDuplicateRegistration": "Not able to move <strong>{firstname} {lastname}</strong>. It's not allowed to have multiple registrations in same group.",
            "notAbleToMoveNonTeamToTeamGroup": "Not able to move <strong>{firstname} {lastname}</strong>. It's not allowed to move non team competition registration to a team competition group.",
            "weighInStatus": "Weigh-in / Status",
            "paidViaStripe": "Paid via Stripe",
            "teamMatchLineupTooltip": "Enter team match line-up to plan the order of who plays first in each game",
            "editTeamMatchLineup": "Edit team match line-up",
            "yearsC": "Year|Years",
            "monthsC": "Month|Months",
            "goToRankingList": "Go to ranking list",
            "forAdmins": "For admins",
            "selectSpecificTime": "Select specific time",
            "muteUntil": "Mute until",
            "somethingWentWrongTogglingNotifications": "Something went wrong when muting/unmuting notifications",
            "findAcademy": "Find Academy",
            "gymdeskLite": "Gymdesk lite",
            "gymdeskPricing": "from $75/mo",
            "gymdeskAcademyPromoTitle": "Gym Management Software Connected with Smoothcomp",
            "gymdeskAcademyPromoText": "Gymdesk is simple to run and takes the everyday admin off your plate, so you can spend less time behind the desk and more time with your members.",
            "gymdeskAcademyPromoCta": "30-day free trial",
            "goToAcademy": "Go to Academy",
            "mostActiveAcademy": "Most active academy",
            "matchVideoPrivate": "Private",
            "matchVideoPublic": "Public",
            "xNewMatchVideos": "{count} new|{count} new",
            "removeMatchVideoConfirm": "Remove this video from your profile? You can't undo this.",
            "matchVideosIntro": "A match only appears on the event page when both athletes set it to Public. Choose Public to share the full match with the community.",
            "matchVideoPublicDescription": "Shown on your profile. Shown on the event page when both athletes choose Public.",
            "matchVideoPrivateDescription": "Hidden from your profile. The other athlete can still show it on theirs.",
            "matchVideoRemoveDescription": "Removes the video from your profile. You can't undo this.",
            "filmedBy": "Filmed by {name}",
            "matchVideos": "Match videos",
            "xMatchVideos": "{count} match video|{count} match videos",
            "matchesOnSmoothcompEvents": "Matches on Smoothcomp events",
            "matchVideoUnavailable": "This video is unavailable.",
            "playMatchVideo": "Play video",
            "smoothcompGymdesk": "Smoothcomp + Gymdesk",
            "smoothcompConnect": "Smoothcomp Connect",
            "gymManagement": "Gym Management",
            "smoothcompGymdeskOneCompany": "Smoothcomp and Gymdesk Are Now One Company",
            "matchVideoFilmedBy": "Filmed by",
            "officialMatchVideo": "Official clip",
            "winLossDiffCount": "{diff} W/L",
            "contributingAthletes": "Contributing Athletes",
            "coachCompanionApp": "Coach Companion App",
            "deactivated": "Deactivated",
            "fromColon": "From:",
            "toColon": "To:",
            "comingSoon": "Coming soon",
            "opensInNewTab": "{label} (opens in a new tab)",
            "onlyVisibleForAdmins": "Only visible for admins",
            "organizerAndMerchantInfo": "Organizer & merchant info",
            "xEventsCompleted": "1 event completed|{amount} events completed",
            "noPastEvents": "No past events",
            "xTimeOnSmoothcomp": "{time} <span class=\"mute\">on Smoothcomp</span>",
            "xEventsOnSmoothcomp": "1 event completed <span class=\"mute\">on Smoothcomp</span>|{amount} events completed <span class=\"mute\">on Smoothcomp</span>",
            "downloadScoreboardApplication": "Download scoreboard application for PC or Mac",
            "haventSavedWeighInChanges": "You haven't saved your weight-in changes. Are you sure you want to leave this page?",
            "communityVideos": "Community videos",
            "communityVideoSettings": "Community video settings",
            "allowCommunitySmoothrecorder": "Allow community to use Smoothrecorder",
            "showCommunityVideosOnEventPage": "Show community videos on Event page",
            "delayPublication": "Delay publication",
            "noDelay": "No delay",
            "delayThreeDaysFromEventStart": "Delay 3 days from event start",
            "publishAt": "Publish at",
            "communityVideosInfo": "Coaches, teammates and family can record matches with Smoothrecorder, and the videos are shown on the event page and athlete profiles. Every shared video promotes your event, and athletes love having footage of their matches.",
            "communityVideosInfoEventPageOff": "Community videos are hidden from the event page. Visitors can’t watch matches there, but athletes still see them on their profiles. Showing videos on the event page keeps visitors coming back and makes your event look bigger and more active.",
            "communityVideosInfoRecordingOff": "Community recording is off. Matches at your event can’t be recorded with Smoothrecorder. Athletes miss out on footage of their matches, and your event loses the reach that shared videos bring.",
            "matchVideosOrganizerSettings": "Organizer settings are chosen by the event organizer and can change at any time. Smoothcomp cannot change them.",
            "smoothrecorderPromoText": "Now friends and family can record your matches like a pro. With live, automated graphics. Just select a match and hit record.",
            "publicBeta": "Public Beta",
            "matchVideoCaptionPrivate": "This is a private video",
            "matchVideoCaptionVisible": "Visible on athlete profiles and event page.",
            "matchVideoCaptionGated": "Hidden until {date}. The organizer has delayed publication.",
            "matchVideoCaptionEventHidden": "Hidden until the organizer publishes the event and its brackets.",
            "matchVideoCaptionRecordingDisallowed": "Hidden. The organizer doesn't allow community recording at this event.",
            "matchVideoCaptionEventUnlisted": "Hidden on athlete profiles. The organizer has made the event unlisted.",
            "matchVideoCaptionEventPageOff": "Visible on athlete profiles. Event pages don't show community videos yet.",
            "matchVideoCaptionEventPageDisabled": "Visible on athlete profiles. The organizer has hidden it on the event page.",
            "matchVideoCaptionOtherAthleteNotPublic": "Visible on your profile. It shows on the event page once the other athlete chooses Public too.",
            "cancelIsClosed": "Cancel is closed",
            "cancelClosedPlacementAchieved": "Cancel is closed, you have achieved placement. Please contact the event organizer if you have any further questions about your registration.",
            "refundCouponDescription": "{amount} {currency} refund coupon",
            "unlinkAccount": "Unlink account",
            "userSettingsX": "{name} - User settings",
            "thinkYouMissedSomething": "Think you missed something",
            "waitingForSync": "Waiting for sync...",
            "semifinals": "Semifinals",
            "128thFinals": "128th-finals",
            "matchXOfY": "Match {nr}/{total}",
            "performanceXOfY": "Performance {nr}/{total}",
            "roundXOfY": "Round {nr} of {total}",
            "repechageXOfY": "Repechage {nr} of {total}",
            "earned": "Earned",
            "earnedSilver": "Earned Silver",
            "earnedBronze": "Earned Bronze",
            "follow": "Follow",
            "noCommunityVideosYet": "No community videos yet"
        },
        "agreements": {
            "intro": "Intro",
            "saas_agreement": "Saas Agreement",
            "sla_agreement": "SLA Agreement",
            "new_agreements_to_review": "New agreements to review",
            "our_software_commitments": "our software commitments",
            "our_support_commitments": "our support commitments",
            "please_review_updates": "Please take a few minutes to review these updates.",
            "version": "Version",
            "reviewing_all_terms": "Reviewing terms for all organizations/federations below.",
            "remind_later": "Remind me later",
            "get_started": "Get Started",
            "decline": "Decline",
            "accept": "Accept",
            "agreements": "Agreements",
            "owner": "Owner",
            "signed_on": "Signed on",
            "view_content": "View content",
            "other": "Other",
            "guardianInformationRequired": "Guardian information is required",
            "agreementDetails": "Agreement details",
            "agreementCreatedAt": "Agreement created at",
            "guardianDetails": "Guardian details",
            "agreementContent": "Agreement content",
            "organizerAndMerchantDetails": "Organizer and merchant details",
            "laterUpdatedTo": "Later updated to: {value}",
            "refundPolicyPendingOrder": "The cancellation-/refund policy will be shown here once the order is complete"
        },
        "club": {
            "addAffiliationTeam": "Add affiliation/team",
            "askYourAcademyManager": "<strong>You're advised</strong> to ask your academy manager to register the academy.",
            "createNewAcademy": "Create new academy",
            "memberApproval": "Member approval",
            "newUsersNeedToBeApproved": "New users need to be approved before becoming members",
            "personInCharge": "Person in charge",
            "selectAffiliation": "Select affiliation",
            "academiesCommunity": "Academies <span class=\"mute\">Community</span>",
            "myAcademies": "My academies",
            "topAcademies": "Top academies",
            "lastOneHundredDays": "Last 100 days",
            "createUserInviteMember": "Create user / invite member",
            "inviteMember": "Invite member",
            "searchByAcademyName": "Search by academy name",
            "filter": "Filter",
            "searchByLocation": "Search by location...",
            "noPastRegistrations": "No past event registrations found",
            "areYouSureYouWantTo": "Are you sure you want to {state} the selected members?",
            "largestAcademy": "Largest academy",
            "affiliationsCommunity": "Affiliations <span class=\"mute\">Community</span>",
            "winsLosses": "{wins} wins / {losses} losses",
            "createOrEditAffiliation": "Create or edit Affiliation",
            "isAffiliationMissing": "Is your affiliation missing from our database? Contact us and we will assist you!",
            "createAffiliation": "Create Affiliation",
            "placedIn": "Placed {badge} in",
            "earnedToRanking": "Earned {badge} to ranking",
            "pts": "pts",
            "unpublished": "Unpublished",
            "clubPendingApproval": "{name} (Pending approval)",
            "isNotConfirmed": "{name} academy membership is not confirmed",
            "manuallyApproveAcademy": "Manually approve academy for this event",
            "dataIsShared": "Your user data is shared with the academies below",
            "affiliationApprovalRequired": "Affiliation approval required",
            "affiliationApprovalRequiredText": "Your request will be pending until a manager from the affiliation has accepted your academy",
            "excludeAcademyFromRankings": "Exclude this academy from club rankings",
            "clubRanking": "Club ranking",
            "approvalSubmitted": "Approval submitted",
            "approvalSubmittedText": "Thank you! You will be notified when a manager or coach from {name} has accepted your membership.",
            "academyApprovalRequired": "Academy approval required",
            "academyApprovalRequiredText": "A manager or coach from the academy needs to approve your membership. You can still continue with your registration and have this worked out later.",
            "pendingApproval": "Pending approval"
        },
        "statistics": {
            "no_classes_found": "No classes found in selected entry to base report on.",
            "no_entries_found": "No entries found to base report on."
        },
        "SKK-FA": {
            "derby_cup_six": "6"
        },
        "won-by": {
            "decision": "Won by Decision",
            "disqualification": "Won by Disqualification (disqualification)",
            "dq": "Won by Disqualification (dq)",
            "draw": "Match was declared a draw",
            "fullippon": "Won by Full Ippon",
            "goldenpoint": "Won by Golden Point",
            "hansokumake": "Won by Hansokumake",
            "ippon": "Won by Ippon",
            "knockout": "Won by Knockout (knockout)",
            "ko": "Won by Knockout (ko)",
            "pointgap": "Won by Pointgap",
            "points": "Won by points",
            "rounds": "Won by rounds",
            "submission": "Won by Submission",
            "tko": "Won by Technical Knockout (tko)",
            "vs1": "Victory by technical superiority (VSU1)",
            "vso": "Won by VSO (wrestling)",
            "vt": "Victory by fall",
            "walkover": "Won by Walkover",
            "wazari": "Won by Wazari",
            "bye": "Advanced via BYE",
            "technical-knockout": "Won by Technical Knockout (technical-knockout)",
            "double-dq": "Both athletes lost by DQ/WO",
            "double-walkover": "Both athletes lost by WO/DQ",
            "no-show": "Match cancelled due to No-Show",
            "double-no-show": "Match cancelled - Double No-show",
            "fastest_escape": "Won By Fastest Escape",
            "submission_overtime": "Won By Submission in Overtime",
            "submission_americana": "Won by Submission (Americana)",
            "submission_anaconda": "Won by Submission (Anaconda)",
            "decision_unanimous": "Won by Decision (Unanimous)",
            "decision_split": "Won by Decision (Split)",
            "decision_majority": "Won by Decision (Majority)",
            "decision_technical": "Won by Decision (Technical)",
            "submission_ankle_lock": "Won by Submission (Ankle Lock)",
            "submission_armbar": "Won by Submission (Armbar)",
            "submission_arm_triangle_choke": "Won by Submission (Arm Triangle Choke)",
            "submission_calf_crusher": "Won by Submission (Calf Crusher)",
            "submission_crucifix": "Won by Submission (Crucifix)",
            "submission_d_arce_choke": "Won by Submission (D'Arce Choke)",
            "submission_ezekiel": "Won by Submission (Ezekiel)",
            "submission_flying_armbar": "Won by Submission (Flying Armbar)",
            "submission_flying_triangle_choke": "Won by Submission (Flying Triangle Choke)",
            "submission_gogoplata": "Won by Submission (Gogoplata)",
            "submission_guillotine_choke": "Won by Submission (Guillotine Choke)",
            "submission_heel_hook": "Won by Submission (Heel Hook)",
            "submission_head_and_arm_choke": "Won by Submission (Head and Arm Choke)",
            "submission_kimura": "Won by Submission (Kimura)",
            "submission_kneebar": "Won by Submission (Kneebar)",
            "submission_neck_crank": "Won by Submission (Neck Crank)",
            "submission_north_south_choke": "Won by Submission (North-South Choke)",
            "submission_omoplata": "Won by Submission (Omoplata)",
            "submission_peruvian_necktie": "Won by Submission (Peruvian Necktie)",
            "submission_rear_naked_choke": "Won by Submission (Rear-Naked Choke)",
            "submission_reverse_armbar": "Won by Submission (Reverse Armbar)",
            "submission_triangle_choke": "Won by Submission (Triangle Choke)",
            "submission_twister": "Won by Submission (Twister)",
            "submission_other": "Won by Submission (Other)",
            "submission_scarf_hold": "Won by Submission (Scarf Hold)",
            "submission_bulldog_choke": "Won by Submission (Bulldog Choke)",
            "submission_von_flue_choke": "Won by Submission (Von Flue Choke)",
            "submission_inverted_triangle": "Won by Submission (Inverted Triangle)",
            "submission_smother_choke": "Won by Submission (Smother Choke)",
            "submission_triangle_armbar": "Won by Submission (Triangle Armbar)",
            "submission_achilles_lock": "Won by Submission (Achilles Lock)",
            "weigh_in_failed": "Won by Weigh In Failed",
            "med_exam_failed": "Won by Med Exam Failed",
            "keiken": "Won by Kiken",
            "shikkaku": "Won by Shikkaku",
            "hantei": "Won by Hantei",
            "senshu": "Won by Senshu",
            "major_decision": "Won by major decision",
            "fall": "Won by fall",
            "tech_fall": "Won by tech fall",
            "forfeit": "Won by forfeit",
            "medical_forfeit": "Won by medical forfeit",
            "injury": "Won by injury",
            "win_by_rule": "Win by rule",
            "final_score": "Won by Final score",
            "rsc": "Won by Referee stops contest",
            "superiority": "Won by superiority",
            "pun": "Won by referee’s punitive declaration",
            "golden_point_round": "Won by Golden point round",
            "withdrawal": "withdrawal",
            "vB": "Victory by injury",
            "vd": "Won by disqualification",
            "vf": "Victory by forfeit",
            "vp0": "Victory by points (VPO)",
            "vp1": "Victory by points (VPO1)",
            "vs0": "Victory by technical superiority (VSU)",
            "v3": "Victory by 3 cautions",
            "d2": "Double disqualification",
            "f2": "Double forfeit",
            "b2": "Double loss by injury (2VIN)",
            "vp": "Victory by points (VP)",
            "no_contest": "Won by No contest",
            "performance": "Won by performance",
            "kill": "Won by Kill",
            "kill_under_min": "Won by Kill under 1 minute",
            "break": "Won by Break",
            "break_under_min": "Won by Break under 1 minute",
            "pin": "Won by Pin",
            "stoppage": "Won by Stoppage",
            "yuko": "Won by Yuko",
            "ofp": "Won by Out from platform",
            "forcible_counting": "Won by Forcible Counting",
            "admonition": "Won by Admonition",
            "warnings": "Won by Warnings",
            "disqualification_over_weight": "Won by Weight",
            "head_judge_decision": "Won by Head Judge Decision",
            "kill_americana": "Won by Kill (Americana)",
            "kill_anaconda": "Won by Kill (Anaconda)",
            "kill_ankle_lock": "Won by Kill (Ankle Lock)",
            "kill_armbar": "Won by Kill (Armbar)",
            "kill_arm_triangle_choke": "Won by Kill (Arm Triangle Choke)",
            "kill_calf_crusher": "Won by Kill (Calf Crusher)",
            "kill_crucifix": "Won by Kill (Crucifix)",
            "kill_d_arce_choke": "Won by Kill (D'Arce Choke)",
            "kill_ezekiel": "Won by Kill (Ezekiel)",
            "kill_flying_armbar": "Won by Kill (Flying Armbar)",
            "kill_flying_triangle_choke": "Won by Kill (Flying Triangle Choke)",
            "kill_gogoplata": "Won by Kill (Gogoplata)",
            "kill_guillotine_choke": "Won by Kill (Guillotine Choke)",
            "kill_heel_hook": "Won by Kill (Heel Hook)",
            "kill_head_and_arm_choke": "Won by Kill (Head and Arm Choke)",
            "kill_kimura": "Won by Kill (Kimura)",
            "kill_kneebar": "Won by Kill (Kneebar)",
            "kill_neck_crank": "Won by Kill (Neck Crank)",
            "kill_north_south_choke": "Won by Kill (North-South Choke)",
            "kill_omoplata": "Won by Kill (Omoplata)",
            "kill_peruvian_necktie": "Won by Kill (Peruvian Necktie)",
            "kill_rear_naked_choke": "Won by Kill (Rear-Naked Choke)",
            "kill_reverse_armbar": "Won by Kill (Reverse Armbar)",
            "kill_triangle_choke": "Won by Kill (Triangle Choke)",
            "kill_twister": "Won by Kill (Twister)",
            "kill_other": "Won by Kill (Other)",
            "kill_scarf_hold": "Won by Kill (Scarf Hold)",
            "kill_bulldog_choke": "Won by Kill (Bulldog Choke)",
            "kill_von_flue_choke": "Won by Kill (Von Flue Choke)",
            "kill_inverted_triangle": "Won by Kill (Inverted Triangle)",
            "kill_smother_choke": "Won by Kill (Smother Choke)",
            "kill_triangle_armbar": "Won by Kill (Triangle Armbar)",
            "kill_achilles_lock": "Won by Kill (Achilles Lock)",
            "kill_under_min_americana": "Won by Kill under 1 min (Americana)",
            "kill_under_min_anaconda": "Won by Kill under 1 min (Anaconda)",
            "kill_under_min_ankle_lock": "Won by Kill under 1 min (Ankle Lock)",
            "kill_under_min_armbar": "Won by Kill under 1 min (Armbar)",
            "kill_under_min_arm_triangle_choke": "Won by Kill under 1 min (Arm Triangle Choke)",
            "kill_under_min_calf_crusher": "Won by Kill under 1 min (Calf Crusher)",
            "kill_under_min_crucifix": "Won by Kill under 1 min (Crucifix)",
            "kill_under_min_d_arce_choke": "Won by Kill under 1 min (D'Arce Choke)",
            "kill_under_min_ezekiel": "Won by Kill under 1 min (Ezekiel)",
            "kill_under_min_flying_armbar": "Won by Kill under 1 min (Flying Armbar)",
            "kill_under_min_flying_triangle_choke": "Won by Kill under 1 min (Flying Triangle Choke)",
            "kill_under_min_gogoplata": "Won by Kill under 1 min (Gogoplata)",
            "kill_under_min_guillotine_choke": "Won by Kill under 1 min (Guillotine Choke)",
            "kill_under_min_heel_hook": "Won by Kill under 1 min (Heel Hook)",
            "kill_under_min_head_and_arm_choke": "Won by Kill under 1 min (Head and Arm Choke)",
            "kill_under_min_kimura": "Won by Kill under 1 min (Kimura)",
            "kill_under_min_kneebar": "Won by Kill under 1 min (Kneebar)",
            "kill_under_min_neck_crank": "Won by Kill under 1 min (Neck Crank)",
            "kill_under_min_north_south_choke": "Won by Kill under 1 min (North-South Choke)",
            "kill_under_min_omoplata": "Won by Kill under 1 min (Omoplata)",
            "kill_under_min_peruvian_necktie": "Won by Kill under 1 min (Peruvian Necktie)",
            "kill_under_min_rear_naked_choke": "Won by Kill under 1 min (Rear-Naked Choke)",
            "kill_under_min_reverse_armbar": "Won by Kill under 1 min (Reverse Armbar)",
            "kill_under_min_triangle_choke": "Won by Kill under 1 min (Triangle Choke)",
            "kill_under_min_twister": "Won by Kill under 1 min (Twister)",
            "kill_under_min_other": "Won by Kill under 1 min (Other)",
            "kill_under_min_scarf_hold": "Won by Kill under 1 min (Scarf Hold)",
            "kill_under_min_bulldog_choke": "Won by Kill under 1 min (Bulldog Choke)",
            "kill_under_min_von_flue_choke": "Won by Kill under 1 min (Von Flue Choke)",
            "kill_under_min_inverted_triangle": "Won by Kill under 1 min (Inverted Triangle)",
            "kill_under_min_smother_choke": "Won by Kill under 1 min (Smother Choke)",
            "kill_under_min_triangle_armbar": "Won by Kill under 1 min (Triangle Armbar)",
            "kill_under_min_achilles_lock": "Won by Kill under 1 min (Achilles Lock)",
            "break_americana": "Won by Break (Americana)",
            "break_anaconda": "Won by Break (Anaconda)",
            "break_ankle_lock": "Won by Break (Ankle Lock)",
            "break_armbar": "Won by Break (Armbar)",
            "break_arm_triangle_choke": "Won by Break (Arm Triangle Choke)",
            "break_calf_crusher": "Won by Break (Calf Crusher)",
            "break_crucifix": "Won by Break (Crucifix)",
            "break_d_arce_choke": "Won by Break (D'Arce Choke)",
            "break_ezekiel": "Won by Break (Ezekiel)",
            "break_flying_armbar": "Won by Break (Flying Armbar)",
            "break_flying_triangle_choke": "Won by Break (Flying Triangle Choke)",
            "break_gogoplata": "Won by Break (Gogoplata)",
            "break_guillotine_choke": "Won by Break (Guillotine Choke)",
            "break_heel_hook": "Won by Break (Heel Hook)",
            "break_head_and_arm_choke": "Won by Break (Head and Arm Choke)",
            "break_kimura": "Won by Break (Kimura)",
            "break_kneebar": "Won by Break (Kneebar)",
            "break_neck_crank": "Won by Break (Neck Crank)",
            "break_north_south_choke": "Won by Break (North-South Choke)",
            "break_omoplata": "Won by Break (Omoplata)",
            "break_peruvian_necktie": "Won by Break (Peruvian Necktie)",
            "break_rear_naked_choke": "Won by Break (Rear-Naked Choke)",
            "break_reverse_armbar": "Won by Break (Reverse Armbar)",
            "break_triangle_choke": "Won by Break (Triangle Choke)",
            "break_twister": "Won by Break (Twister)",
            "break_other": "Won by Break (Other)",
            "break_scarf_hold": "Won by Break (Scarf Hold)",
            "break_bulldog_choke": "Won by Break (Bulldog Choke)",
            "break_von_flue_choke": "Won by Break (Von Flue Choke)",
            "break_inverted_triangle": "Won by Break (Inverted Triangle)",
            "break_smother_choke": "Won by Break (Smother Choke)",
            "break_triangle_armbar": "Won by Break (Triangle Armbar)",
            "break_achilles_lock": "Won by Break (Achilles Lock)",
            "break_under_min_americana": "Won by Break under 1 min (Americana)",
            "break_under_min_anaconda": "Won by Break under 1 min (Anaconda)",
            "break_under_min_ankle_lock": "Won by Break under 1 min (Ankle Lock)",
            "break_under_min_armbar": "Won by Break under 1 min (Armbar)",
            "break_under_min_arm_triangle_choke": "Won by Break under 1 min (Arm Triangle Choke)",
            "break_under_min_calf_crusher": "Won by Break under 1 min (Calf Crusher)",
            "break_under_min_crucifix": "Won by Break under 1 min (Crucifix)",
            "break_under_min_d_arce_choke": "Won by Break under 1 min (D'Arce Choke)",
            "break_under_min_ezekiel": "Won by Break under 1 min (Ezekiel)",
            "break_under_min_flying_armbar": "Won by Break under 1 min (Flying Armbar)",
            "break_under_min_flying_triangle_choke": "Won by Break under 1 min (Flying Triangle Choke)",
            "break_under_min_gogoplata": "Won by Break under 1 min (Gogoplata)",
            "break_under_min_guillotine_choke": "Won by Break under 1 min (Guillotine Choke)",
            "break_under_min_heel_hook": "Won by Break under 1 min (Heel Hook)",
            "break_under_min_head_and_arm_choke": "Won by Break under 1 min (Head and Arm Choke)",
            "break_under_min_kimura": "Won by Break under 1 min (Kimura)",
            "break_under_min_kneebar": "Won by Break under 1 min (Kneebar)",
            "break_under_min_neck_crank": "Won by Break under 1 min (Neck Crank)",
            "break_under_min_north_south_choke": "Won by Break under 1 min (North-South Choke)",
            "break_under_min_omoplata": "Won by Break under 1 min (Omoplata)",
            "break_under_min_peruvian_necktie": "Won by Break under 1 min (Peruvian Necktie)",
            "break_under_min_rear_naked_choke": "Won by Break under 1 min (Rear-Naked Choke)",
            "break_under_min_reverse_armbar": "Won by Break under 1 min (Reverse Armbar)",
            "break_under_min_triangle_choke": "Won by Break under 1 min (Triangle Choke)",
            "break_under_min_twister": "Won by Break under 1 min (Twister)",
            "break_under_min_other": "Won by Break under 1 min (Other)",
            "break_under_min_scarf_hold": "Won by Break under 1 min (Scarf Hold)",
            "break_under_min_bulldog_choke": "Won by Break under 1 min (Bulldog Choke)",
            "break_under_min_von_flue_choke": "Won by Break under 1 min (Von Flue Choke)",
            "break_under_min_inverted_triangle": "Won by Break under 1 min (Inverted Triangle)",
            "break_under_min_smother_choke": "Won by Break under 1 min (Smother Choke)",
            "break_under_min_triangle_armbar": "Won by Break under 1 min (Triangle Armbar)",
            "break_under_min_achilles_lock": "Won by Break under 1 min (Achilles Lock)",
            "no_show_fusensho": "Match cancelled due to No-Show (Fusenshō)",
            "technique_kimarite": "Won by Technique (Kimarite)",
            "technique": "Won by Technique",
            "disqualification_hansoku": "Won by  Disqualification (Hansoku)",
            "criteria": "Won by Criteria",
            "wp": "WP",
            "rscs": "Won by Referee stops contest (Safety)",
            "rsci": "Won by Referee stops contest (Injury)",
            "rsch": "Won by Referee stops contest (Head Strike)",
            "rscb": "Won by Referee stops contest (Body Strike)",
            "rsco": "Won by Referee stops contest (Outclass)",
            "ccl": "Won by Compulsory count limit",
            "koh": "Won by Knockout (Head Strike)",
            "kob": "Won by Knockout (Body Strike)",
            "ret": "Won by Retirement",
            "wo": "Won by Walkover",
            "nc": "Won by No contest",
            "draw_leading": "Draw (Leading off / Better Style)",
            "draw_defence": "Draw (Better Defence)",
            "draw_other": "Draw (Other)"
        },
        "schedule": {
            "moveAndDistributeTo": "Move and distribute to",
            "loadingMats": "Loading mats...",
            "selectMats": "Select mats",
            "moveTool": "Move Tool",
            "andPlaceOn": "and place on",
            "top": "Top",
            "bottom": "Bottom",
            "keepIndividual": "Keep individual brackets on the same mat",
            "createSliceFor": "Create slice for",
            "sliceAdjective": "Slice",
            "sliceRounds": "Slice rounds",
            "sliceSingleBlock": "Slice single block",
            "moveToDropzone": "Move to Dropzone",
            "distributeTooltip": "Get an even distribution of matches over a set of mats",
            "dropzoneTooltip": "Move all to the Dropzone",
            "sliceRoundsTooltip": "Slice up brackets in multiple rounds to make a sandwich style schedule",
            "groupTooltip": "Make your schedule less cluttered by grouping small schedule blocks together",
            "noSliceAlternativesAvailable": "No slice alternatives available",
            "sliceItUp": "Slice it up",
            "chooseSplitValue": "You need to choose split value",
            "sliceTool": "Slice Tool",
            "groupTool": "Group Tool",
            "groupAllSelected": "Create one group for all selected",
            "groupEveryRound": "Create one group for every round",
            "groupSelectedRounds": "Create one group with selected rounds",
            "selectRounds": "Select rounds",
            "createGroups": "Create groups",
            "sliceAndDistributeTo": "Slice and distribute to",
            "sliceAndDistribute": "Slice & Distribute",
            "selectOneBlock": "Select one block",
            "invalidBlockType": "Invalid block type",
            "displayAllBracketMatches": "Display all bracket matches",
            "lunchBreakPlaceholder": "Lunch break...",
            "pauseUntil": "Pause until",
            "pauseDuration": "Pause duration",
            "deletePause": "Delete pause",
            "okAddPause": "OK, add pause",
            "okEditPause": "OK, edit pause",
            "editPauseBlock": "Edit pause block",
            "addNewPauseBlock": "Add new pause block",
            "etaEndX": "Eta end {time}",
            "totalMatchesX": "Total matches: {count}"
        },
        "fedPlatform": {
            "powerUpYourFederation": "Power up your Federation,",
            "pricingAndPlans": "Pricing & Plans",
            "seePricingAndPlans": "See Pricing & Plans",
            "withMembershipsAcademies": "with Memberships, Academies & Events",
            "yourFederationYourBrand": "Your federation, your brand, your events.",
            "getACustomizedPlatform": "Get a customized platform with your own subdomain and logo. All your events and rankings, gathered in one professional place.",
            "growYourFederation": "Grow your Federation with Smoothcomp",
            "delegateEventManagement": "Delegate event management with full oversight of their operations.",
            "aUnifiedCalendar": "A unified calendar showcasing only your sanctioned events.",
            "sellMembershipsVerifyBelts": "Sell memberships with online payments, review applications and verify belts.",
            "aCompleteCrmSystem": "A complete CRM system with your event listing",
            "designYourOwnWebsite": "Design your own website with our content management system. List your own events, sell memberships and get your own subdomain on Smoothcomp.",
            "getYourOwnSubdomain": "Get your own subdomain your-name.smoothcomp.com",
            "createYourOwnPages": "Create your own pages and navigation within your federation page.",
            "aUnifiedCalendarHub": "A unified calendar showcasing only your sanctioned events in one hub.",
            "sellMembershipsWithOnline": "Sell memberships with online payments.",
            "sellMembershipsWithReview": "Sell memberships with online payments and review applications.",
            "customRankingListsWithin": "Custom Ranking Lists within your Federation",
            "rankTheBestAthletes": "Rank the best athletes across multiple events or seasons.",
            "rankTheBestAcademies": "Rank the best academies across multiple events or seasons.",
            "rankTheBestNation": "Rank the best nation across multiple events or seasons.",
            "offerMembershipsFor": "Offer Memberships for Athletes, Academies and Organizers",
            "collectMembershipFees": "Collect membership fees using Stripe, PayPal and more.",
            "defineDataFieldsAnd": "Define data fields and document uploads required for membership approval.",
            "manageIfMembershipIsRequired": "Manage if membership is required for both athletes and academies in order to compete at your events."
        },
        "stripe": {
            "invoice_status_paid": "Paid",
            "invoice_status_void": "Canceled",
            "invoice_status_open": "Pending",
            "invoice_status_draft": "Draft",
            "invoice_status_uncollectible": "Uncollectible"
        },
        "federation": {
            "eventSeasons": "Event seasons",
            "eventSeason": "Event season",
            "extendMembership": "Extend membership",
            "forFederationsAndCompaniesRunningSeveral": "For federations and companies running several tournaments we can provide you with <a><strong>your-name</strong>.smoothcomp.com</a>. On this customizable page you can gather all administration for your academies and tournaments in one place.",
            "manageEvents": "Manage Events",
            "allEventsArranged": "All events arranged by your company or federation in one place",
            "rankingForYourAcademies": "Ranking for your academies and athletes",
            "manageAcademies": "Manage Academies",
            "manageAllYourMemberAcademies": "Manage all your member academies from one interface",
            "reviewAndApproveApplications": "Review and approve applications to your federation",
            "managePaymentsForYourMemberships": "Manage payments for your memberships",
            "manageFighters": "Manage Athletes",
            "manageAndApproveFighters": "Manage and approve athletes to be a part of each club of your federation (or let each coach for the club do it for you)",
            "reviewAndApproveBeltsAndPromotions": "Review and approve belts and promotions for athletes (or let the coach of each club do it for you)",
            "pricingAndPlans": "Pricing & plans",
            "runYourOwnCircuitOfEvents": "Run your own circuit of events from your personal subdomain, choose if you require participating academies to be members with an optional fee for membership to your organisation. Grow your business by letting affiliate organisers run events under your umbrella.",
            "includesACMS": "Includes a CMS (add “About”, “News”, “Rules” or any page you like). Increased flexibility by offering individual membership to your federation as an extra layer and offer different levels of memberships for both academies and individuals. Create ranking lists for your divisions with our powerful ranking engine.",
            "academyMembership": "Academy membership",
            "membershipForAcademiesLetsYouCharge": "Membership for academies lets you charge member academies a yearly fee (if you like) for being a part of your federation. You control who gets to participate at your events.",
            "affiliateOrganisers": "Affiliate organisers",
            "growYourBusinessByLettingAffiliate": "Grow your business by letting affiliate organisers run events under your umbrella.",
            "subdomain": "Subdomain",
            "chooseYourNameSmoothcompCom": "Choose yourname.smoothcomp.com which will be the landing page of your federation. You can always direct your personal web adress to point at yourname.smoothcomp.com.",
            "eventListing": "Event listing",
            "onYourSubdomain": "On your subdomain only your federation events will be listed.",
            "eventTemplates": "Event templates",
            "makeACompetitionTemplate": "Make a competition template for your federation to make creating events simple also for affiliate organisers.",
            "everythingInBasicPlus": "Everything in Basic, plus:",
            "individualMembership": "Individual membership",
            "thisFeatureLetsYouAdd": "This feature lets you add another layer of membership for individual users, you can have one fee for the academy and one for the individual if you so choose.",
            "multipleMembershipPlans": "Multiple membership plans",
            "ifYouHaveDifferentLevel": "If you have different level of memberships, for instance “support membership, normal membership and premium membership you can now build those plans within your admin system.",
            "theRankingEngineLetsYou": "The ranking engine lets you set rules for different events, entries and classes so you can customize your own ranking list for your circuit.",
            "cms": "CMS - Content Management System",
            "buildYourFederationPage": "Build your federation page as you want with multiple pages/menus or add a news page.",
            "customMetadata": "Custom Metadata",
            "customMetadataCanBeUseful": "Custom metadata can be useful if you want to record information about previous merits, belts or other achievements. You can also have your members upload documents for you to check before approving them membership",
            "choosePlan": "Choose plan",
            "plan": "Plan",
            "memberNumber": "Member Number",
            "memberSince": "Member Since",
            "quarantine": "Suspension",
            "ranking_lists": "Ranking lists",
            "federation_events": "Federation events",
            "show_active_events": "Show active events",
            "show_archived_events": "Show archived events",
            "export_event_registrations": "Export event registrations",
            "export_events_between_dates": "Export events between dates",
            "give_event_access_to_organizer_portal": "Give event access to Organizer portal",
            "quarantine_period": "Suspension period",
            "quarantine_period_desc": "Allow organizers to put atheletes in suspension and access organizer portal during this period.",
            "remove_as_template": "Remove as template",
            "use_as_template": "Use as template",
            "template": "Template|Templates",
            "approved_federation_event": "Approved federation event",
            "content": "Content",
            "members": "Members",
            "pending_domain": "Your subdomain will be activated in a few days. You can continue to setup and work with the platform until then.",
            "plans": "Plans",
            "status_settings": "Status settings",
            "event_settings": "Event settings",
            "custom_data": "Custom data",
            "replace_logo": "Replace logo",
            "resume_subscription": "Resume subscription",
            "change_plan": "Change plan",
            "delete_all_data": {
                "title": "Delete all data?",
                "text": "Membership data including ranking lists, users, academies and settings will be deleted. Are you sure?",
                "confirm": "Yes, cancel and delete all my data"
            },
            "cancel_subscription": "Cancel subscription",
            "invoices": "Invoices",
            "unavailableFeature": "Please upgrade your federation plan to use this function.",
            "view_plans": "View plans",
            "update_membership_numbers": "Are you sure you want to update the membership numbers? All existing {type} membership numbers will be regenerated according to the number preview below.",
            "membership_prefix": "Membership prefix",
            "membership_start_number": "Membership start number",
            "membership_number_preview": "Membership number preview",
            "upgrade_federation_plan": "Please upgrade your federation plan to get access to inactivated settings.",
            "new_custom_data": "New custom data",
            "users_data": {
                "title": "Users data",
                "description": "What information would you like to ask the users about when they register?"
            },
            "academies_data": {
                "title": "Academies data"
            },
            "personal_number_type": "Personal number type",
            "require_personal_number": "Require personal number",
            "delete_status_reason": {
                "title": "Delete status reason?",
                "confirm": "Delete reason"
            },
            "membership_terms_of_service": "Membership Terms of Service",
            "auto_approve_events": "Auto approve events <small class=\"text-muted\">by disabling this you manually need to handle event sanctions.</small>",
            "allow_organizers_put_athletes_in_suspension": "Allow organizers put athletes in suspension",
            "hide_events_from_sc_event_calendar": "Hide events from smoothcomp event calendar.",
            "athletes_registration": "Athletes registration",
            "athletes_must_be_a_member_of_the_federation_to_register": "Athletes must be a member of the federation to register",
            "must_also_be_approved": "Must also be approved",
            "must_also_have_an_active_payment_plan": "Must also have an active payment plan",
            "athletes_participation": "Athletes participation",
            "require_approved_and_paid_federation_membership": "Require approved and paid federation membership",
            "without_membership_athletes_cant_be_added_to_brackets": "Without membership athletes can't be added to brackets",
            "academies_must_be_a_member_of_the_federation_to_register": "Academies must be a member of the federation to register",
            "for_all_countries": "For all countries",
            "only_for_selected_countries": "Only for selected countries",
            "academy_members_must_also_be_approved_by_the_academy": "Academy members must also be approved by the academy",
            "event_categories": "Event categories",
            "new_category": "New category",
            "seasons": {
                "delete": {
                    "title": "Delete event season?",
                    "confirm": "Delete season"
                },
                "make_current_season": "Make current season",
                "new": "New season"
            },
            "save_menu": "Save menu",
            "federation_academies": "Federation academies",
            "add_academy": "Add academy",
            "plan_status": "Plan status",
            "member_status": "Member status",
            "export": {
                "title": "The export has started. You will receive a notification once it's completed. Depending on the data it might take a couple of minutes",
                "in_progress": "Your export is being processed, it might take a minute."
            },
            "paid_transactions": "Paid transactions",
            "export_members": "Export members",
            "status_note_description": "Please update _______ before we can approve your membership. Thank you.",
            "send_mail_with_status": "Send mail with status to member when saved",
            "plan_expires": "Plan expires",
            "federation_academies_statistics": "Federation academies statistics",
            "website_logo": "Website Logo",
            "scoreboard_logo": "Scoreboard Logo (Square is recommended)",
            "streaming_logo": "Streaming Logo (should be 246x84px or ~3{1} aspect ratio)",
            "custom_fields_status": "Custom data status",
            "academyPlans": "Academy plans",
            "userPlans": "User plans",
            "multiplePrices": "Multiple prices",
            "periodAndPricing": "Period and pricing",
            "period": "Period",
            "ageRules": "Age rules",
            "minAge": "Min age",
            "maxAge": "Max age",
            "ageBy": "By",
            "byCurrentAge": "By their current age right now",
            "byAgeThisYear": "By the age they will turn this year",
            "expiration": "Expiration",
            "expireDayOfPurchase": "Expire on day of purchase",
            "expireFixedDate": "Expire on fixed date",
            "deletePlan": "Delete plan",
            "menuItem": "Menu item",
            "plusAddTranslation": "+ Add translation",
            "deleteMenuItemConfirm": "Delete menu item?",
            "folder": "Folder",
            "eventList": "Event list",
            "planExpired": "Plan expired",
            "manageMembership": "Manage membership",
            "academySignUp": "Academy sign up",
            "noActivePlan": "No active membership plan",
            "noMembership": "No membership",
            "xMembership": "{name} membership",
            "memberNo": "Member no.",
            "yourDataIsShare": "Your user data is shared with the federations below",
            "cancelMembershipAndRemove": "Cancel membership and remove access",
            "cancelMembership": "Cancel membership",
            "createFederation": "Create federation",
            "federationName": "Federation name",
            "selectFederationPlan": "Select federation plan",
            "category": "Category",
            "seasonPlaceholder": "-- Season --",
            "categoryPlaceholder": "-- Category --",
            "noPrimaryFederation": "None (Use smoothcomp)",
            "selectSeasonPlaceholder": "— Select season —",
            "cancelMembershipDeleteData": "Cancel membership (delete my data)",
            "handleUserData": "Handle user data",
            "unknownPlan": "Unknown plan",
            "memberDetailsX": "Member details - {name}",
            "searchForNewAthlete": "Search for a new athlete:",
            "memberNoX": "Member no. {number}",
            "personalNumberFormatMismatch": "Your entry has been saved but it does not match the format for Swedish personal number",
            "invisibleForMember": "(invisible for the member)",
            "expiredFieldsUpdatedStatusPending": "All expired fields have been updated and your membership status has been set to pending"
        },
        "auth": {
            "addANewProfile": "Add a new profile",
            "failed": "Incorrect email/password combination.",
            "noAccountExists": "No account with that email address exists.",
            "selectProfile": "Select profile",
            "forgotYourPassword": "Forgot your password?",
            "noAcccountCreateOne": "No account? Create one here!",
            "alreadyHaveAnAccountLogIn": "Already have an account? Login",
            "emailInUse": "Email in use",
            "loginToAddNewPerson": "<a class=\"clickable alert-link\" @click=\"showCreateAccount = false\">Log in</a> to add a new person to your account",
            "loginToAddNewPersonName": "<a class=\"clickable alert-link\" @click=\"showCreateAccount = false\">Log in</a> to add {name} to your account",
            "lockdownHeader": "Organizers only!",
            "lockdownText": "Your account needs organizer access in order to proceed!",
            "throttle": "Too many login attempts. Please try again in a couple of seconds.",
            "addProfile": "Add profile",
            "linkUpToSeven": "You can link up to 7 accounts (8 in total with counting your own profile).",
            "createANewProfile": "Create a new profile",
            "ifYouAreACoach": "If you are a coach we recommend you add your members through the academy page and handle event registrations from there. This page is only meant for family members.",
            "transferExistingProfile": "Transfer an existing profile",
            "loginWithTransferProfile": "Log in with the user you want to transfer into this account. Use the email and password for the other user.",
            "chooseProfile": "Choose profile to move into this account:",
            "maximumProfiles": "Maximum profiles reached",
            "noSharedAccounts": "You do not have any shared accounts.",
            "specifyNewEmail": "Specify a new email for the selected user.",
            "tellTheUser": "Tell the user to use the link below to create a new password using the selected email above.",
            "noUserExists": "No user exists with that email address",
            "wrongPassword": "Wrong password",
            "confirmationSent": "Confirmation email sent."
        },
        "registration": {
            "cancelRegistration": "Cancel registration",
            "areYouSureYouWantToCancel": "Are you sure you want to cancel all of your registrations to <strong>{title}</strong>?",
            "yourRegistrationsBelowWillBeDeleted": "Your registrations below will be deleted",
            "yesCancelRegistrations": "Yes, cancel my registrations",
            "youAreEntitledTo": "You are entitled to {percent}% refund, you paid {ordersSum} {currency} and {refundSum} {currency} will be refunded",
            "inCouponCode": "in coupon code",
            "incompleteRegistrationsCount": "{count} incomplete registrations",
            "showingIncompleteRegistrationsCount": "Showing {count} incomplete registrations",
            "showCompletedRegistrations": "Show completed registrations",
            "showIncompleteRegistrations": "Show incomplete registrations",
            "showingCompletedAndIncomplete": "Showing completed and incomplete",
            "showCompletedAndIncomplete": "Show completed and incomplete",
            "notApproved": "Not approved",
            "notPaid": "Not paid",
            "resetAllFilters": "Reset all filters",
            "filtersAreApplied": "Filters are applied",
            "filterOnEntry": "Filter on entry",
            "participantsNationality": "Athletes nationality",
            "downloadCsv": "Download csv",
            "downloadEmailList": "Download email list",
            "selectParticipantsToExport": "Select athletes to export",
            "suspension": "Suspension {federation}: {reason} ({expire_date})",
            "no_results": "No results found",
            "filters_applied": "Filters are applied",
            "bracket": "Bracket",
            "birth": "Birth"
        },
        "sctv": {
            "purchase": "Purchase",
            "save_card_and_purchase": "Save card & Purchase",
            "when_balance_below": "When balance goes below",
            "current_balance": "Current balance",
            "bring_balance_up_with": "Bring my balance back up with",
            "refill_order_placed_primary": "Refill order placed",
            "refill_order_placed_secondary": "Your refill order has been placed",
            "refill_order_placed_secondary_with_card": "Your card has been saved and your order has been placed",
            "card_saved_primary": "Card saved",
            "card_saved_secondary": "Your card and settings have been saved",
            "error_saving_card": "Error saving card",
            "please_check_card_details": "Please check your card details and try again",
            "user_access": "User access",
            "add_access": "Add access",
            "no_access_found": "No package accesses found",
            "total_sales": "Total sales",
            "total_sales_tooltip": "Total paid by customers for the livestream access",
            "your_rev_share": "Your revshare",
            "your_rev_share_tooltip": "Your share after platform costs (e.g. storage and bandwidth) (payment provider fees excluded)",
            "your_revenue": "Your revenue",
            "your_revenue_tooltip": "Your earnings based on your share (payment provider fees excluded)",
            "total_refunds": "Total refunds",
            "total_refunds_tooltip": "Total refunded to customers (payment provider fees excluded)",
            "refund_share": "Refund share",
            "refund_share_tooltip": "Your share of refunds, based on your revenue share (payment provider fees excluded)",
            "your_revenue_after_refunds": "Your revenue after refunds",
            "your_revenue_after_refunds_tooltip": "Final earnings after your share of refunds (payment provider fees excluded)",
            "manual_order": "Manual order",
            "refund_order": "Refund order",
            "purchased": "Purchased",
            "added": "Added",
            "refunded": "Refunded",
            "removed": "Removed",
            "remove_access": "Remove access",
            "allow_other_payment_options": "Allow other payment options",
            "add_accesses": "Add accesses",
            "remove_card_confirm": "Do you want to remove this card?",
            "your_total_revenue": "Your share after platform costs (e.g. storage and bandwidth) (payment provider fees excluded) and any potential refunds",
            "wallet_information_card_html_content": "<p>PayPal supports automatic revenue splitting — meaning you get your share right when the customer makes a purchase.</p><p>However, other payment services don´t support this feature on our platform.</p><p>If you´re not using PayPal, you´ll need to add funds to this wallet before PPV sales can happen. We´ll then deduct our share from the wallet instead of splitting it directly during the transaction.</p><p><b style=\"color: var(--text-primary);\">Important:</b> In order to make sales you need to have funds in your wallet. We recommend enabling \"Auto refill\" which takes care of this automatically, allowing your wallet to always have a sufficient balance.</p>",
            "wallet_information_card_title": "This wallet is for non-PayPal purchases",
            "linkNewYoutubeAccount": "Link new YouTube account",
            "linkYoutubeAccount": "Link YouTube Account",
            "addStream": "Add Stream",
            "sctvPackageDescription": "Get your own streaming platform with Smoothcomp TV.",
            "youtubePackageDescription": "Connect your YouTube-channel and let us create the streams for you.",
            "customPackageTitle": "Custom",
            "customPackageDescription": "Manually setup any RTMP(S) or SRT destination.",
            "overlayPackageTitle": "Graphics Only",
            "overlayPackageDescription": "If you already have your stream setup and want to use our overlays such as Tale of the Tapes, Scoreboard and Clock.",
            "ppvBenefit": "PPV (Pay Per View)",
            "cutMatchesBenefit": "Cuts individual matches",
            "multiviewBenefit": "Multiview with filters",
            "noUpfrontFeesBenefit": "No upfront fees",
            "visibilityPpvTitle": "PPV",
            "visibilityPpvDescription": "Anyone who buys access can watch the livestream.",
            "visibilityPublicTitle": "Public",
            "visibilityPublicDescription": "Anyone can watch the livestream.",
            "visibilityUnlistedTitle": "Unlisted",
            "visibilityUnlistedDescription": "Anyone with a link can watch the livestream.",
            "visibilityPrivateTitle": "Private",
            "visibilityPrivateDescription": "Only you can watch the livestream.",
            "standardLatencyOption": "Standard latency without slates (Default)",
            "lowLatencyOption": "Low latency",
            "reconnectWindow30Min": "30 min (Default)",
            "reconnectWindow0Min": "0 min",
            "customRtmp": "Custom RTMP",
            "checkIfAcceptedSctvAgreementError": "Something went wrong while checking acceptance of PPV agreement, please try again.",
            "getSctvAgreementError": "Something went wrong while fetching agreement, please try again later.",
            "acceptAgreementError": "Could not accept agreement, please try again later.",
            "unableToFetchPackages": "Unable to fetch livestream packages",
            "yourTotalRevenue": "Your total revenue",
            "replaysAvailable": "Replays are available for 30 days after livestream",
            "noPackagesToPurchase": "There are no packages to purchase. Please contact the organizer.",
            "paymentMethod": "Payment method: {method}",
            "revokeAccessToStreams": "Revoke access to package streams",
            "refundMethodDirectlyHtml": "Directly <small>(Refund through the used payment method)</small>",
            "refundMethodManualHtml": "Manual <small>(Handle refund manually)</small>",
            "refundOrderVerb": "Refund order",
            "eventRevenueShare": "Event revenue share",
            "getOrganizerSettings": "Get organizer settings",
            "includingStreams": "Including streams",
            "livestreamPackages": "Livestream packages",
            "createPackage": "Create package",
            "connectedStreams": "Connected streams",
            "walletCurrency": "Wallet - {currency}",
            "adjustBalance": "Adjust balance",
            "sctvWallet": "Smoothcomp TV Wallet",
            "minAmountCurrency": "Minimum amount: {amount} {currency}",
            "purchaseFailed": "The purchase failed. Please check your inputs and try again.",
            "adjustmentFailed": "The balance adjustment failed. Please try again.",
            "balanceAdjusted": "Balance adjusted",
            "walletBalanceAdjusted": "Wallet balance has been adjusted",
            "streamOptions": "Stream options",
            "selectPlatform": "Select platform",
            "otherCustomRtmp": "Other (custom RTMP)",
            "enterUrlKey": "Enter URL and key manually",
            "latencyMode": "Latency mode",
            "reconnectWindow": "Reconnect window",
            "visibilityPublicOption": "Public (Everyone can watch)",
            "visibilityPublicFreeOption": "Public (Everyone can watch for free)",
            "visibilityPpvOption": "Pay-per-view",
            "visibilityUnlistedOption": "Unlisted (Anyone with the link can watch)",
            "visibilityPrivateOption": "Private (Only you can watch)",
            "visibilityPrivateSharedOption": "Private (Only you and people you chose can watch)",
            "taleOfTapeSettings": "Tale of the Tape settings",
            "taleOfTapeOverlayHint": "Displayed in the overlay for the Tale of the Tape",
            "athleteNames": "Athletes names",
            "profilePictures": "Profile Pictures",
            "teams": "Teams",
            "scoreboardOverlayHint": "Displayed in the overlay for the scoreboard",
            "matchClock": "Match clock",
            "teamLineup": "Team lineup",
            "withFlag": "(with flag)",
            "advanced": "Advanced",
            "taleOfTapeTimeoutLabel": "Tale of tape timeout (Seconds)",
            "taleOfTapeTimeoutHint": "This determines the maximum number of seconds for which the Tale of the Tape will be displayed. (Default is 30 seconds)",
            "overlayTimeoutLabel": "Overlay timeout (Seconds)",
            "overlayTimeoutHint": "This determines the number of seconds before the overlay is automatically hidden if the scoreboard is inactive. (Default is 120 seconds)",
            "teamMatches": "Team Matches",
            "teamLineupExpandedLabel": "Team match lineup - Expanded mode (Seconds)",
            "teamLineupExpandedHint": "The amount of time in seconds that the team lineup is displayed in a fully expanded mode with profile pictures (only for team matches) (Default is 10 seconds)",
            "teamLineupCompactLabel": "Team match lineup - Compact mode (Seconds)",
            "teamLineupCompactHint": "The amount of time in seconds that the team lineup is displayed in a compact mode without profile pictures (only for team matches) (Default is 10 seconds)",
            "teamLineupHiddenLabel": "Team match lineup - Hidden time (Seconds)",
            "teamLineupHiddenHint": "The amount of time in seconds that the team lineup is hidden before displayed again (in a loop) in expanded and compact modes stated above (only for team matches) (Default is 120 seconds)"
        }
    }
}
